import { Options, Vue } from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
// import BaseFunctions from '@/components/Utility/Base'
import { Tournaments } from '@/services/TournamentsDataService'
import SeasonsDataService from '@/services/SeasonsDataService'
import TeamsDataService from '@/services/TeamsDataService'
import MembersDataService from '@/services/MembersDataService'
import MatchPlannerDataService from '@/services/MatchPlannerDataService'
import SysTournamentRow, { SysTournamentCategoryId, SysTournamentMatchSchedule, SysTournamentRowId, SysTournamentMatchSettlement, SysTournamentMatch, SysTournamentMatchSet, SysTournamentMatch180, tournamentMatchScheduleTeamStatusFriendlyType, SysTournamentRules, SysTournamentRegionId, SysTournamentSaesonId, SysTournamentMatchesTeamRankings, SysTournamentMatchFinalApproval } from '@/types/SysTournament'
import SysMember from '@/types/SysMember'
import SysMatchPlanner from '@/types/SysMatchPlanner'
import SysTeam from '@/types/SysTeam'
import RegionsDataService from '@/services/RegionsDataService'
import SysRegion from '@/types/SysRegion'
import CommonFunctions from '@/components/Utility/Common'
import TournamentCommonFunctions, { teamRankingsArrayType } from '@/components/Utility/tournamentCommon'
import SysSaeson from '@/types/SysSaeson'
import ClubsDataService from '@/services/ClubsDataService'
import { History } from '@/services/HistoryDataService'
import SysClub, { SysClubTeamsId } from '@/types/SysClub'
import MatchHistoryDataService from '@/services/MatchHistoryDataService'
import UsersDataService from '@/services/UsersDataService'
import exportFromJSON from 'export-from-json'
import http from '@/http-common'

/* export default defineComponent({
  name: 'AdminTournaments',
  setup () {
    // component setup
  }
}) */

// BUG: On first load; match schedule is fetched twice. This happens because of the filterSeasonTextValue variable and the watch that have been set on it.

type tournamentRulesDateType = { documentId: string; id: number; categoryValue: { categoryName: string; categoryId: number }; regionValue: { regionName: string; regionId: number}[]; tournamentResult: string; pointsAwarded: number; }
type tournamentRowDataType = { rowName: string; numberOfSets: number; minNumberOfTeams: number; maxNumberOfTeams: number; numberOfTeamsPerClub: number; numberOfPlayers: number; maxNumberOfPlayers: number }
type tournamentCategoryDataType = { categoryName: string; categoryPrice: number }
type tournamentMatchScheduleDataType = { matchNumber: number; matchScheduleDate: string; matchScheduleDateNewDate: string; matchScheduleComment: string; matchScheduleCommentStatus: tournamentMatchScheduleTeamStatusFriendlyType | null; matchHomeTeamId: number; matchHomeTeamName: string; matchHomeTeamResult: number; matchGuestTeamId: number; matchGuestTeamName: string; matchGuestTeamResult: number; matchHomeTeamVerdict: number; matchGuestTeamVerdict: number; matchTournamentRow: { id: number, status: boolean, name: string } }
type tournamentMatchSchedulePlayerInfoDataType = { playerMemberId: number; playerName: string; playerLicense: number; playerSelected: boolean; playerVerdict: number; playerVerdictDirtyFlag: boolean; matchSettlementExtId: number, matchesWon: number; matchSetsWon: number; matchSetsLost: number; match180: number; matchSetHighestClosing: number; matchSetFastestDarting: number, hide: boolean }
type tournamentSeasonDataType = { seasonName: string; seasonStartDate: string; seasonEndDate: string; seasonRegistrationDate: string }
type matchPlannerDataType = { matchPerDay: number; skipMatchPerDayFirstRound: boolean; meetEachTeamTimes: number; matchNumberOfRoundsWithLargestDivisionTeams: boolean; timeBetweenMatches: number, autoIncreaseNumbTimesTeamsMeetsTreshold: number }
type teamsNewDivisionPlacementsDataType = { id: number, origId: number, origPlacement: number, rowIdOfOrigPlacement: number, newPlacement: number, rowIdOfNewPlacement: number, origRowOrdinal: number, newRowOrdinal: number, origRowSubOrdinal: number, newRowSubOrdinal: number }
type dataReturnType = { raekkes: any; turneringskategoris: any; filterStatusStringValue: string; filterStatusStringValue2: string; filterSeasonTextValue: { text: string; value: string }; filterSeasonTextOptions: { text: string; value: string; }[]; matchSettlementHomeTeamPlayersNameValue: any[]; matchSettlementHomeTeamPlayersNameOptions: any[]; matchSettlementGuestTeamPlayersNameValue: any[]; matchSettlementGuestTeamPlayersNameOptions: any[]; tournamentRowSearchInputValue: string; tournamentCategorySearchInputValue: string; tournamentCategoryTitleOptions: any[]; matchSettlementMatchesSetsUpdateIntervalTimer: any; collapseStateValue1: boolean; index: number; totalPages: number; totalPages2: number; error: any; tournamentRuleData: tournamentRulesDateType; tabValue: string; }

@Options({
  props: {
    msg: String
  }
})
export default class AdminTournaments extends Vue {
  msg!: string
  error: any = null
  tabValue = 'Vis og rediger turneringskategorier'
  private firstTimeRetrieveSeasonData = true
  private raekkes: SysTournamentRow[] = []
  private turneringskategoris: SysTournamentCategoryId[] = []
  private kampprograms: SysTournamentMatchSchedule[] = []
  private playersHistories: any = []
  private playersHistoriesData: any = []
  private tempTournamentCategory = {} as SysTournamentCategoryId
  private tempTournamentRow = {} as SysTournamentRowId
  private tempTournamentRows: SysTournamentRow[] = []
  private tempTournamentRowsOfPreviousSeason: SysTournamentRow[] = []
  private tempTournamentMatchSchedule = {} as SysTournamentMatchSchedule
  private tempTournamentMatchSettlement = {} as SysTournamentMatchSettlement
  private tempTournamentMatchSettlementPlayersMemberData: SysMember[] = []
  private tempTournamentMatchPlanResponse: SysMatchPlanner[] = []
  private tempHolds: SysTeam[] = []
  private lastEditedTournamentRowDocumentId = ''
  tournamentRowData: tournamentRowDataType = { rowName: '', numberOfSets: 0, minNumberOfTeams: 0, maxNumberOfTeams: 0, numberOfTeamsPerClub: 0, numberOfPlayers: 0, maxNumberOfPlayers: 0 }
  tournamentCategoryData: tournamentCategoryDataType = { categoryName: '', categoryPrice: 0 }
  tournamentMatchScheduleData: tournamentMatchScheduleDataType = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
  tournamentMatchScheduleHomeTeamPlayersInfoData: tournamentMatchSchedulePlayerInfoDataType[] = []
  tournamentMatchScheduleGuestTeamPlayersInfoData: tournamentMatchSchedulePlayerInfoDataType[] = []
  tournamentSeasonData: tournamentSeasonDataType = { seasonName: '', seasonStartDate: '', seasonEndDate: '', seasonRegistrationDate: '' }
  private matchPlannerData: matchPlannerDataType = { matchPerDay: 2, skipMatchPerDayFirstRound: true, meetEachTeamTimes: 2, matchNumberOfRoundsWithLargestDivisionTeams: true, timeBetweenMatches: 5, autoIncreaseNumbTimesTeamsMeetsTreshold: 0 }
  filterStatusStringValue = 'Vis alt'
  filterStatusStringOptions: string[] = ['Vis alt', 'Aktiv', 'Ikke aktiv']
  filterStatusStringValue2 = 'Vis alt'
  filterStatusStringOptions2: string[] = ['Vis alt', 'Aktiv', 'Ikke aktiv']
  filterPlayerValidationHistoryValue = 'all'
  filterPlayerVaidationHistoryOptions: string[] = ['all', 'Hjem', 'Ude']
  filterSeasonTextValue = { text: 'Vis alt', value: '0' }
  filterSeasonTextOptions: { text: string; value: string }[] = [{ text: 'Vis alt', value: '0' }]
  tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
  newTournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
  newTournamentRowTextValue = { text: 'Vælg her', value: '0' }
  newTournamentRowTextOptions: { text: string, value: string }[] = [{ text: 'Vælg her', value: '0' }]
  newPlacementTextValue = { text: 'Vælg her', value: '0' }
  newPlacementTextOptions: { text: string, value: string }[] = [{ text: 'Vælg her', value: '0' }]
  tournamentSeasonTextOptions: { text: string; value: string; numberOfUsedSlots: string }[] = [{ text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }]
  tournamentCategoryTitleValue = { text: 'Vælg her', value: '0' }
  tournamentCategoryTitleOptions: { text: string; value: string }[] = [{ text: 'Vælg her', value: '0' }]
  tournamentSeasonSeriesTextValue = { text: 'Vælg her', value: '0' }
  tournamentSeasonSeriesTextOptions: { text: string; value: string }[] = [{ text: 'Vælg her', value: '0' }, { text: 'Alle undtagen Junior', value: '1' }, { text: 'Kun Junior - 1. halvår (forår)', value: '2' }, { text: 'Kun Junior - 2. halvår (efterår)', value: '3' }, { text: 'Kun Hovedturnering', value: '4' }, { text: 'Kun Hverdagsrækken', value: '5' }, { text: 'Kun Oldboys 35+', value: '6' }, { text: 'Kun Oldboys 35+ Vest', value: '7' }, { text: 'Kun Oldboys 50+', value: '8' }, { text: 'Kun Damepairs', value: '9' }, { text: 'Kun Bornholms Rækken', value: '10' }]
  tournamentSeasonMatchPlanTeamsTextValue = [{ tournamentRow: { id: 0, name: '' }, matches: [{ date: '', homeTeam: { text: 'Vælg her', value: '0' }, guestTeam: { text: 'Vælg her', value: '0' } }] }]
  tournamentSeasonMatchPlanTeamsTextOptions: { text: string; value: string }[] = [{ text: 'Vælg her', value: '0' }]
  tournamentMatchScheduleSelectedSlotTextValue = { text: 'Automatisk', value: '-1' }
  tournamentMatchScheduleSelectedSlotTextOptions: { text: string; value: string }[] = [{ text: 'Automatisk', value: '-1' }]
  homeTeamNameValue = { text: 'Vælg her', value: '0' }
  homeTeamNameOptions: { text: string; value: string }[] = [{ text: 'Vælg her', value: '0' }]
  guestTeamNameValue = { text: 'Vælg her', value: '0' }
  guestTeamNameOptions: { text: string; value: string }[] = [{ text: 'Vælg her', value: '0' }]
  matchSettlementHomeTeamPlayersNameValue: { name: string; value: string; gender: string; birthdaydate: string; isparadart: boolean; clubid: number; teamid: number }[] = []
  matchSettlementHomeTeamPlayersNameOptions: { key: number; name: string; value: string; gender: string; birthdaydate: string; isparadart: boolean; clubid: number; teamid: number }[] = []
  matchSettlementGuestTeamPlayersNameValue: { name: string; value: string; gender: string; birthdaydate: string; isparadart: boolean; clubid: number; teamid: number }[] = []
  matchSettlementGuestTeamPlayersNameOptions: { key: number; name: string; value: string; gender: string; birthdaydate: string; isparadart: boolean; clubid: number; teamid: number }[] = []
  tournamentRowsNameValue = { text: 'Vælg her', value: '0' }
  tournamentRowsNameOptions: { text: string; value: string }[] = [{ text: 'Vælg her', value: '0' }]
  tournamentMatchSettlementTeamProtestStatusValue = 'Ingen'
  tournamentRowSearchInputValue = ''
  tournamentRowSearchTerm = ''
  tournamentCategorySearchInputValue = ''
  tournamentCategorySearchTerm = ''
  tournamentMatchScheduleSearchInputValue = ''
  tournamentMatchScheduleSearchTerm = ''
  toggleIconsSortingValue = 0
  toggleIconsSortingValue2 = 0
  toggleIconsSortingValue3 = 0
  // private oldSort = ''
  // private oldSort2 = ''
  private oldCategorySort = ''
  private oldRowSort = ''
  private oldMatchSort = ''
  private oldRuleSort = ''
  private submitted = false
  private submitted2 = false
  private submitted3 = false
  // private currentListSortingOrder = ''
  // private currentListSortingOrder2 = ''
  // private currentListSortingOrder3 = ''
  private currentCategorySort = ''
  private currentRowSort = ''
  private currentMatchSort = 'kampprogram_dato:asc,kampprogram_kampnr:asc'
  private currentRulesSort = 'sort[0]=turneringskategori_id.turneringskategori_navn:asc&sort[1]=turneringsregler_resultat:asc'
  private editTournamentRowModal = false
  private editTournamentCategoryModal = false
  private editTournamentMatchScheduleModal = false
  private editCreateTournamentSeasonModal = false
  private editCreateTournamentSeasonMatchPlanModal = false
  private editTournamentMatchSettlementModal = false
  private editTournamentMatchSettlementTeamPlayersModal = false
  private editTournamentMatchSettlementTeamProtestStatusModal = false
  private createTournamentSeasonMatchPlanEditModal = false
  private editTournamentRoundToBeCreatedModal = false
  private editFinalizeTournamentSeasonModal = false
  private editCreateNewTournamentSeasonModal = false
  private editSuggestedTournamentSeasonTeamPlacementsModal = false
  private editOneTournamentSeasonTeamPlacementModal = false
  private tournamentMatchResultsCalcProgress = 0
  private lastEditedTournamentRowId = 0
  private lastEditedTournamentCategoryId = 0
  private lastEditedTournamentCategoryDocumentId = ''
  private lastEditedTournamentMatchScheduleId = 0
  private lastEditedTeamInTournamentSeasonTeamPlacement = 0
  private lastCreatedTournamentRowId = 0
  private lastCreatedTournamentCategoryId = 0
  private lastCreatedTournamentMatchScheduleId = 0
  private lastCreatedTournamentSeasonId = 0
  private lastCreatedTournamentMatchId = 0
  private lastCreatedTournamentMatchSetId = 0
  private lastCreatedTournamentMatchSettlementId = 0
  private lastCreatedTournamentMatchSettlementExtId = 0
  private lastCreatedTournamentRoundsId = 0
  private tournamentMatchPlanTotalNumberOfMatches = 0
  private tournamentMatchPlanNumberOfMatchesSavedProgressValue = 0
  private currentMatchesTeamRankingsSavedProgressValue = 0
  private tempTournamentMatchSettlementTeamIds: number[] = []
  private matchSettlementNumberOfPresentMatchesCreated = 0
  private matchSettlementNumberOfPresentMatchesSetsCreated = 0
  private teamInputFieldClickCount = 0
  private matchSettlementNumberOfMatches = 16
  private matchSettlementNumberOfSetsPerMatch = 3
  private matchSettlementPlayerMatchOrder: { playerIndexHomeTeam: number; playerIndexGuestTeam: number; playerIndex2HomeTeam: number; playerIndex2GuestTeam: number; isDouble: boolean; resultRecorderHome: number | null; resultRecorderGuest: number | null }[] = []
  private matchSettlementPlayerMatchSetResults: { matchId: number; matchIndexNumber: number; matchSetDart: number; matchSetClosed: number; matchSetRemainScore: number; matchSet: number; matchHomeOrGuestTeam: boolean; matchSetDirtyFlag: number }[] = []
  private matchSettlementNumberOfTeamPlayers = 4
  private matchSettlementNumberOfTeamPlayersMaxSelections = 4
  private matchSettlementTeamPlayersExtDataUpdateStarted = false
  private matchSettlementTeamPlayersExtDataUpdateProgress = 0
  private matchSettlementTeamPlayersExtDataUpdateProgressWatermark = 0
  private matchSettlementTeamPlayersExtDataUpdateIds: number[] = []
  private editTournamentRoundToBeCreatedDateValue = new Date()
  private editTournamentRoundToBeCreatedDateView = { type: 'month', year: (new Date()).getFullYear() }
  private editTournamentRoundToBeCreatedNumberOfMatchesValue = 1
  private totalResultHome = 0
  private totalResultGuest = 0
  private isOldBoysFlag = false
  private matchSettlementMatchesSetsUpdateIntervalTimer = 0
  private actionModeOfSaveTournamentSeasonMatchPlanButton = false
  private cancelSaveTournamentSeasonMatchPlanButtonTriggered = false
  private currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex = 1
  private currentMatchNumber = 1
  private selectedMatchScheduleSlotToBeUsed = -1 // Value -1 = Automatisk, value 0 is reserved for saves of non-bulk generated match schedules.
  private indexOfEditedTournamentRoundToBeCreated = 0
  private tournamentRoundsToBeCreated = [{ tagNotClosed: true, date: '', time: '', numberOfMatches: 0 }]
  private collapseStateValue1 = true
  private matchScheduleDateLockFlag = true
  private matchAutoUpdateMode = false
  private matchFinalApproval: { new: boolean, orig: boolean } = { new: false, orig: false }
  private currentPage = 1
  private currentPage2 = 1
  private currentPage3 = 1
  private currentHistoryPage = 1
  private totalPages = 0
  private totalPages2 = 0
  private totalPages3 = 0
  private totalHistoryPages = 0
  private totalNumberOfPages = 0
  private totalNumberOfPages2 = 0
  private totalNumberOfPages3 = 0
  private totalNumberOfHistoryPages = 0
  private index = 0
  pageSizeValue = 25
  pageSizeValue2 = 25
  pageSizeValue3 = 25
  historyPageSizeValue = 25
  pageSizeValueString = '25'
  pageSizeValueString2 = '25'
  pageSizeValueString3 = '25'
  historyPageSizeValueString = '25'
  pageSizeOptions : string[] = ['10', '25', '100']
  pageSizeOptions2 : string[] = ['10', '25', '100']
  pageSizeOptions3 : string[] = ['10', '25', '100']
  historyPageSizeOption : string[] = ['10', '25', '100']
  // Tournament Rules Global Variables
  private rules: SysTournamentRules[] = []
  private rulesCategoryFilterValue = { id: 0, value: 'Vis alt' }
  private rulesCategoryFilterOptions: { id: number, value: string }[] = []
  private extraRulesParameter = ''
  private rulesModal = false
  private editingExistingRule = false
  private tournamentRuleData: tournamentRulesDateType = { documentId: '', id: 0, categoryValue: { categoryId: 0, categoryName: 'Vælg her' }, regionValue: [], tournamentResult: '', pointsAwarded: 0 }
  private categoryOptions: { categoryId: number, categoryName: string }[] = []
  private regionOptions: { regionName: string, regionId: number}[] = []
  private rulesDeleteWarningModal = false
  private currentDeletingRuleId = 0
  private currentDeletingRuleDocumentId = ''
  private rulesWarningModal = false
  private checkedRuleFlag = false
  private rowColumnName: string[] = ['name', 'category', 'region', 'minTeams', 'maxTeams', 'sets']
  private matchColumnName: string[] = ['matchNo', 'season', 'row', 'homeTeam', 'awayTeam', 'date', 'result', 'match']
  private newCategory = false
  private matchResults: SysTournamentMatchSettlement[] = []
  private createNewMatchModal = false
  // Teams.
  teamSeasonFilterValue = { text: 'Vis alt', value: 0 }
  teamSeasonFilterOptions: { text: string, value: number }[] = []
  teamFilterValue = { text: 'Vis alt', value: 0 }
  teamFilterOptions: { text: string, value: number }[] = []
  tournamentCategoryFilterValue = { text: 'Vis alt', value: 0 }
  tournamentCategoryFilterOptions: { text: string, value: number }[] = [{ text: 'Vis alt', value: 0 }]
  teams: SysTeam[] = []
  private teamFirstTimeRetrieve = true
  private totalCancelTeamArr: number[] = []
  tournamentRowFilterValue = { text: 'Vis alt', value: 0 }
  tournamentRowFilterOptions: { text: string, value: number }[] = []
  private teamsNewDivisionPlacements: teamsNewDivisionPlacementsDataType[] = []
  private teamSeasons: SysSaeson[] = []
  private teamTournamentCategory: SysTournamentCategoryId[] = []
  private currentTeamPage = 1
  private totalTeamPages = 0
  private teamPageSizeValue = 25
  teamPageSizeValueString = '25'
  teamPageSizeOptions: string[] = ['10', '25', '100']
  totalNumberOfTeamPages = 0
  private currentTeamSort = 'hold_holdnavn:asc'
  private oldTeamSort = ''
  private advancedTournamentTeamsNewSeasonDivisionPlacementsModeFlag = false
  teamData = {} as SysTeam
  teamMatchSchedule: SysTournamentMatchSchedule[] = []
  teamMatchSettlement: SysTournamentMatchSettlement[] = []
  teamDataModal = false
  teamWithdrawWarningModal = false
  teamWithDrawId = 0
  numberCancellations = 0
  numberNonAppearance = 0
  numberOfTeamRankingsArrayItemsSaved = 0
  disableStartButtonWhenSavingCurrentMatchesTeamRankings = false
  numberOfTeamsInPreviousSeason = 0
  teamToBeChangedTournamentSeasonTeamPlacement = { text: 'Ingen hold valgt', value: 0 }
  origRowIdOfTeamPlacement = 0
  lastInitialNewPlacementValue = 0
  rowMaxOrdinalValuesLoopIndex = 0
  // playerValidationHistorySearchString = ''
  // playerValidationHistorySearchInputValue = ''
  errorMessages = {
    1: 'er muligvis en ulovlig spiller, da sidste kamp var i en højere række',
    2: 'er muligvis ulovlig, da vedkommende er under 18, og klubben ikke deltager i juniorrækken',
    3: 'er muligvis ulovlig, da vedkommende er under klubskifte karantæne',
    4: 'er muligvis ulovlig, da det er en af de sidste otte kampe, og vedkommende har spillet mere end 14 kampe på højere rangerende hold',
    5: 'er muligvis ulovlig, da det er første kamprunde, og vedkommende har allerede spillet en kamp i denne turnering'
  }

  private lastPlayedMatchModel = false
  private selectedPlayersLastMatchData = null
  private nextPlannedMatch = null
  private lastPlayedMatch = null
  private matchHistoryData = null
  private selectedPlayersMatchRaekke = null
  private playerHistoryComment = ''
  private confirmationModal = false
  filterPlayerValidationHistoryBasedOnStatus = 'all'
  filterPlayerVaidationHistoryStatusOptions: string[] = ['all', 'Waiting', 'Open', 'Closed']
  isStatusClosed = false
  private currentPlayerMatchHistorySort = 'createdAt:desc'
  private isSortingAscending = false
  private teamCaptain = { awayTeamCaptain: null, homeTeamCaptain: null }
  isLoading = false

  readonly name : string = 'AdminTournaments'
  $Message: any
  $Notification: any
  data (): dataReturnType {
    return {
      raekkes: this.raekkes,
      turneringskategoris: this.turneringskategoris,
      filterStatusStringValue: this.filterStatusStringValue,
      filterStatusStringValue2: this.filterStatusStringValue2,
      tournamentRowSearchInputValue: this.tournamentRowSearchInputValue,
      tournamentCategorySearchInputValue: this.tournamentCategorySearchInputValue,
      tournamentCategoryTitleOptions: this.tournamentCategoryTitleOptions,
      filterSeasonTextValue: this.filterSeasonTextValue,
      filterSeasonTextOptions: this.filterSeasonTextOptions,
      matchSettlementHomeTeamPlayersNameValue: this.matchSettlementHomeTeamPlayersNameValue,
      matchSettlementHomeTeamPlayersNameOptions: this.matchSettlementHomeTeamPlayersNameOptions,
      matchSettlementGuestTeamPlayersNameValue: this.matchSettlementGuestTeamPlayersNameValue,
      matchSettlementGuestTeamPlayersNameOptions: this.matchSettlementGuestTeamPlayersNameOptions,
      matchSettlementMatchesSetsUpdateIntervalTimer: this.matchSettlementMatchesSetsUpdateIntervalTimer,
      collapseStateValue1: this.collapseStateValue1,
      index: this.index,
      error: this.error,
      totalPages: this.totalPages,
      totalPages2: this.totalPages2,
      tournamentRuleData: this.tournamentRuleData,
      tabValue: 'Vis og rediger turneringskategorier'
    }
  }

  @Watch('createNewMatchModal')
  onNewMatchModalChange (toggleValue: boolean) : void {
    if (!toggleValue) {
      this.homeTeamNameValue = { text: 'Vælg her', value: '0' }
      this.guestTeamNameValue = { text: 'Vælg her', value: '0' }
      this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
      this.tournamentRowsNameValue = { text: 'Vælg her', value: '0' }
      this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
      this.retrieveTournamentMatchSchedule()
    }
  }

  @Watch('editTournamentCategoryModal')
  onEditCategoryModalChange (toggleValue: boolean) : void {
    if (!toggleValue) {
      this.tournamentCategoryData = { categoryName: '', categoryPrice: 0 }
      this.newCategory = false
    }
  }

  @Watch('tournamentSeasonTextValue')
  onTournamentSeasonTextValueChange (objValue: any) : void {
    // console.log('[onTournamentSeasonTextValueChange] DONE.')
    this.tournamentMatchScheduleSelectedSlotTextOptions = [{ text: 'Automatisk', value: '-1' }]

    for (let slotCount = Number(this.tournamentSeasonTextValue.numberOfUsedSlots); slotCount >= 1; slotCount--) {
      this.tournamentMatchScheduleSelectedSlotTextOptions.push({ text: 'Slot ' + slotCount.toString(), value: slotCount.toString() })
    }

    if (this.editCreateTournamentSeasonMatchPlanModal) {
      this.tournamentMatchScheduleSelectedSlotTextValue = { text: 'Automatisk', value: '-1' }
    }

    // console.log('[onTournamentSeasonTextValueChange] tournamentMatchScheduleSelectedSlotTextOptions = ' + JSON.stringify(this.tournamentMatchScheduleSelectedSlotTextOptions))
  }

  @Watch('matchSettlementNumberOfPresentMatchesSetsCreated')
  onTournamentMatchSettlementNumberOfPresentMatchesSetsCreatedAutoUpdateSetupDestroyChanged (progressValue: number, oldProgressValue: number) : void {
    console.log('[onTournamentMatchSettlementNumberOfPresentMatchesSetsCreatedAutoUpdateSetupDestroyChanged] Match settlement match set automatic update interval setup / destroy: ' + progressValue)

    // Setup interval timer for the purpose of automatically updating changed match set data of the currently edited match settlement via the relevant API access.
    if (this.matchSettlementNumberOfPresentMatchesCreated === this.matchSettlementNumberOfMatches && progressValue === this.matchSettlementNumberOfSetsPerMatch * this.matchSettlementNumberOfMatches) {
      // console.log('[onTournamentMatchSettlementNumberOfPresentMatchesSetsCreatedAutoUpdateSetupDestroyChanged] Setup interval timer.')

      // this.matchSettlementMatchesSetsUpdateIntervalTimer = setInterval(() => { this.updateTournamentSettlementMatchSetTables() }, 30000)
    } else if (progressValue === 0 && oldProgressValue > 0) {
      console.log('[onTournamentMatchSettlementNumberOfPresentMatchesSetsCreatedAutoUpdateSetupDestroyChanged] Destroy interval timer.')

      clearInterval(this.matchSettlementMatchesSetsUpdateIntervalTimer)
    }
  }

  @Watch('matchSettlementTeamPlayersExtDataUpdateProgress')
  onTournamentMatchSettlementTeamPlayersExtDataUpdateProgressChanged (progressValue: string, oldProgressValue: string) : void {
    console.log('[onTournamentMatchSettlementTeamPlayersExtDataUpdateProgressChanged] Match settlement team players extra data update progress changed to: ' + progressValue)

    if (this.matchSettlementTeamPlayersExtDataUpdateStarted) {
      console.log('[onTournamentMatchSettlementTeamPlayersExtDataUpdateProgressChanged] matchSettlementTeamPlayersExtDataUpdateIds = ' + JSON.stringify(this.matchSettlementTeamPlayersExtDataUpdateIds))

      if (this.matchSettlementTeamPlayersExtDataUpdateProgress >= this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark) {
        this.matchSettlementTeamPlayersExtDataUpdateStarted = false

        const updateTournamentMatchSettlement = {
          kampafvikling_ekstras_id: this.matchSettlementTeamPlayersExtDataUpdateIds
        }

        if (this.tempTournamentMatchSettlement.id !== null && Number(this.tempTournamentMatchSettlement.id) >= 1) {
          console.log('[onTournamentMatchSettlementTeamPlayersExtDataUpdateProgressChanged] Updating match settlement extra data.')
          this.editTournamentMatchSettlementTeamPlayersModal = false

          Tournaments.TournamentMatchSettlementDataService.update(Number(this.tempTournamentMatchSettlement.id).toString(), updateTournamentMatchSettlement)
            .then((response) => {
              // this.lastUpdatedTournamentMatchSettlementId = response.data.id
              console.log(response.data)
            })
            .catch((err) => {
              this.error = err
              // console.log(err)
            })
        }
      }
    }
  }

  @Watch('tournamentMatchResultsCalcProgress')
  onTournamentMatchResultsCalcProgressChanged (progressValue: number, oldProgressValue: number) : void {
    console.log('[onTournamentMatchResultsCalcProgressChanged] Tournament match results calculations progress changed to: ' + progressValue)

    if (progressValue >= this.matchSettlementNumberOfMatches) {
      this.tournamentMatchResultsCalcProgress = 0
      this.tournamentMatchScheduleData.matchHomeTeamResult = this.totalResultHome
      this.tournamentMatchScheduleData.matchGuestTeamResult = this.totalResultGuest

      this.checkMatchScheduleTeamStatusAndModifyTotalResultScoreAccordingly()

      const updateTournamentMatchSettlement = {
        kampafvikling_resultat_hjem: this.tournamentMatchScheduleData.matchHomeTeamResult,
        kampafvikling_resultat_ude: this.tournamentMatchScheduleData.matchGuestTeamResult,
        kampafvikling_dom_mod_hjhold: (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 0.5 ? null : (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1)),
        kampafvikling_dom_mod_udhold: (this.tournamentMatchScheduleData.matchGuestTeamVerdict === 0.5 ? null : (this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1))
      }

      // Update the total score result and the verdict information via API access for each team of this match settlement.
      Tournaments.TournamentMatchSettlementDataService.update(Number(this.tempTournamentMatchSettlement.id).toString(), updateTournamentMatchSettlement)
        .then((response) => {
          // this.lastUpdatedTournamentMatchSettlementId = response.data.id
          console.log(response.data)

          // Update also the verdict information via API access for the individual players of this match settlement.
          for (const tournamentMatchScheduleHomeTeamPlayerInfoData of this.tournamentMatchScheduleHomeTeamPlayersInfoData) {
            if (Number(tournamentMatchScheduleHomeTeamPlayerInfoData.matchSettlementExtId) > 0 && tournamentMatchScheduleHomeTeamPlayerInfoData.playerVerdictDirtyFlag) {
              const updateTournamentMatchSettlementExt = {
                kampafvikling_dom_mod_hjspiller: (tournamentMatchScheduleHomeTeamPlayerInfoData.playerVerdict === 0.5 ? null : (tournamentMatchScheduleHomeTeamPlayerInfoData.playerVerdict === 1))
              }

              tournamentMatchScheduleHomeTeamPlayerInfoData.playerVerdictDirtyFlag = false

              Tournaments.TournamentMatchSettlementExtDataService.update(Number(tournamentMatchScheduleHomeTeamPlayerInfoData.matchSettlementExtId).toString(), updateTournamentMatchSettlementExt)
                .then((response) => {
                  // this.lastUpdatedTournamentMatchSettlementExtId = response.data.id
                  console.log(response.data)
                })
                .catch((err) => {
                  this.error = err
                  // console.log(err)
                })
                // .finally(() => {
                // })
            }
          }
          for (const tournamentMatchScheduleGuestTeamPlayerInfoData of this.tournamentMatchScheduleGuestTeamPlayersInfoData) {
            if (Number(tournamentMatchScheduleGuestTeamPlayerInfoData.matchSettlementExtId) > 0 && tournamentMatchScheduleGuestTeamPlayerInfoData.playerVerdictDirtyFlag) {
              const updateTournamentMatchSettlementExt = {
                kampafvikling_dom_mod_udspiller: (tournamentMatchScheduleGuestTeamPlayerInfoData.playerVerdict === 0.5 ? null : (tournamentMatchScheduleGuestTeamPlayerInfoData.playerVerdict === 1))
              }

              tournamentMatchScheduleGuestTeamPlayerInfoData.playerVerdictDirtyFlag = false

              Tournaments.TournamentMatchSettlementExtDataService.update(Number(tournamentMatchScheduleGuestTeamPlayerInfoData.matchSettlementExtId).toString(), updateTournamentMatchSettlementExt)
                .then((response) => {
                  // this.lastUpdatedTournamentMatchSettlementExtId = response.data.id
                  console.log(response.data)
                })
                .catch((err) => {
                  this.error = err
                  // console.log(err)
                })
                // .finally(() => {
                // })
            }
          }
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })
    }
  }

  public async exportDataToExcel () {
    this.isLoading = true
    const fileName = 'Hold Oversigt'
    const exportType = exportFromJSON.types.xls
    const teamParameters = `saeson_id.id=${this.teamSeasonFilterValue.value}&klubber_id.klubber_status=true` + (this.teamFilterValue.value === 0 ? '' : `&klubber_id.id=${this.teamFilterValue.value}`) + (this.tournamentCategoryFilterValue.value === 0 ? '' : `&raekke_id.turneringskategori_id=${this.tournamentCategoryFilterValue.value}`) + (this.tournamentRowFilterValue.value === 0 ? '' : `&raekke_id.id=${this.tournamentRowFilterValue.value}`)
    let response: any[] = []
    await TeamsDataService.getAll('', null, teamParameters)
      .then((res) => {
        response = [...res.data]
        this.isLoading = false
      }).catch((err) => {
        this.isLoading = false
        console.error(err)
      })
    const data: any[] = response.map(item => {
      return {
        klubber_klubnavn: item.klubber_id.klubber_klubnavn,
        klubber_email: item.klubber_id.klubber_email
      }
    })
    const uniqueData : any[] = data.filter((value, index, self) =>
      index === self.findIndex((t) => (
        t.klubber_klubnavn === value.klubber_klubnavn && t.klubber_email === value.klubber_email
      ))
    )
    exportFromJSON({ data: uniqueData, fileName, exportType })
  }

  public checkMatchScheduleTeamStatusAndModifyTotalResultScoreAccordingly (): boolean {
    let retVal = false
    let maxScoreValue = this.matchSettlementNumberOfMatches

    // Handle max score value in the case of Junior match rows.
    if (this.tournamentMatchScheduleData.matchTournamentRow.name !== undefined && this.tournamentMatchScheduleData.matchTournamentRow.name !== null && this.tournamentMatchScheduleData.matchTournamentRow.name.toLowerCase().includes('junior')) {
      maxScoreValue = (this.matchSettlementNumberOfSetsPerMatch === null || this.matchSettlementNumberOfSetsPerMatch === 0 ? 1 : this.matchSettlementNumberOfSetsPerMatch)
    }

    if (this.tournamentMatchScheduleData.matchScheduleCommentStatus !== null && Number(this.matchSettlementNumberOfMatches) > 0) {
      if (this.tournamentMatchScheduleData.matchScheduleCommentStatus === tournamentMatchScheduleTeamStatusFriendlyType.Afbudhjem) {
        this.tournamentMatchScheduleData.matchHomeTeamResult = 0
        this.tournamentMatchScheduleData.matchGuestTeamResult = maxScoreValue
        retVal = true
      } else if (this.tournamentMatchScheduleData.matchScheduleCommentStatus === tournamentMatchScheduleTeamStatusFriendlyType.Afbudud) {
        this.tournamentMatchScheduleData.matchHomeTeamResult = maxScoreValue
        this.tournamentMatchScheduleData.matchGuestTeamResult = 0
        retVal = true
      } else if (this.tournamentMatchScheduleData.matchScheduleCommentStatus === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelsehjem) {
        this.tournamentMatchScheduleData.matchHomeTeamResult = 0
        this.tournamentMatchScheduleData.matchGuestTeamResult = maxScoreValue
        retVal = true
      } else if (this.tournamentMatchScheduleData.matchScheduleCommentStatus === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelseud) {
        this.tournamentMatchScheduleData.matchHomeTeamResult = maxScoreValue
        this.tournamentMatchScheduleData.matchGuestTeamResult = 0
        retVal = true
      } else if (this.tournamentMatchScheduleData.matchScheduleCommentStatus === tournamentMatchScheduleTeamStatusFriendlyType.Protesthjem) {
        if (this.tournamentMatchScheduleData.matchHomeTeamVerdict < 1 && this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1) {
          this.tournamentMatchScheduleData.matchHomeTeamResult = maxScoreValue
          this.tournamentMatchScheduleData.matchGuestTeamResult = 0
          retVal = true
        } else if (this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1) {
          this.tournamentMatchScheduleData.matchHomeTeamResult = 0
          this.tournamentMatchScheduleData.matchGuestTeamResult = 0
          retVal = true
        }
      } else if (this.tournamentMatchScheduleData.matchScheduleCommentStatus === tournamentMatchScheduleTeamStatusFriendlyType.Protestud) {
        if (this.tournamentMatchScheduleData.matchGuestTeamVerdict < 1 && this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1) {
          this.tournamentMatchScheduleData.matchHomeTeamResult = 0
          this.tournamentMatchScheduleData.matchGuestTeamResult = maxScoreValue
          retVal = true
        } else if (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1) {
          this.tournamentMatchScheduleData.matchHomeTeamResult = 0
          this.tournamentMatchScheduleData.matchGuestTeamResult = 0
          retVal = true
        }
      } else {
        if (this.tournamentMatchScheduleData.matchGuestTeamVerdict < 1 && this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1) {
          this.tournamentMatchScheduleData.matchHomeTeamResult = 0
          this.tournamentMatchScheduleData.matchGuestTeamResult = maxScoreValue
          retVal = true
        } else if (this.tournamentMatchScheduleData.matchHomeTeamVerdict < 1 && this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1) {
          this.tournamentMatchScheduleData.matchHomeTeamResult = maxScoreValue
          this.tournamentMatchScheduleData.matchGuestTeamResult = 0
          retVal = true
        } else if (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1 && this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1) {
          this.tournamentMatchScheduleData.matchHomeTeamResult = 0
          this.tournamentMatchScheduleData.matchGuestTeamResult = 0
          retVal = true
        }
      }
    } else if (Number(maxScoreValue) > 0) {
      if (this.tournamentMatchScheduleData.matchGuestTeamVerdict < 1 && this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1) {
        this.tournamentMatchScheduleData.matchHomeTeamResult = 0
        this.tournamentMatchScheduleData.matchGuestTeamResult = maxScoreValue
        retVal = true
      } else if (this.tournamentMatchScheduleData.matchHomeTeamVerdict < 1 && this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1) {
        this.tournamentMatchScheduleData.matchHomeTeamResult = maxScoreValue
        this.tournamentMatchScheduleData.matchGuestTeamResult = 0
        retVal = true
      } else if (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1 && this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1) {
        this.tournamentMatchScheduleData.matchHomeTeamResult = 0
        this.tournamentMatchScheduleData.matchGuestTeamResult = 0
        retVal = true
      }
    }

    return retVal
  }

  public setMatchTeamPlayerVerdictDirtyFlag (playerMemberId: number, homeTeamFlag = true) : void {
    console.log('[setMatchTeamPlayerVerdictDirtyFlag] Set dirty flag for match team player verdict data field.')

    if (homeTeamFlag) {
      for (let arrIndex1 = 0; arrIndex1 < this.tournamentMatchScheduleHomeTeamPlayersInfoData.length; arrIndex1++) {
        if (this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].hide === false && this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].playerMemberId === playerMemberId) {
          this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].playerVerdictDirtyFlag = true
        }
      }
    } else {
      for (let arrIndex1 = 0; arrIndex1 < this.tournamentMatchScheduleGuestTeamPlayersInfoData.length; arrIndex1++) {
        if (this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].hide === false && this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].playerMemberId === playerMemberId) {
          this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].playerVerdictDirtyFlag = true
        }
      }
    }
  }

  @Watch('matchAutoUpdateMode')
  onMatchAutoUpdateModeChange (newVal: any) : void {
    if (newVal) {
      clearInterval(this.matchSettlementMatchesSetsUpdateIntervalTimer)
      this.matchSettlementMatchesSetsUpdateIntervalTimer = setInterval(() => { this.updateTournamentSettlementMatchSetTables() }, 30000)
    } else if (!newVal) {
      this.matchSettlementMatchesSetsUpdateIntervalTimer = setInterval(() => { this.updateTournamentSettlementMatchSetTables() }, 30000)
    }
  }

  @Watch('pageSizeValueString')
  onPageSizeValueChange (newVal: any) : void {
    this.pageSizeValue = Number(newVal)
    this.currentPage = 1
    this.retrieveTournamentCategories()
  }

  @Watch('historyPageSizeValueString')
  onHistoryPageSizeValueChange (newVal: any) : void {
    this.historyPageSizeValue = Number(newVal)
    this.currentHistoryPage = 1
    this.retrievePlayersValidationHistory()
  }

  @Watch('pageSizeValueString2')
  onPageSizeValueChange2 (newVal: any) : void {
    this.pageSizeValue2 = Number(newVal)
    this.currentPage2 = 1
    this.retrieveTournamentRows()
  }

  @Watch('pageSizeValueString3')
  onPageSizeValueChange3 (newVal: any) : void {
    this.pageSizeValue3 = Number(newVal)
    this.currentPage3 = 1
    this.retrieveTournamentRows()
  }

  @Watch('filterStatusStringValue')
  onTournamentCategoriesStatusChanged (statusValue: string, oldStatusValue: string) : void {
    console.log('Filter status changed to: ' + statusValue)
    this.retrieveTournamentCategories()
  }

  @Watch('filterStatusStringValue2')
  onTournamentRowsStatusChanged (statusValue: string, oldStatusValue: string) : void {
    console.log('Filter status changed to: ' + statusValue)
    this.retrieveTournamentRows()
  }

  // @Watch('filterPlayerValidationHistoryValue')
  // onPlayerTeamTypeChanged () : void {
  //   console.log('filterPlayerValidationHistoryValue', this.filterPlayerValidationHistoryValue)
  //   this.retrievePlayersValidationHistory()
  // }

  @Watch('filterSeasonTextValue')
  onTournamentSeasonFilterChanged (selectValue: { text: string; value: string }, oldSelectValue: { text: string; value: string }) : void {
    if (!this.firstTimeRetrieveSeasonData) {
      console.log('Filter select changed to: ' + selectValue.text)
      this.retrieveTournamentMatchSchedule()
    }
  }

  // @Watch('toggleIconsSortingValue')
  // onListSort1ToggleChanged (toggleValue: string, oldToggleValue: string) {
  //   console.log('List sort toggle changed to: ' + toggleValue)
  //   if (toggleValue === 'check_box_outline_blank') {
  //     this.currentListSortingOrder = ''
  //   } else if (toggleValue === 'kategorinavn') {
  //     this.currentListSortingOrder = 'turneringskategori_navn:asc'
  //   } else if (toggleValue === 'pris') {
  //     this.currentListSortingOrder = 'turneringskategori_pris:asc'
  //   }

  //   this.retrieveTournamentCategories()
  // }

  // @Watch('toggleIconsSortingValue2')
  // onListSort2ToggleChanged (toggleValue: string, oldToggleValue: string) {
  //   console.log('List sort toggle changed to: ' + toggleValue)
  //   if (toggleValue === 'check_box_outline_blank') {
  //     this.currentListSortingOrder2 = ''
  //   } else if (toggleValue === 'raekkenavn') {
  //     this.currentListSortingOrder2 = 'raekke_navn:asc'
  //   } else if (toggleValue === 'turneringskategori') {
  //     this.currentListSortingOrder2 = 'turneringskategori_id.turneringskategori_navn:asc'
  //   } else if (toggleValue === 'antalsaet') {
  //     this.currentListSortingOrder2 = 'raekke_antalsaet:asc'
  //   } else if (toggleValue === 'regionnavn') {
  //     this.currentListSortingOrder2 = 'region_id.region_navn:asc'
  //   }
  //   this.retrieveTournamentRows()
  // }

  // @Watch('toggleIconsSortingValue3')
  // onListSort3ToggleChanged (toggleValue: string, oldToggleValue: string) {
  //   console.log('List sort toggle changed to: ' + toggleValue)
  //   if (toggleValue === 'check_box_outline_blank') {
  //     this.currentListSortingOrder3 = ''
  //   } else if (toggleValue === 'kampnr') {
  //     this.currentListSortingOrder3 = 'kampprogram_kampnr:asc'
  //   } else if (toggleValue === 'saeson') {
  //     this.currentListSortingOrder3 = 'saeson_id.saeson_navn:asc'
  //   } else if (toggleValue === 'raekke') {
  //     this.currentListSortingOrder3 = 'raekke_id.raekke_navn:asc'
  //   } else if (toggleValue === 'dato') {
  //     this.currentListSortingOrder3 = 'kampprogram_dato:asc'
  //   }
  //   this.retrieveTournamentMatchSchedule()
  // }

  @Watch('newTournamentRowTextValue')
  onNewTournamentRowTextValueChanged (textValue: { text: string, value: string }, oldTextValue: { text: string, value: string }) : void {
    let placementCount = 0
    this.newPlacementTextOptions = []

    for (const teamsNewDivisionPlacementItem of this.teamsNewDivisionPlacements) {
      // Only process placement values for the particular tournament row, that has been selected.
      if (teamsNewDivisionPlacementItem.rowIdOfNewPlacement === Number(textValue.value)) {
        this.newPlacementTextOptions.push({ text: teamsNewDivisionPlacementItem.newPlacement.toString(), value: teamsNewDivisionPlacementItem.newPlacement.toString() })
        placementCount++
      }
    }

    // If the selected tournament rows is different than the original new tournament row, that the team was placed into, then add an extra (free) placement at the end.
    if (Number(textValue.value) !== this.origRowIdOfTeamPlacement) {
      this.newPlacementTextOptions.push({ text: (placementCount + 1).toString(), value: (placementCount + 1).toString() })
      this.newPlacementTextValue = { text: '1', value: '1' }
    } else {
      this.newPlacementTextValue = { text: (this.lastInitialNewPlacementValue).toString(), value: (this.lastInitialNewPlacementValue).toString() }
    }
  }

  @Watch('tournamentSeasonTextValue')
  onTournamentSeasonTextChanged (nameObj: any, oldNameObj: any) : void {
    // console.log('Season text filter changed to: ' + JSON.stringify(nameObj))
    this.teamInputFieldClickCount = 0
  }

  @Watch('tournamentRowsNameValue')
  onTournamentRowsNameChanged (nameObj: any, oldNameObj: any) : void {
    // console.log('Row name filter changed to: ' + JSON.stringify(nameObj))
    this.teamInputFieldClickCount = 0
  }

  public showRowColumn (column: string) : boolean {
    return this.rowColumnName.includes(column)
  }

  public showMatchColumn (column: string) : boolean {
    return this.matchColumnName.includes(column)
  }

  public locConvertFromUTCtoLocalDateTime (inputDatetimeString: string) : string {
    let retVal = ''
    retVal = CommonFunctions.convertFromUTCtoLocalDateTime(inputDatetimeString, 0)
    const strPos = retVal.indexOf(' ')
    retVal = (retVal.substring(0, strPos) + 'T' + retVal.substring(strPos + 1)).substring(0, 19)

    return retVal
  }

  public toDanishDateStringWClock (dateString: string) : string {
    // return CommonFunctions.toDanishDateString(dateString) + ' kl. ' + CommonFunctions.getHoursAndMinutes(dateString)
    return CommonFunctions.toDanishDateString(dateString, 3) + ' kl. ' + CommonFunctions.getHoursAndMinutes(dateString, false)
  }

  // ColumnSorting methods
  public categoryColumSort (sortBy: string) : void {
    if (sortBy === 'reset') {
      this.currentCategorySort = ''
      this.oldCategorySort = ''
      this.tournamentCategorySearchInputValue = ''
      Tournaments.TournamentCategoriesDataService.getAll('', { slicemode: 1, start: 0, limit: -1, page: (this.currentPage - 1), pagesize: this.pageSizeValue, totalcount: this.totalPages })
        .then((response) => {
          this.turneringskategoris = response.data
          this.forceRerenderTournamentsList()
          this.$forceUpdate()
        })
        .catch((err) => {
          this.error = err
        })
    } else if (sortBy === 'category') {
      if (this.oldCategorySort === '' || this.oldCategorySort !== sortBy) {
        this.currentCategorySort = 'turneringskategori_navn:asc'
        this.oldCategorySort = sortBy
      } else {
        this.currentCategorySort = 'turneringskategori_navn:desc'
        this.oldCategorySort = ''
      }
      this.retrieveTournamentCategories()
    } else if (sortBy === 'price') {
      if (this.oldCategorySort === '' || this.oldCategorySort !== sortBy) {
        this.currentCategorySort = 'turneringskategori_pris:asc'
        this.oldCategorySort = sortBy
      } else {
        this.currentCategorySort = 'turneringskategori_pris:desc'
        this.oldCategorySort = ''
      }
      this.retrieveTournamentCategories()
    }
  }

  public rowColumnSort (sortBy: string) : void {
    if (sortBy === 'reset') {
      this.tournamentRowSearchInputValue = ''
      this.tournamentRowSearchTerm = ''
      this.currentRowSort = ''
      this.oldRowSort = ''
    } else if (sortBy === 'name') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_navn:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_navn:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'category') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'turneringskategori_id.turneringskategori_navn:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'turneringskategori_id.turneringskategori_navn:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'minTeams') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_minhold:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_minhold:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'maxTeams') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_maxhold:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_maxhold:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'sets') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_antalsaet:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_antalsaet:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'teamsPerClub') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_antalspillere:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_antalspillere:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'players') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_antalspillere:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_antalspillere:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'maxPlayers') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_maxspillere:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_maxspillere:desc'
        this.oldRowSort = ''
      }
    } else if (sortBy === 'promotions') {
      if (this.oldRowSort === '' || this.oldRowSort !== sortBy) {
        this.currentRowSort = 'raekke_oprykning:asc'
        this.oldRowSort = sortBy
      } else {
        this.currentRowSort = 'raekke_oprykning:desc'
        this.oldRowSort = ''
      }
    }
    this.retrieveTournamentRows()
  }

  public ruleColumnSort (sortBy: string) : void {
    if (sortBy === 'reset') {
      this.rulesCategoryFilterValue = { id: 0, value: 'Vis alle' }
      this.currentRulesSort = 'turneringskategori_id.turneringskategori_navn:asc,turneringsregler_resultat:asc'
      this.oldRuleSort = ''
    } else if (sortBy === 'category') {
      if (this.oldRuleSort === '' || this.oldRuleSort !== sortBy) {
        this.currentRulesSort = 'turneringskategori_id.turneringskategori_navn:desc,turneringsregler_resultat:asc'
        this.oldRuleSort = 'category'
      } else {
        this.currentRulesSort = 'turneringskategori_id.turneringskategori_navn:asc,turneringsregler_resultat:asc'
        this.oldRuleSort = ''
      }
    } else if (sortBy === 'result') {
      if (this.oldRuleSort === '' || this.oldRuleSort !== sortBy) {
        this.currentRulesSort = 'turneringsregler_resultat:asc'
        this.oldRuleSort = 'result'
      } else {
        this.currentRulesSort = 'turneringsregler_resultat:desc'
        this.oldRuleSort = ''
      }
    } else if (sortBy === 'point') {
      if (this.oldRuleSort === '' || this.oldRuleSort !== sortBy) {
        this.currentRulesSort = 'turneringsregler_point:asc'
        this.oldRuleSort = 'point'
      } else {
        this.currentRulesSort = 'turneringsregler_point:desc'
        this.oldRuleSort = ''
      }
    }
    this.retrieveTournamentRules()
  }

  public matchColumnSort (sortBy: string) : void {
    if (sortBy === 'reset') {
      this.currentMatchSort = 'kampprogram_dato:asc,kampprogram_kampnr:asc'
      this.oldMatchSort = ''
      this.tournamentMatchScheduleSearchTerm = ''
      this.tournamentMatchScheduleSearchInputValue = ''
    } else if (sortBy === 'matchNo') {
      if (this.oldMatchSort === '' || this.oldMatchSort !== sortBy) {
        this.currentMatchSort = 'kampprogram_kampnr:asc'
        this.oldMatchSort = sortBy
      } else {
        this.currentMatchSort = 'kampprogram_kampnr:desc'
        this.oldMatchSort = ''
      }
    } else if (sortBy === 'season') {
      if (this.oldMatchSort === '' || this.oldMatchSort !== sortBy) {
        this.currentMatchSort = 'saeson_id.saeson_navn:asc'
        this.oldMatchSort = sortBy
      } else {
        this.currentMatchSort = 'saeson_id.saeson_navn:desc'
        this.oldMatchSort = ''
      }
    } else if (sortBy === 'row') {
      if (this.oldMatchSort === '' || this.oldMatchSort !== sortBy) {
        this.currentMatchSort = 'raekke_id.raekke_navn:asc'
        this.oldMatchSort = sortBy
      } else {
        this.currentMatchSort = 'raekke_id.raekke_navn:desc'
        this.oldMatchSort = ''
      }
    } else if (sortBy === 'homeTeam') {
      if (this.oldMatchSort === '' || this.oldMatchSort !== sortBy) {
        this.currentMatchSort = 'kampprogram_hjemmehold.hold_holdnavn:asc'
        this.oldMatchSort = sortBy
      } else {
        this.currentMatchSort = 'kampprogram_hjemmehold.hold_holdnavn:desc'
        this.oldCategorySort = ''
      }
    } else if (sortBy === 'awayTeam') {
      if (this.oldMatchSort === '' || this.oldMatchSort !== sortBy) {
        this.currentMatchSort = 'kampprogram_udehold.hold_holdnavn:asc'
        this.oldMatchSort = sortBy
      } else {
        this.currentMatchSort = 'kampprogram_udehold.hold_holdnavn:desc'
        this.oldMatchSort = ''
      }
    } else if (sortBy === 'date') {
      if (this.oldMatchSort === '' || this.oldMatchSort !== sortBy) {
        this.currentMatchSort = 'kampprogram_dato:asc'
        this.oldMatchSort = sortBy
      } else {
        this.currentMatchSort = 'kampprogram_dato:desc'
        this.oldMatchSort = ''
      }
    }
    this.retrieveTournamentMatchSchedule()
  }

  public turnToNewPage (pageChange : number) : void {
    this.currentPage += pageChange

    if (this.currentPage < 1) {
      this.currentPage = 1
    } else if (this.currentPage > this.totalNumberOfPages) {
      this.currentPage = this.totalNumberOfPages
    }

    this.retrieveTournamentCategories()
  }

  public turnToNewHistoryPage (pageChange : number) : void {
    this.currentHistoryPage += pageChange

    if (this.currentHistoryPage < 1) {
      this.currentHistoryPage = 1
    } else if (this.currentHistoryPage > this.totalNumberOfHistoryPages) {
      this.currentHistoryPage = this.totalNumberOfHistoryPages
    }

    this.retrievePlayersValidationHistory()
  }

  public jumpToPage (pageNumber : number) : void {
    this.currentPage = pageNumber

    if (this.currentPage < 1) {
      this.currentPage = 1
    } else if (this.currentPage > this.totalNumberOfPages) {
      this.currentPage = this.totalNumberOfPages
    }

    this.retrieveTournamentCategories()
  }

  public jumpToPageOfHistory (pageNumber : number) : void {
    this.currentHistoryPage = pageNumber

    if (this.currentHistoryPage < 1) {
      this.currentHistoryPage = 1
    } else if (this.currentHistoryPage > this.totalNumberOfHistoryPages) {
      this.currentHistoryPage = this.totalNumberOfHistoryPages
    }

    this.retrievePlayersValidationHistory()
  }

  public turnToNewPage2 (pageChange2 : number) : void {
    this.currentPage2 += pageChange2

    if (this.currentPage2 < 1) {
      this.currentPage2 = 1
    } else if (this.currentPage2 > this.totalNumberOfPages2) {
      this.currentPage2 = this.totalNumberOfPages2
    }

    this.retrieveTournamentRows()
  }

  public jumpToPage2 (pageNumber2 : number) : void {
    this.currentPage2 = pageNumber2

    if (this.currentPage2 < 1) {
      this.currentPage2 = 1
    } else if (this.currentPage2 > this.totalNumberOfPages2) {
      this.currentPage2 = this.totalNumberOfPages2
    }

    this.retrieveTournamentRows()
  }

  public turnToNewPage3 (pageChange3 : number) : void {
    this.currentPage3 += pageChange3

    if (this.currentPage3 < 1) {
      this.currentPage3 = 1
    } else if (this.currentPage3 > this.totalNumberOfPages3) {
      this.currentPage3 = this.totalNumberOfPages3
    }

    this.retrieveTournamentMatchSchedule()
  }

  public jumpToPage3 (pageNumber3 : number) : void {
    this.currentPage3 = pageNumber3

    if (this.currentPage3 < 1) {
      this.currentPage3 = 1
    } else if (this.currentPage3 > this.totalNumberOfPages3) {
      this.currentPage3 = this.totalNumberOfPages3
    }

    this.retrieveTournamentMatchSchedule()
  }

  public forceRerenderTournamentsList () : void {
    this.error = 'Opdaterer ...'
    this.$nextTick(() => {
      this.error = null
    })
  }

  public findTournamentCategory () : void {
    console.log('Search tournament category.')
    this.tournamentCategorySearchTerm = this.tournamentCategorySearchInputValue
    this.retrieveTournamentCategories()
  }

  public findTournamentRow () : void {
    console.log('Search tournament row.')
    this.tournamentRowSearchTerm = this.tournamentRowSearchInputValue
    this.retrieveTournamentRows()
  }

  // public findPlayerHistory () : void {
  //   console.log('Search Player')
  //   this.playerValidationHistorySearchString = this.playerValidationHistorySearchInputValue
  //   this.retrievePlayersValidationHistory()
  // }

  public findTournamentMatchSchedule () : void {
    console.log('Search tournament match schedule.')
    this.tournamentMatchScheduleSearchTerm = this.tournamentMatchScheduleSearchInputValue
    this.retrieveTournamentMatchSchedule()
  }

  private templateGetTeams (event: any, resetCountFlag: false, sourceName = '') {
    // console.log('[templateGetTeams] event current active instance = ' + JSON.stringify(this.name))
    // console.log('[templateGetTeams] event target tagName = ' + JSON.stringify(event.target.tagName))
    // console.log('[templateGetTeams] event target value = ' + JSON.stringify(event.target.value))
    // console.log('[templateGetTeams] event target currentTarget = ' + JSON.stringify(event.currentTarget))
    console.log('[templateGetTeams] event source name = ' + sourceName)

    if (sourceName === 'tab1' || sourceName === 'hjhold' || sourceName === 'udhold') {
      if (resetCountFlag === false || event.target.tagName === 'I' || event.target.tagName === 'INPUT') {
        this.teamInputFieldClickCount++
        console.log('teamInputFieldClickCount = ' + this.teamInputFieldClickCount)
      } else {
        this.teamInputFieldClickCount = 1
      }

      this.retrieveTeams(null, true)
    }
  }

  public newTournamentCategory () : void {
    this.editTournamentCategoryModal = true
    this.newCategory = true
  }

  public editTournamentCategory (tournamentCategoryId: number, documentId: string) : void {
    this.lastEditedTournamentCategoryId = tournamentCategoryId
    this.lastEditedTournamentCategoryDocumentId = documentId
    this.newCategory = false

    Tournaments.TournamentCategoriesDataService.get(documentId)
      .then((response) => {
        this.tempTournamentCategory = response.data
        this.tournamentCategoryData = { categoryName: this.tempTournamentCategory.turneringskategori_navn, categoryPrice: Number(this.tempTournamentCategory.turneringskategori_pris) }
        this.editTournamentCategoryModal = true
      })
      .catch((err) => {
        this.error = err
      })
  }

  // public cancelTournamentCategoryEdit () : void {
  //   console.log('Cancel tournament category item edit.')
  //   this.editTournamentCategoryModal = false
  //   this.tournamentCategoryData = { categoryName: '', categoryPrice: 0 }
  // }

  public editTournamentRow (tournamentRowId: number, documentId: string) : void {
    console.log('Edit tournament row item with Id: ' + tournamentRowId)
    this.lastEditedTournamentRowId = tournamentRowId
    this.lastEditedTournamentRowDocumentId = documentId

    Tournaments.TournamentRowsDataService.get(documentId)
      .then((response) => {
        this.tempTournamentRow = response.data
        this.tournamentRowData = { rowName: this.tempTournamentRow.raekke_navn, numberOfSets: Number(this.tempTournamentRow.raekke_antalsaet), minNumberOfTeams: Number(this.tempTournamentRow.raekke_minhold), maxNumberOfTeams: Number(this.tempTournamentRow.raekke_maxhold), numberOfTeamsPerClub: Number(this.tempTournamentRow.raekke_holdprklub), numberOfPlayers: Number(this.tempTournamentRow.raekke_antalspillere), maxNumberOfPlayers: Number(this.tempTournamentRow.raekke_maxspillere) }
        this.editTournamentRowModal = true
      })
      .catch((err) => {
        this.error = err
      })
  }

  public cancelTournamentRowEdit () : void {
    console.log('Cancel tournament row item edit.')
    this.editTournamentRowModal = false
    this.tournamentRowData = { rowName: '', numberOfSets: 0, minNumberOfTeams: 0, maxNumberOfTeams: 0, numberOfTeamsPerClub: 0, numberOfPlayers: 0, maxNumberOfPlayers: 0 }
  }

  public editTournamentMatchSchedule (tournamentMatchScheduleId: number, tournamentMatchScheduleRowNumberOfPlayersPerTeam: number | null, tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam: number | null, tournamentMatchScheduleRowNumberOfSetsPerMatch: number | null, isOldBoys = false) : void {
    console.log('Edit tournament match schedule item with Id: ' + tournamentMatchScheduleId)
    this.lastEditedTournamentMatchScheduleId = tournamentMatchScheduleId
    this.matchSettlementNumberOfSetsPerMatch = (tournamentMatchScheduleRowNumberOfSetsPerMatch === null || tournamentMatchScheduleRowNumberOfSetsPerMatch === 0 ? 1 : Number(tournamentMatchScheduleRowNumberOfSetsPerMatch))
    // this.editTournamentMatchScheduleModal = true

    if (tournamentMatchScheduleRowNumberOfPlayersPerTeam === 1) {
      this.matchSettlementNumberOfMatches = 1
    } else if (tournamentMatchScheduleRowNumberOfPlayersPerTeam === 2) {
      this.matchSettlementNumberOfMatches = 5
    } else if (isOldBoys) {
      if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) >= 3 && Number(tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam) <= 8) {
        this.matchSettlementNumberOfMatches = 4 + 2 // Four single matches plus 2 double matches.
      }
    } else {
      if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 3) {
        this.matchSettlementNumberOfMatches = 9
      } else if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 4) {
        this.matchSettlementNumberOfMatches = 16
      } else if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) >= 5 && Number(tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam) <= 8) {
        this.matchSettlementNumberOfMatches = 4 + 2 // Four single matches plus 2 double matches.
      }
    }

    Tournaments.TournamentMatchSchedulesDataService.get(tournamentMatchScheduleId.toString())
      .then((response) => {
        this.tempTournamentMatchSchedule = response.data
        console.log(response.data)

        // this.tournamentMatchScheduleData = { matchNumber: this.tempTournamentMatchSchedule.kampprogram_kampnr, matchScheduleDate: new Date(this.tempTournamentMatchSchedule.kampprogram_dato).toISOString().substring(0, 16), matchScheduleDateNewDate: new Date(this.tempTournamentMatchSchedule.kampprogram_nydato).toISOString().substring(0, 16), matchScheduleComment: this.tempTournamentMatchSchedule.kampprogram_kommentar, matchScheduleCommentStatus: this.tempTournamentMatchSchedule.kampprogram_afb_udb, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: Number(this.tempTournamentMatchSchedule.raekke_id.id), status: this.tempTournamentMatchSchedule.raekke_id.raekke_status, name: this.tempTournamentMatchSchedule.raekke_id.raekke_navn } }
        this.tournamentMatchScheduleData = { matchNumber: this.tempTournamentMatchSchedule.kampprogram_kampnr, matchScheduleDate: this.locConvertFromUTCtoLocalDateTime(this.tempTournamentMatchSchedule.kampprogram_dato).substring(0, 16), matchScheduleDateNewDate: this.locConvertFromUTCtoLocalDateTime(this.tempTournamentMatchSchedule.kampprogram_nydato).substring(0, 16), matchScheduleComment: this.tempTournamentMatchSchedule.kampprogram_kommentar, matchScheduleCommentStatus: this.tempTournamentMatchSchedule.kampprogram_afb_udb, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: Number(this.tempTournamentMatchSchedule.raekke_id.id), status: this.tempTournamentMatchSchedule.raekke_id.raekke_status, name: this.tempTournamentMatchSchedule.raekke_id.raekke_navn } }
        if (this.tempTournamentMatchSchedule.kampprogram_nydato === null) {
          this.tournamentMatchScheduleData.matchScheduleDateNewDate = this.tournamentMatchScheduleData.matchScheduleDate
        }
        if (this.tempTournamentMatchSchedule.kampprogram_afb_udb !== null) {
          // Set the current value of the radio button option list for the team Protest-Cancellation-NonAppearance status to best matching value based upon the value obtained through the API access.
          if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Protesthjem) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Protest fra hjemmeholdet'
          } else if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Protestud) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Protest fra udeholdet'
          } else if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudhjem) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Afbud fra hjemmeholdet'
          } else if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudud) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Afbud fra udeholdet'
          } else if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelsehjem) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Udeblivelse af hjemmeholdet'
          } else if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelseud) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Udeblivelse af udeholdet'
          } else {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Ingen'
          }
        } else {
          this.tournamentMatchSettlementTeamProtestStatusValue = 'Ingen'
        }

        // Set the value of number of matches for this match schedule.
        if (this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere !== null && this.tempTournamentMatchSchedule.raekke_id.raekke_maxspillere !== null &&
          this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere >= 1 && this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere <= 8) {
          const isOldBoys = (this.tempTournamentMatchSchedule.raekke_id.raekke_navn.toLocaleLowerCase().includes('old') && this.tempTournamentMatchSchedule.raekke_id.raekke_navn.toLocaleLowerCase().includes('boy'))

          if (this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere === 1) {
            this.matchSettlementNumberOfMatches = 1
          } else if (this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere === 2) {
            this.matchSettlementNumberOfMatches = 5
          } else if (isOldBoys) {
            if (Number(this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere) >= 3 && Number(this.tempTournamentMatchSchedule.raekke_id.raekke_maxspillere) <= 8) {
              this.matchSettlementNumberOfMatches = 4 + 2 // Four single matches plus 2 double matches.
            }
          } else {
            if (Number(this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere) === 3) {
              this.matchSettlementNumberOfMatches = 9
            } else if (Number(this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere) === 4) {
              this.matchSettlementNumberOfMatches = 16
            } else if (Number(this.tempTournamentMatchSchedule.raekke_id.raekke_antalspillere) >= 5 && Number(this.tempTournamentMatchSchedule.raekke_id.raekke_maxspillere) <= 8) {
              this.matchSettlementNumberOfMatches = 4 + 2 // Four single matches plus 2 double matches.
            }
          }
        }

        this.matchFinalApproval.new = false
        this.matchFinalApproval.orig = false

        Tournaments.TournamentMatchFinalApproval.getAll('', null, 'kampprogram_id.id=' + tournamentMatchScheduleId.toString())
          .then((response) => {
            // console.log('[editTournamentMatchSchedule()] Match final approval response.data = ' + JSON.stringify(response.data))

            if ((<any[]>response.data).length >= 1 && response.data[0] !== null && response.data[0].kampgodkendt_godkendt !== undefined && response.data[0].kampgodkendt_godkendt !== null && response.data[0].kampgodkendt_godkendt === true) {
              this.matchFinalApproval.new = true
              this.matchFinalApproval.orig = true
            }
          })
          .catch((err) => {
            console.log(err)
          })

        this.retrieveTeams(true)
      })
      .catch((err) => {
        this.error = err
      })
  }

  public cancelTournamentMatchScheduleEdit () : void {
    console.log('Cancel tournament match schedule item edit.')
    this.editTournamentMatchScheduleModal = false
    this.homeTeamNameValue = { text: 'Vælg her', value: '0' }
    this.guestTeamNameValue = { text: 'Vælg her', value: '0' }
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.tournamentRowsNameValue = { text: 'Vælg her', value: '0' }
    this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
    this.matchScheduleDateLockFlag = true
  }

  public editTournamentMatchSettlement (tournamentMatchScheduleId: number, tournamentMatchScheduleRowNumberOfPlayersPerTeam: number | null, tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam: number | null, tournamentMatchScheduleRowNumberOfSetsPerMatch: number | null, isOldBoys = false) : void {
    console.log('Edit tournament match settlement for schedule item with Id: ' + tournamentMatchScheduleId)
    this.lastEditedTournamentMatchScheduleId = tournamentMatchScheduleId
    this.matchSettlementNumberOfPresentMatchesCreated = 0 // Reset progress value.
    this.matchSettlementNumberOfPresentMatchesSetsCreated = 0 // Reset progress value.
    this.matchAutoUpdateMode = false
    this.editTournamentMatchSettlementModal = true
    this.matchSettlementNumberOfMatches = 16
    this.matchSettlementNumberOfSetsPerMatch = 4
    console.log('tournamentMatchScheduleRowNumberOfPlayers = ' + tournamentMatchScheduleRowNumberOfPlayersPerTeam)
    console.log('tournamentMatchScheduleRowNumberOfSetsPerMatch = ' + tournamentMatchScheduleRowNumberOfSetsPerMatch)

    if (tournamentMatchScheduleRowNumberOfPlayersPerTeam !== null && tournamentMatchScheduleRowNumberOfSetsPerMatch !== null &&
      tournamentMatchScheduleRowNumberOfPlayersPerTeam >= 1 && tournamentMatchScheduleRowNumberOfPlayersPerTeam <= 8 &&
      tournamentMatchScheduleRowNumberOfSetsPerMatch >= 1 && tournamentMatchScheduleRowNumberOfSetsPerMatch <= 7) {
      this.matchSettlementNumberOfSetsPerMatch = (tournamentMatchScheduleRowNumberOfSetsPerMatch === null ? 1 : Number(tournamentMatchScheduleRowNumberOfSetsPerMatch))

      if (tournamentMatchScheduleRowNumberOfPlayersPerTeam === 1) {
        this.matchSettlementNumberOfMatches = 1
        this.matchSettlementPlayerMatchOrder = [
          { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: 0 }
        ]
      } else if (tournamentMatchScheduleRowNumberOfPlayersPerTeam === 2) {
        this.matchSettlementNumberOfMatches = 5
        this.matchSettlementPlayerMatchOrder = [
          { playerIndexHomeTeam: 1, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
          { playerIndexHomeTeam: 2, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
          { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 2, playerIndex2GuestTeam: 2, isDouble: true, resultRecorderHome: null, resultRecorderGuest: 0 },
          { playerIndexHomeTeam: 2, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
          { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 }
        ]
      } else if (isOldBoys) {
        if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) >= 3 && Number(tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam) <= 8) {
          this.matchSettlementNumberOfMatches = 4 + 2 // Four single matches plus 2 double matches.
          this.matchSettlementPlayerMatchOrder = [
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 4, playerIndexGuestTeam: 4, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 5, playerIndexGuestTeam: 5, playerIndex2HomeTeam: 6, playerIndex2GuestTeam: 6, isDouble: true, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 7, playerIndexGuestTeam: 7, playerIndex2HomeTeam: 8, playerIndex2GuestTeam: 8, isDouble: true, resultRecorderHome: 0, resultRecorderGuest: null }
          ]
        } /* else if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 3) {
          this.matchSettlementNumberOfMatches = 4 + 2 // Four single matches plus 2 double matches.
          this.matchSettlementPlayerMatchOrder = [
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 4, playerIndexGuestTeam: 4, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 5, playerIndexGuestTeam: 5, playerIndex2HomeTeam: 6, playerIndex2GuestTeam: 6, isDouble: true, resultRecorderHome: 0, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 7, playerIndexGuestTeam: 7, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: 0 }
          ]
        } */
      } else {
        if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 3) {
          this.matchSettlementNumberOfMatches = 9
          this.matchSettlementPlayerMatchOrder = [
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 }
          ]
        } else if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 4) {
          this.matchSettlementNumberOfMatches = 16
          this.matchSettlementPlayerMatchOrder = [
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 3 },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 4, resultRecorderGuest: null },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 4, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 2 },
            { playerIndexHomeTeam: 4, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 2, resultRecorderGuest: null },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 1 },
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 4, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 3, resultRecorderGuest: null },
            { playerIndexHomeTeam: 4, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 4 },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 1, resultRecorderGuest: null },
            { playerIndexHomeTeam: 4, playerIndexGuestTeam: 4, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 3 },
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 3, resultRecorderGuest: null },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 1 },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 1, resultRecorderGuest: null },
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 2 },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 4, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 4, resultRecorderGuest: null },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 4 },
            { playerIndexHomeTeam: 4, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 2, resultRecorderGuest: null }
          ]
        } else if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) >= 5 && Number(tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam) <= 8) {
          this.matchSettlementNumberOfMatches = 4 + 2 // Four single matches plus 2 double matches.
          this.matchSettlementPlayerMatchOrder = [
            { playerIndexHomeTeam: 1, playerIndexGuestTeam: 1, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 2, playerIndexGuestTeam: 2, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 3, playerIndexGuestTeam: 3, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 4, playerIndexGuestTeam: 4, playerIndex2HomeTeam: 0, playerIndex2GuestTeam: 0, isDouble: false, resultRecorderHome: 0, resultRecorderGuest: null },
            { playerIndexHomeTeam: 5, playerIndexGuestTeam: 5, playerIndex2HomeTeam: 6, playerIndex2GuestTeam: 6, isDouble: true, resultRecorderHome: null, resultRecorderGuest: 0 },
            { playerIndexHomeTeam: 7, playerIndexGuestTeam: 7, playerIndex2HomeTeam: 8, playerIndex2GuestTeam: 8, isDouble: true, resultRecorderHome: 0, resultRecorderGuest: null }
          ]
        }
      }
      // console.log('[editTournamentMatchSettlement] matchSettlementPlayerMatchOrder = ' + JSON.stringify(this.matchSettlementPlayerMatchOrder))

      // Get team information and player member information for each team of this tournament match settlement.
      Tournaments.TournamentMatchSettlementDataService.getAll('', null, 'kampprogram_id.id=' + tournamentMatchScheduleId.toString())
        .then((response) => {
          this.tempTournamentMatchSettlement = response.data[0]
          console.log(response.data)
          this.tempTournamentMatchSettlement.kampafvikling_ekstras_id = this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.sort(function compare (a, b) { return a.kampafvikling_spiller_indeks - b.kampafvikling_spiller_indeks })

          Tournaments.TournamentMatchSchedulesDataService.get(tournamentMatchScheduleId.toString())
            .then((response) => {
              this.tempTournamentMatchSchedule = response.data
              console.log(response.data)

              // this.tournamentMatchScheduleData = { matchNumber: this.tempTournamentMatchSchedule.kampprogram_kampnr, matchScheduleDate: new Date(this.tempTournamentMatchSchedule.kampprogram_dato).toISOString().substring(0, 16), matchScheduleDateNewDate: new Date(this.tempTournamentMatchSchedule.kampprogram_nydato).toISOString().substring(0, 16), matchScheduleComment: this.tempTournamentMatchSchedule.kampprogram_kommentar, matchScheduleCommentStatus: this.tempTournamentMatchSchedule.kampprogram_afb_udb, matchHomeTeamId: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id)), matchHomeTeamName: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null || this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn), matchHomeTeamResult: 0, matchGuestTeamId: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_udehold.id)), matchGuestTeamName: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null || this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn), matchGuestTeamResult: 0, matchHomeTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === true ? 1 : 0)), matchGuestTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === true ? 1 : 0)), matchTournamentRow: { id: Number(this.tempTournamentMatchSchedule.raekke_id.id), status: this.tempTournamentMatchSchedule.raekke_id.raekke_status, name: this.tempTournamentMatchSchedule.raekke_id.raekke_navn } }
              this.tournamentMatchScheduleData = { matchNumber: this.tempTournamentMatchSchedule.kampprogram_kampnr, matchScheduleDate: this.locConvertFromUTCtoLocalDateTime(this.tempTournamentMatchSchedule.kampprogram_dato).substring(0, 16), matchScheduleDateNewDate: this.locConvertFromUTCtoLocalDateTime(this.tempTournamentMatchSchedule.kampprogram_nydato).substring(0, 16), matchScheduleComment: this.tempTournamentMatchSchedule.kampprogram_kommentar, matchScheduleCommentStatus: this.tempTournamentMatchSchedule.kampprogram_afb_udb, matchHomeTeamId: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id)), matchHomeTeamName: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null || this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn), matchHomeTeamResult: 0, matchGuestTeamId: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_udehold.id)), matchGuestTeamName: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null || this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn), matchGuestTeamResult: 0, matchHomeTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === true ? 1 : 0)), matchGuestTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === true ? 1 : 0)), matchTournamentRow: { id: Number(this.tempTournamentMatchSchedule.raekke_id.id), status: this.tempTournamentMatchSchedule.raekke_id.raekke_status, name: this.tempTournamentMatchSchedule.raekke_id.raekke_navn } }

              let sanityCheckFlag = false

              if (this.tempTournamentMatchSettlement !== undefined && this.tempTournamentMatchSettlement !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id !== undefined && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id !== null) {
                // Build an array with match player Ids to be used when retrieving player member information through the API access.
                this.tournamentMatchScheduleHomeTeamPlayersInfoData = []
                this.tournamentMatchScheduleGuestTeamPlayersInfoData = []
                let matchSettlementDataExtIdsHaveNull = false
                let matchSettlementDataExtPlayersMemberFindParam = ''
                let matchSettlementDataExtPlayersMemberFindParamOneEighty = ''
                let arrIndex1 = 0
                const matchSettlementDataExtIds: number[] = []
                console.log('[editTournamentMatchSettlement] kampafvikling_ekstras_id' + JSON.stringify(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id))

                for (const matchSettlementDataExtObjItem of this.tempTournamentMatchSettlement.kampafvikling_ekstras_id) {
                  if (matchSettlementDataExtObjItem.id !== null) {
                    matchSettlementDataExtIds.push(Number(matchSettlementDataExtObjItem.id))
                    matchSettlementDataExtPlayersMemberFindParam += ((arrIndex1 < 1 ? 'id=' : '&id=') + Number(matchSettlementDataExtObjItem.kampafvikling_spiller_hj).toString() + '&id=' + Number(matchSettlementDataExtObjItem.kampafvikling_spiller_ud).toString())

                    if (this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(matchSettlementDataExtObjItem.kampafvikling_spiller_hj)) === -1) {
                      this.tournamentMatchScheduleHomeTeamPlayersInfoData.push({ playerMemberId: Number(matchSettlementDataExtObjItem.kampafvikling_spiller_hj), playerName: '-', playerLicense: 0, playerSelected: (matchSettlementDataExtObjItem.kampafvikling_spiller_hj_valgt === null ? true : matchSettlementDataExtObjItem.kampafvikling_spiller_hj_valgt), playerVerdict: (matchSettlementDataExtObjItem.kampafvikling_dom_mod_hjspiller === null ? 0.5 : (matchSettlementDataExtObjItem.kampafvikling_dom_mod_hjspiller ? 1 : 0)), playerVerdictDirtyFlag: false, matchSettlementExtId: Number(matchSettlementDataExtObjItem.id), matchesWon: 0, matchSetsWon: 0, matchSetsLost: 0, match180: 0, matchSetHighestClosing: 0, matchSetFastestDarting: 0, hide: false })
                    } else {
                      this.tournamentMatchScheduleHomeTeamPlayersInfoData.push({ playerMemberId: Number(matchSettlementDataExtObjItem.kampafvikling_spiller_hj), playerName: '-', playerLicense: 0, playerSelected: (matchSettlementDataExtObjItem.kampafvikling_spiller_hj_valgt === null ? true : matchSettlementDataExtObjItem.kampafvikling_spiller_hj_valgt), playerVerdict: (matchSettlementDataExtObjItem.kampafvikling_dom_mod_hjspiller === null ? 0.5 : (matchSettlementDataExtObjItem.kampafvikling_dom_mod_hjspiller ? 1 : 0)), playerVerdictDirtyFlag: false, matchSettlementExtId: Number(matchSettlementDataExtObjItem.id), matchesWon: 0, matchSetsWon: 0, matchSetsLost: 0, match180: 0, matchSetHighestClosing: 0, matchSetFastestDarting: 0, hide: true })
                    }
                    if (this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(matchSettlementDataExtObjItem.kampafvikling_spiller_ud)) === -1) {
                      this.tournamentMatchScheduleGuestTeamPlayersInfoData.push({ playerMemberId: Number(matchSettlementDataExtObjItem.kampafvikling_spiller_ud), playerName: '-', playerLicense: 0, playerSelected: (matchSettlementDataExtObjItem.kampafvikling_spiller_ud_valgt === null ? true : matchSettlementDataExtObjItem.kampafvikling_spiller_ud_valgt), playerVerdict: (matchSettlementDataExtObjItem.kampafvikling_dom_mod_udspiller === null ? 0.5 : (matchSettlementDataExtObjItem.kampafvikling_dom_mod_udspiller ? 1 : 0)), playerVerdictDirtyFlag: false, matchSettlementExtId: Number(matchSettlementDataExtObjItem.id), matchesWon: 0, matchSetsWon: 0, matchSetsLost: 0, match180: 0, matchSetHighestClosing: 0, matchSetFastestDarting: 0, hide: false })
                    } else {
                      this.tournamentMatchScheduleGuestTeamPlayersInfoData.push({ playerMemberId: Number(matchSettlementDataExtObjItem.kampafvikling_spiller_ud), playerName: '-', playerLicense: 0, playerSelected: (matchSettlementDataExtObjItem.kampafvikling_spiller_ud_valgt === null ? true : matchSettlementDataExtObjItem.kampafvikling_spiller_ud_valgt), playerVerdict: (matchSettlementDataExtObjItem.kampafvikling_dom_mod_udspiller === null ? 0.5 : (matchSettlementDataExtObjItem.kampafvikling_dom_mod_udspiller ? 1 : 0)), playerVerdictDirtyFlag: false, matchSettlementExtId: Number(matchSettlementDataExtObjItem.id), matchesWon: 0, matchSetsWon: 0, matchSetsLost: 0, match180: 0, matchSetHighestClosing: 0, matchSetFastestDarting: 0, hide: true })
                    }
                    // If the situation is a old boys row with only 3 players per team then handle that situation special here. The last double match will be converted into a single match, since there are not enough players for a double match in this case.
                    if (isOldBoys && Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 3 && matchSettlementDataExtObjItem.kampafvikling_spiller_indeks >= 7 && matchSettlementDataExtObjItem.kampafvikling_spiller_hj_valgt === false && matchSettlementDataExtObjItem.kampafvikling_spiller_ud_valgt === false && this.matchSettlementPlayerMatchOrder[5].isDouble) {
                      this.matchSettlementPlayerMatchOrder[5].isDouble = false
                      this.matchSettlementPlayerMatchOrder[5].playerIndex2HomeTeam = 0
                      this.matchSettlementPlayerMatchOrder[5].playerIndex2GuestTeam = 0
                    }

                    arrIndex1++
                  } else {
                    matchSettlementDataExtIdsHaveNull = true
                  }
                }
                matchSettlementDataExtPlayersMemberFindParamOneEighty = matchSettlementDataExtPlayersMemberFindParam.replaceAll('id=', 'medlem_id.id=') + '&kampprogram_id.id=' + tournamentMatchScheduleId.toString()
                console.log('[editTournamentMatchSettlement] matchSettlementDataExtPlayersMemberFindParam = ' + matchSettlementDataExtPlayersMemberFindParam)
                console.log('[editTournamentMatchSettlement] matchSettlementDataExtPlayersMemberFindParamOneEighty = ' + matchSettlementDataExtPlayersMemberFindParamOneEighty)
                console.log('[editTournamentMatchSettlement] Size of matchSettlementDataExtIds[] = ' + (matchSettlementDataExtIds.length).toString())
                console.log('[editTournamentMatchSettlement] matchSettlementDataExtIdsHaveNull = ' + matchSettlementDataExtIdsHaveNull)

                // Sanity checks are done here.
                if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 1 && (matchSettlementDataExtIds.length) === 1) {
                  sanityCheckFlag = true
                }
                if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 2 && (matchSettlementDataExtIds.length * 2 + 1) === this.matchSettlementNumberOfMatches) {
                  sanityCheckFlag = true
                }
                if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 3 && (Math.pow(matchSettlementDataExtIds.length, 2)) === this.matchSettlementNumberOfMatches) {
                  sanityCheckFlag = true
                }
                if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) === 4 && (Math.pow(matchSettlementDataExtIds.length, 2)) === this.matchSettlementNumberOfMatches) {
                  sanityCheckFlag = true
                }
                if (Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) >= 5 && Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) <= 8 && (matchSettlementDataExtIds.length) >= 5) {
                  sanityCheckFlag = true
                }
                if (isOldBoys && Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) >= 3 && Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) <= 8 && (matchSettlementDataExtIds.length) >= 3) {
                  sanityCheckFlag = true
                }
                // console.log('[editTournamentMatchSettlement] sanityCheckFlag = ' + sanityCheckFlag)

                // if (matchSettlementDataExtIdsHaveNull === false && (Math.pow(matchSettlementDataExtIds.length, 2)) === this.matchSettlementNumberOfMatches) {
                if (matchSettlementDataExtIdsHaveNull === false && sanityCheckFlag) {
                  // Get members information of each match settlement player from API.
                  MembersDataService.getAll('', null, matchSettlementDataExtPlayersMemberFindParam)
                    .then((response) => {
                      this.tempTournamentMatchSettlementPlayersMemberData = response.data
                      console.log(response.data)

                      Tournaments.TournamentMatch180DataService.getAll('', null, matchSettlementDataExtPlayersMemberFindParamOneEighty)
                        .then((response) => {
                          const tempTournamentMatchSettlementPlayersMatch180Data = response.data as SysTournamentMatch180[]
                          console.log(response.data)

                          // Add some additional members information to the team player information section of the match schedule.
                          for (let arrIndex1 = 0, indexOfTeamPlayerMemberData = 0; arrIndex1 < Math.max(this.tournamentMatchScheduleHomeTeamPlayersInfoData.length, this.tournamentMatchScheduleGuestTeamPlayersInfoData.length); arrIndex1++) {
                            indexOfTeamPlayerMemberData = (this.tournamentMatchScheduleHomeTeamPlayersInfoData.length > arrIndex1) ? this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => Number(x.id) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].playerMemberId)) : -1
                            if (indexOfTeamPlayerMemberData >= 0) {
                              this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].playerName = this.tempTournamentMatchSettlementPlayersMemberData[indexOfTeamPlayerMemberData].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexOfTeamPlayerMemberData].user_id.lastname
                              this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].playerLicense = this.tempTournamentMatchSettlementPlayersMemberData[indexOfTeamPlayerMemberData].medlem_licens
                            }
                            indexOfTeamPlayerMemberData = (this.tournamentMatchScheduleGuestTeamPlayersInfoData.length > arrIndex1) ? this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => Number(x.id) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].playerMemberId)) : -1
                            if (indexOfTeamPlayerMemberData >= 0) {
                              this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].playerName = this.tempTournamentMatchSettlementPlayersMemberData[indexOfTeamPlayerMemberData].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexOfTeamPlayerMemberData].user_id.lastname
                              this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].playerLicense = this.tempTournamentMatchSettlementPlayersMemberData[indexOfTeamPlayerMemberData].medlem_licens
                            }
                            indexOfTeamPlayerMemberData = (this.tournamentMatchScheduleHomeTeamPlayersInfoData.length > arrIndex1) ? tempTournamentMatchSettlementPlayersMatch180Data.findIndex(x => Number(x.medlem_id.id) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].playerMemberId)) : -1
                            if (indexOfTeamPlayerMemberData >= 0) {
                              this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].match180 = tempTournamentMatchSettlementPlayersMatch180Data[indexOfTeamPlayerMemberData].kamp_180_antal
                            } else {
                              if (this.tournamentMatchScheduleGuestTeamPlayersInfoData.length > arrIndex1) {
                                this.tournamentMatchScheduleHomeTeamPlayersInfoData[arrIndex1].match180 = 0
                              }
                            }
                            indexOfTeamPlayerMemberData = (this.tournamentMatchScheduleGuestTeamPlayersInfoData.length > arrIndex1) ? tempTournamentMatchSettlementPlayersMatch180Data.findIndex(x => Number(x.medlem_id.id) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].playerMemberId)) : -1
                            if (indexOfTeamPlayerMemberData >= 0) {
                              this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].match180 = tempTournamentMatchSettlementPlayersMatch180Data[indexOfTeamPlayerMemberData].kamp_180_antal
                            } else {
                              if (this.tournamentMatchScheduleGuestTeamPlayersInfoData.length > arrIndex1) {
                                this.tournamentMatchScheduleGuestTeamPlayersInfoData[arrIndex1].match180 = 0
                              }
                            }
                          }
                          // console.log('[editTournamentMatchSettlement] tournamentMatchScheduleHomeTeamPlayersInfoData[] = ' + JSON.stringify(this.tournamentMatchScheduleHomeTeamPlayersInfoData))

                          // Initialize the match settlement player match set result array.
                          this.matchSettlementPlayerMatchSetResults = []
                          for (let arrIndex1 = 0; arrIndex1 < this.matchSettlementNumberOfMatches; arrIndex1++) {
                            for (let arrIndex2 = 0; arrIndex2 < this.matchSettlementNumberOfSetsPerMatch * 2; arrIndex2++) {
                              this.matchSettlementPlayerMatchSetResults.push({ matchId: 0, matchIndexNumber: (arrIndex1 + 1), matchSetDart: 0, matchSetClosed: 0, matchSetRemainScore: 0, matchSet: Math.floor(arrIndex2 / 2), matchHomeOrGuestTeam: ((arrIndex2 & 1) === 0), matchSetDirtyFlag: 0 })
                            }
                          }
                          console.log('[editTournamentMatchSettlement] matchSettlementPlayerMatchSetResults[] = ' + JSON.stringify(this.matchSettlementPlayerMatchSetResults))

                          // this.tournamentMatchScheduleData = { matchNumber: this.tempTournamentMatchSchedule.kampprogram_kampnr, matchScheduleDate: new Date(this.tempTournamentMatchSchedule.kampprogram_dato).toISOString().substring(0, 16), matchScheduleDateNewDate: new Date(this.tempTournamentMatchSchedule.kampprogram_nydato).toISOString().substring(0, 16), matchScheduleComment: this.tempTournamentMatchSchedule.kampprogram_kommentar, matchScheduleCommentStatus: this.tempTournamentMatchSchedule.kampprogram_afb_udb, matchHomeTeamId: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id)), matchHomeTeamName: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null || this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn), matchHomeTeamResult: 0, matchGuestTeamId: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_udehold.id)), matchGuestTeamName: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null || this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn), matchGuestTeamResult: 0, matchHomeTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === true ? 1 : 0)), matchGuestTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === true ? 1 : 0)), matchTournamentRow: { id: Number(this.tempTournamentMatchSchedule.raekke_id.id), status: this.tempTournamentMatchSchedule.raekke_id.raekke_status, name: this.tempTournamentMatchSchedule.raekke_id.raekke_navn } }
                          this.tournamentMatchScheduleData = { matchNumber: this.tempTournamentMatchSchedule.kampprogram_kampnr, matchScheduleDate: this.locConvertFromUTCtoLocalDateTime(this.tempTournamentMatchSchedule.kampprogram_dato).substring(0, 16), matchScheduleDateNewDate: this.locConvertFromUTCtoLocalDateTime(this.tempTournamentMatchSchedule.kampprogram_nydato).substring(0, 16), matchScheduleComment: this.tempTournamentMatchSchedule.kampprogram_kommentar, matchScheduleCommentStatus: this.tempTournamentMatchSchedule.kampprogram_afb_udb, matchHomeTeamId: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id)), matchHomeTeamName: (this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id === null || this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn), matchHomeTeamResult: 0, matchGuestTeamId: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null ? 0 : Number(this.tempTournamentMatchSchedule.kampprogram_udehold.id)), matchGuestTeamName: (this.tempTournamentMatchSchedule.kampprogram_udehold.id === null || this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn === null ? 'UKENDT/FEJL' : this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn), matchGuestTeamResult: 0, matchHomeTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_hjhold === true ? 1 : 0)), matchGuestTeamVerdict: (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === null ? 0.5 : (this.tempTournamentMatchSettlement.kampafvikling_dom_mod_udhold === true ? 1 : 0)), matchTournamentRow: { id: Number(this.tempTournamentMatchSchedule.raekke_id.id), status: this.tempTournamentMatchSchedule.raekke_id.raekke_status, name: this.tempTournamentMatchSchedule.raekke_id.raekke_navn } }

                          // console.log('[editTournamentMatchSettlement] matchScheduleDate = ' + this.tournamentMatchScheduleData.matchScheduleDate)

                          // Initialize match settlement related database tables:
                          // Create the various match and match set items in the database if they do not exist already.
                          this.matchSettlementNumberOfPresentMatchesCreated = 0 // Reset progress value.
                          this.matchSettlementNumberOfPresentMatchesSetsCreated = 0 // Reset progress value.
                          this.initializeMatchTables()
                        })
                        .catch((err) => {
                          this.error = err
                        })
                    })
                    .catch((err) => {
                      this.error = err
                    })
                }
              }
            })
            .catch((err) => {
              this.error = err
            })
        })
        .catch((err) => {
          this.error = err
        })
    }
  }

  public initializeMatchTables () : boolean {
    console.log('[initializeMatchTables] Initializing match and match set database tables for the match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString())

    Tournaments.TournamentMatchDataService.getAll('kamp_nummer:asc', null, 'kampafvikling_id.id=' + Number(this.tempTournamentMatchSettlement.id).toString())
      .then((response) => {
        let tempTournamentMatchData: SysTournamentMatch[] = []
        tempTournamentMatchData = response.data

        console.log('[initializeMatchTables] Tournament matches data: ' + JSON.stringify(response.data))

        for (let arrIndex1 = 0; arrIndex1 < this.matchSettlementNumberOfMatches;) {
          const tempArrIndex1 = arrIndex1
          const matchNumberIndex = tempTournamentMatchData.findIndex(x => x.kamp_nummer === (arrIndex1 + 1))

          if (matchNumberIndex === -1) {
            console.log('[initializeMatchTables] matchSettlementPlayerMatchOrder[' + arrIndex1.toString() + '] = ' + JSON.stringify(this.matchSettlementPlayerMatchOrder[arrIndex1]))
            // Create the tournament match item between two players (one from each team).
            const createTournamentMatchData = {
              kampafvikling_id: Number(this.tempTournamentMatchSettlement.id),
              kamp_nummer: (arrIndex1 + 1),
              kamp_hjemmebane_spiller: this.matchSettlementPlayerMatchOrder[arrIndex1].playerIndexHomeTeam.toString(),
              kamp_udebane_spiller: String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex1].playerIndexGuestTeam > 0 && this.matchSettlementPlayerMatchOrder[arrIndex1].playerIndexGuestTeam < 9 ? (this.matchSettlementPlayerMatchOrder[arrIndex1].playerIndexGuestTeam + 64) : 65)
            }

            Tournaments.TournamentMatchDataService.create(createTournamentMatchData)
              .then((response) => {
                this.lastCreatedTournamentMatchId = response.data.id
                const createdTournamentMatchId = response.data.id
                // const tempArrIndex1 = arrIndex1
                this.matchSettlementNumberOfPresentMatchesCreated++
                console.log('[initializeMatchTables] Created match data: ' + JSON.stringify(response.data))

                // Tournaments.TournamentMatchSetDataService.getAll('kamp_saet_saet:asc', null, 'kamp_id.id=' + Number(createdTournamentMatchId).toString() + '&kamp_saet_saet=' + this.matchSettlementPlayerMatchSetResults[arrIndex2].matchSet.toString() + '&kamp_saet_hjem_ud=' + this.matchSettlementPlayerMatchSetResults[arrIndex2].matchHomeOrGuestTeam)
                Tournaments.TournamentMatchSetDataService.getAll('kamp_saet_saet:asc', null, 'kamp_id.id=' + Number(createdTournamentMatchId).toString())
                  .then((response) => {
                    let tempTournamentMatchSetsData: SysTournamentMatchSet[] = []
                    tempTournamentMatchSetsData = response.data
                    console.log('[initializeMatchTables] Tournament match sets data: ' + JSON.stringify(response.data))

                    for (let arrIndex2 = 0; arrIndex2 < this.matchSettlementNumberOfSetsPerMatch * 2;) {
                      const matchSetArrayIndex = tempArrIndex1 * this.matchSettlementNumberOfSetsPerMatch * 2 + arrIndex2
                      this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId = createdTournamentMatchId
                      // this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId = Number(tempTournamentMatchSetsData[0].kamp_id.id)
                      this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchIndexNumber = (tempArrIndex1 + 1)

                      const matchSetIndex1 = tempTournamentMatchSetsData.findIndex(x => (x.kamp_saet_saet === this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet && x.kamp_saet_hjem_ud === this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam))

                      console.log('[initializeMatchTables] matchSetIndex1 = ' + matchSetIndex1)

                      if (matchSetIndex1 === -1) {
                        const createTournamentMatchSetData = {
                          kamp_id: createdTournamentMatchId,
                          kamp_saet_dart: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart,
                          kamp_saet_lukket: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed,
                          kamp_saet_restscore: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetRemainScore,
                          kamp_saet_saet: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet,
                          kamp_saet_hjem_ud: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam
                        }

                        console.log('[initializeMatchTables] createTournamentMatchSetData = ' + JSON.stringify(createTournamentMatchSetData))

                        Tournaments.TournamentMatchSetDataService.create(createTournamentMatchSetData)
                          .then((response) => {
                            this.lastCreatedTournamentMatchSetId = response.data.id
                            if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false) {
                              this.matchSettlementNumberOfPresentMatchesSetsCreated++
                            }
                            console.log('[initializeMatchTables] Created match set data:' + JSON.stringify(response.data))

                            return true
                          })
                          .catch((err) => {
                            // this.error = err
                            console.log('[initializeMatchTables] Error retrieving relevant match set item for tournament match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString() + ' with match number: ' + (tempArrIndex1 + 1).toString())
                            console.log('[initializeMatchTables] Error message: ' + err)

                            return false
                          })
                          // .finally(() => {
                          // })
                      } else {
                        console.log('[initializeMatchTables] Match set data was already created.')
                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false) {
                          this.matchSettlementNumberOfPresentMatchesSetsCreated++
                        }
                        console.log('[initializeMatchTables] Created match set so far: ' + this.matchSettlementNumberOfPresentMatchesSetsCreated)

                        // this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId = (tempTournamentMatchSetsData[matchSetIndex1].kamp_id.id === null ? 0 : Number(tempTournamentMatchSetsData[matchSetIndex1].kamp_id.id))
                        this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart = tempTournamentMatchSetsData[matchSetIndex1].kamp_saet_dart
                        this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed = tempTournamentMatchSetsData[matchSetIndex1].kamp_saet_lukket
                        this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetRemainScore = tempTournamentMatchSetsData[matchSetIndex1].kamp_saet_restscore
                        // this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet = tempTournamentMatchSetsData[matchSetIndex1].kamp_saet_saet
                      }

                      arrIndex2++
                    }

                    return true
                  })
                  .catch((err) => {
                    // this.error = err
                    console.log('[initializeMatchTables] Error creating match set item for tournament match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString() + ' with match number: ' + (tempArrIndex1 + 1).toString())
                    console.log('[initializeMatchTables] Error message: ' + err)

                    return false
                  })
              })
              .catch((err) => {
                // this.error = err
                console.log('[initializeMatchTables] Error creating match item for tournament match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString() + ' with match number: ' + (arrIndex1 + 1).toString())
                console.log('[initializeMatchTables] Error message: ' + err)

                return false
              })
          } else {
            console.log('[initializeMatchTables] Match data was already created.')
            this.matchSettlementNumberOfPresentMatchesCreated++

            // console.log('[initializeMatchTables] pre-getAll with ' + matchNumberIndex)
            // console.log('[initializeMatchTables] pre-getAll kamp_id.id = ' + Number(tempTournamentMatchData[matchNumberIndex].id).toString())
            // console.log('[initializeMatchTables] pre-getAll arrIndex1 = ' + arrIndex1)

            // Tournaments.TournamentMatchSetDataService.getAll('kamp_saet_saet:asc', null, 'kamp_id.id=' + Number(tempTournamentMatchData[matchNumberIndex].id).toString() + '&kamp_saet_saet=' + this.matchSettlementPlayerMatchSetResults[arrIndex2].matchSet.toString() + '&kamp_saet_hjem_ud=' + this.matchSettlementPlayerMatchSetResults[arrIndex2].matchHomeOrGuestTeam)
            Tournaments.TournamentMatchSetDataService.getAll('kamp_saet_saet:asc', null, 'kamp_id.id=' + Number(tempTournamentMatchData[matchNumberIndex].id).toString())
              .then((response) => {
                // const tempArrIndex1 = arrIndex1
                let tempTournamentMatchSetsData: SysTournamentMatchSet[] = []
                tempTournamentMatchSetsData = response.data
                // console.log('[initializeMatchTables] tempArrIndex1 = ' + tempArrIndex1)
                console.log('[initializeMatchTables] Tournament match sets data: ' + JSON.stringify(response.data))

                for (let arrIndex2 = 0; arrIndex2 < this.matchSettlementNumberOfSetsPerMatch * 2;) {
                  const matchSetArrayIndex = tempArrIndex1 * this.matchSettlementNumberOfSetsPerMatch * 2 + arrIndex2
                  // console.log('[initializeMatchTables] matchSetArrayIndex = ' + matchSetArrayIndex)
                  // console.log('[initializeMatchTables] tempArrIndex1 = ' + tempArrIndex1)
                  this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId = (tempTournamentMatchData[matchNumberIndex].id === null ? 0 : Number(tempTournamentMatchData[matchNumberIndex].id))
                  this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchIndexNumber = (tempArrIndex1 + 1)
                  console.log('[initializeMatchTables] Checking for match Id : ' + this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId)

                  const matchSetIndex2 = tempTournamentMatchSetsData.findIndex(x => (x.kamp_saet_saet === this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet && x.kamp_saet_hjem_ud === this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam))

                  console.log('[initializeMatchTables] matchSetIndex2 = ' + matchSetIndex2)

                  if (matchSetIndex2 === -1) {
                    const createTournamentMatchSetData = {
                      kamp_id: { id: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId.toString() },
                      kamp_saet_dart: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart,
                      kamp_saet_lukket: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed,
                      kamp_saet_restscore: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetRemainScore,
                      kamp_saet_saet: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet,
                      kamp_saet_hjem_ud: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam
                    }

                    console.log('[initializeMatchTables] createTournamentMatchSetData = ' + JSON.stringify(createTournamentMatchSetData))

                    Tournaments.TournamentMatchSetDataService.create(createTournamentMatchSetData)
                      .then((response) => {
                        this.lastCreatedTournamentMatchSetId = response.data.id
                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false) {
                          this.matchSettlementNumberOfPresentMatchesSetsCreated++
                        }
                        console.log('[initializeMatchTables] Created match set data:' + JSON.stringify(response.data))
                        console.log('[initializeMatchTables] Created match set so far: ' + this.matchSettlementNumberOfPresentMatchesSetsCreated)

                        return true
                      })
                      .catch((err) => {
                        // this.error = err
                        console.log('[initializeMatchTables] Error retrieving relevant match set item for tournament match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString() + ' with match number: ' + (arrIndex1 + 1).toString())
                        console.log('[initializeMatchTables] Error message: ' + err)

                        return false
                      })
                      // .finally(() => {
                      // })
                  } else {
                    console.log('[initializeMatchTables] Match set data was already created.')
                    if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false) {
                      this.matchSettlementNumberOfPresentMatchesSetsCreated++
                    }
                    console.log('[initializeMatchTables] Created match set so far: ' + this.matchSettlementNumberOfPresentMatchesSetsCreated)

                    // this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId = (tempTournamentMatchSetsData[matchSetIndex2].kamp_id.id === null ? 0 : Number(tempTournamentMatchSetsData[matchSetIndex2].kamp_id.id))
                    this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart = tempTournamentMatchSetsData[matchSetIndex2].kamp_saet_dart
                    this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed = tempTournamentMatchSetsData[matchSetIndex2].kamp_saet_lukket
                    this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetRemainScore = tempTournamentMatchSetsData[matchSetIndex2].kamp_saet_restscore
                    // this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet = tempTournamentMatchSetsData[matchSetIndex2].kamp_saet_saet
                  }

                  arrIndex2++
                }

                return true
              })
              .catch((err) => {
                // this.error = err
                console.log('[initializeMatchTables] Error creating match set item for tournament match settlement (LAST): ' + Number(this.tempTournamentMatchSettlement.id).toString() + ' with match number: ' + (arrIndex1 + 1).toString())
                console.log('[initializeMatchTables] Error message: ' + err)

                return false
              })
          }

          arrIndex1++
        }
      })
      .catch((err) => {
        // this.error = err
        console.log('[initializeMatchTables] Error retrieving relevant match item for tournament match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString())
        console.log('[initializeMatchTables] Error message: ' + err)

        return false
      })

    return true
  }

  public updateTournamentSettlementMatchSetTables (onlyDirtyRowData = true) : boolean {
    console.log('[updateTournamentSettlementMatchSetTables] Update match set database tables of the match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString())
    this.totalResultHome = 0
    this.totalResultGuest = 0
    this.tournamentMatchResultsCalcProgress = 0

    Tournaments.TournamentMatchDataService.getAll('kamp_nummer:asc', null, 'kampafvikling_id.id=' + Number(this.tempTournamentMatchSettlement.id).toString())
      .then((response) => {
        let tempTournamentMatchData: SysTournamentMatch[] = []
        tempTournamentMatchData = response.data

        console.log('[updateTournamentSettlementMatchSetTables] Tournament matches data: ' + JSON.stringify(response.data))

        // Reset certain statistical match data for each player of each team registered to the match settlement being processed.
        this.tournamentMatchScheduleHomeTeamPlayersInfoData.forEach(function (item) { item.matchesWon = 0; item.matchSetsWon = 0; item.matchSetsLost = 0; item.matchSetHighestClosing = 0; item.matchSetFastestDarting = 0 })
        this.tournamentMatchScheduleGuestTeamPlayersInfoData.forEach(function (item) { item.matchesWon = 0; item.matchSetsWon = 0; item.matchSetsLost = 0; item.matchSetHighestClosing = 0; item.matchSetFastestDarting = 0 })

        for (let arrIndex1 = 0; arrIndex1 < this.matchSettlementNumberOfMatches;) {
          const tempArrIndex1 = arrIndex1
          const matchNumberIndex = tempTournamentMatchData.findIndex(x => x.kamp_nummer === (arrIndex1 + 1))

          if (matchNumberIndex > -1) {
            console.log('[updateTournamentSettlementMatchSetTables] Match data item exists.')

            // Handle adjustments of the total score result for situations, where a team loses a match, because the number of players in that team is less than the number of players of the opposing team.
            const indexMatchHomePlayer = this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.findIndex(x => Number(x.kampafvikling_spiller_indeks) === this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam)
            const indexMatchGuestPlayer = this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.findIndex(x => Number(x.kampafvikling_spiller_indeks) === this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam)
            const indexMatchHomePlayer2 = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.findIndex(x => Number(x.kampafvikling_spiller_indeks) === this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam) : -1)
            const indexMatchGuestPlayer2 = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.findIndex(x => Number(x.kampafvikling_spiller_indeks) === this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam) : -1)
            // console.log('[updateTournamentSettlementMatchSetTables] playerIndexHomeTeam / playerIndexGuestTeam = ' + this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam.toString() + ' / ' + this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam.toString())
            // console.log('[updateTournamentSettlementMatchSetTables] kampafvikling_ekstras_id[] = ' + JSON.stringify(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id))
            // console.log('[updateTournamentSettlementMatchSetTables] indexMatchHomePlayer / indexMatchGuestPlayer = ' + indexMatchHomePlayer.toString() + ' / ' + indexMatchGuestPlayer.toString())

            if (indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1) {
              if (((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === false) ||
                (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === false)) {
                console.log('[updateTournamentSettlementMatchSetTables] Adjust total results because of skipped match. (Home team wins that match.) [' + (tempArrIndex1 + 1).toString() + ']')

                this.totalResultHome++
              }
              if (((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === false) ||
                (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === false)) {
                console.log('[updateTournamentSettlementMatchSetTables] Adjust total results because of skipped match. (Guest team wins that match.)' + (tempArrIndex1 + 1).toString() + ']')

                this.totalResultGuest++
              }
            }

            // Tournaments.TournamentMatchSetDataService.getAll('kamp_saet_saet:asc', null, 'kamp_id.id=' + Number(tempTournamentMatchData[matchNumberIndex].id).toString() + '&kamp_saet_saet=' + this.matchSettlementPlayerMatchSetResults[arrIndex2].matchSet.toString() + '&kamp_saet_hjem_ud=' + this.matchSettlementPlayerMatchSetResults[arrIndex2].matchHomeOrGuestTeam)
            Tournaments.TournamentMatchSetDataService.getAll('kamp_saet_saet:asc', null, 'kamp_id.id=' + Number(tempTournamentMatchData[matchNumberIndex].id).toString())
              .then((response) => {
                // const tempArrIndex1 = arrIndex1
                let tempTournamentMatchSetsData: SysTournamentMatchSet[] = []
                tempTournamentMatchSetsData = response.data
                // console.log('[initializeMatchTables] tempArrIndex1 = ' + tempArrIndex1)
                console.log('[updateTournamentSettlementMatchSetTables] Tournament match sets data: ' + JSON.stringify(response.data))
                let countMatchSetResultHome = 0
                let countMatchSetResultGuest = 0
                let tmpCountMatchSetResultHome = 0
                // let tmpCountMatchSetResultGuest = 0
                // let indexOfTeamPlayerMemberData = -1
                // let indexOfTeamPlayer2MemberData = -1
                let indexOfHomeTeamPlayerMemberData = -1
                let indexOfHomeTeamPlayer2MemberData = -1
                let indexOfGuestTeamPlayerMemberData = -1
                let indexOfGuestTeamPlayer2MemberData = -1
                let matchesWonAdjustmentsExecuteOnlyOncePerMatchFlag = true

                for (let arrIndex2 = 0; arrIndex2 < this.matchSettlementNumberOfSetsPerMatch * 2;) {
                  const matchSetArrayIndex = tempArrIndex1 * this.matchSettlementNumberOfSetsPerMatch * 2 + arrIndex2
                  // this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId = (tempTournamentMatchData[matchNumberIndex].id === null ? 0 : Number(tempTournamentMatchData[matchNumberIndex].id))
                  // this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchIndexNumber = (tempArrIndex1 + 1)
                  console.log('[updateTournamentSettlementMatchSetTables] Checking for match Id : ' + this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId)

                  const matchSetIndex2 = tempTournamentMatchSetsData.findIndex(x => (x.kamp_saet_saet === this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet && x.kamp_saet_hjem_ud === this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam))

                  console.log('[updateTournamentSettlementMatchSetTables] matchSetIndex2 = ' + matchSetIndex2)
                  // console.log('[updateTournamentSettlementMatchSetTables] matchSettlementPlayerMatchOrder[] = ' + JSON.stringify(this.matchSettlementPlayerMatchOrder[tempArrIndex1]))
                  indexOfHomeTeamPlayerMemberData = this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerMemberId))
                  indexOfHomeTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerMemberId)) : -1)
                  indexOfGuestTeamPlayerMemberData = this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerMemberId))
                  indexOfGuestTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerMemberId)) : -1)

                  // Perform some statistics calculations.
                  if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam) {
                    // indexOfTeamPlayerMemberData = this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerMemberId))
                    // indexOfTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerMemberId)) : -1)

                    // if (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].hide === false) {
                    // if (((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === false) || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === false)) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt)) {
                    if (arrIndex2 !== null) {
                      if (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict < 1) && (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict === 1) || (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart > 8 && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > 1))) {
                        // Handle statistic calculation for the number of match set won by player(s).
                        this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsWon += 1
                        // this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsWon += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected ? 1 : 0)
                        this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetsWon = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsWon // This is not used except for debugging purpose.
                        if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble) {
                          // Handle also double match situations.
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsWon += 1
                          // this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsWon += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetsWon = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsWon // This is not used except for debugging purpose.
                        }
                      }
                      // Check if there is set a match verdict against the player(s) from the home team or not.
                      if (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict === 1)) {
                        // There exists a verdict against at least one player.
                        // Handle statistic calculation for the number of match set lost by player(s).
                        if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt)) {
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                        } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === false && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt)) {
                          // Handle also situations, where a player is not selected for the match.
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                        } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt)) {
                          // Handle also double match situations.
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                        }
                      } else {
                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetClosed > 1) {
                          // Handle statistic calculation for the number of match set lost by player(s).
                          if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt)) {
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected && (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict < 1)) && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetClosed > 1) ? 1 : 0)
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                          } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === false && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt)) {
                            // Handle also situations, where a player is not selected for the match.
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected && (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict < 1)) ? 1 : 0)
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                          } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt)) {
                            // Handle also double match situations.
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected && (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict < 1)) && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetClosed > 1) ? 1 : 0)
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerSelected && (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict < 1)) && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex + 1].matchSetClosed > 1) ? 1 : 0)
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                          } /* else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === false && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt)) {
                            // Handle also double match situations, where a player is not selected for the match.
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerSelected ? 1 : 0)
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                            // this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerSelected ? 1 : 0)
                            // this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetsLost = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                          } */
                        }
                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart > 0 && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > 0) {
                          // Handle statistic calculation for the highest closing value in the match by player(s).
                          if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetHighestClosing) {
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed // This is not used except for debugging purpose.
                          }
                          if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetHighestClosing) {
                            // Handle also double match situations.
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed // This is not used except for debugging purpose.
                          }
                        }
                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart > 0 && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > 0) {
                          // Handle statistic calculation for the fastest darting value in the match by player(s).
                          if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart < this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetFastestDarting || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetFastestDarting <= 0) {
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart // This is not used except for debugging purpose.
                          }
                          if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart < this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetFastestDarting || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetFastestDarting <= 0)) {
                            // Handle also double match situations.
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart
                            this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart // This is not used except for debugging purpose.
                          }
                        }
                      }
                    }
                  } else {
                    // indexOfTeamPlayerMemberData = this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerMemberId))
                    // indexOfTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerMemberId)) : -1)
                    // console.log('[TSHOOT] GST check isDouble = ' + this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble)
                    // console.log('[TSHOOT] GST check kampafvikling_spiller_hj_valgt = ' + this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble)
                    // console.log('[TSHOOT] GST check kampafvikling_spiller_ud_valgt = ' + this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble)

                    // if (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].hide === false) {
                    // if ((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && ((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === false) || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === false))) {
                    // if ((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && ((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt) && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble || (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt)))) {
                    if (arrIndex2 !== null) {
                      if (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict < 1) && (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict === 1) || (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart > 8 && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > 1))) {
                        // Handle statistic calculation for the number of match set won by player(s).
                        this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsWon += 1
                        // this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsWon += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected ? 1 : 0)
                        this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetsWon = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsWon // This is not used except for debugging purpose.
                        if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble) {
                          // Handle also double match situations.
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsWon += 1
                          // this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsWon += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchSetsWon = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsWon // This is not used except for debugging purpose.
                        }
                      }
                      // Check if there is set a match verdict against the player(s) from the guest team or not.
                      if (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict === 1)) {
                        // There exists a verdict against at least one player.
                        // Handle statistic calculation for the number of match set lost by player(s).
                        if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt)) {
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                        } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === false) {
                          // Handle also situations, where a player is not selected for the match.
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                        } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt)) {
                          // Handle also double match situations.
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerSelected ? 1 : 0)
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                        }
                      } else {
                        // console.log('[TSHOOT] this.matchSettlementPlayerMatchOrder[tempArrIndex1] = ' + JSON.stringify(this.matchSettlementPlayerMatchOrder[tempArrIndex1]))
                        // console.log('[TSHOOT] tournamentMatchScheduleGuestTeamPlayersInfoData = ' + JSON.stringify(this.tournamentMatchScheduleGuestTeamPlayersInfoData))
                        // console.log('[TSHOOT] matchSettlementPlayerMatchSetResults = ' + JSON.stringify(this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex]))
                        // console.log('[TSHOOT] playerMemberId = ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerMemberId)
                        // console.log('[TSHOOT] indexOfGuestTeamPlayerMemberData = ' + indexOfGuestTeamPlayerMemberData.toString())
                        // console.log('[TSHOOT] Guest player name: ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerName + ' / ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerName)
                        // console.log('[TSHOOT] Guest player hide flag: ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].hide + ' / ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].hide)
                        // console.log('[TSHOOT] at match: ' + (tempArrIndex1 + 1).toString() + ' [SET: ' + Math.ceil((arrIndex2 + 1) / 2).toString() + ']')

                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetClosed > 1) {
                          // Handle statistic calculation for the number of match set lost by player(s).
                          if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt)) {
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected && (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict < 1)) && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetClosed > 1) ? 1 : 0)
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                          } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === false) {
                            // Handle also situations, where a player is not selected for the match.
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected && (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict < 1)) ? 1 : 0)
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                          } else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt)) {
                            // Handle also double match situations.
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected && (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict < 1)) && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetClosed > 1) ? 1 : 0)
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerSelected && (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict < 1)) && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetDart > 8 || this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex - 1].matchSetClosed > 1) ? 1 : 0)
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                          } /* else if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1 && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === false) {
                            // Handle also double match situations, where a player is not selected for the match.
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerSelected ? 1 : 0)
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetsLost // This is not used except for debugging purpose.
                            // this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost += (this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerSelected ? 1 : 0)
                            // this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchSetsLost = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetsLost // This is not used except for debugging purpose.
                          } */
                        }
                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart > 0 && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > 0) {
                          // if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed === 12) {
                          //   console.log('[TSHOOT] ********')
                          // }
                          // Handle statistic calculation for the highest closing value in the match by player(s).
                          if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetHighestClosing) {
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed // This is not used except for debugging purpose.
                          }
                          if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetHighestClosing) {
                            // Handle also double match situations.
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchSetHighestClosing = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed // This is not used except for debugging purpose.
                          }
                        }
                        if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart > 0 && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > 0) {
                          // Handle statistic calculation for the fastest darting value in the match by player(s).
                          if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart < this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetFastestDarting || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetFastestDarting <= 0) {
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart // This is not used except for debugging purpose.
                          }
                          if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart < this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetFastestDarting || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetFastestDarting <= 0)) {
                            // Handle also double match situations.
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart
                            this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchSetFastestDarting = this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart // This is not used except for debugging purpose.
                          }
                        }
                      }
                    }
                  }

                  // Code for calculating matchset subresults win for either home team or guest team in each match. Also make sure to handle the consequences of player verdicts correctly.
                  if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === true && (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict === 1))) {
                    // Skip doing anything, if the player(s) of the opponent team also has a verdict against them.
                    if (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict < 1)) {
                      countMatchSetResultGuest++
                      console.log('[updateTournamentSettlementMatchSetTables:home] Verdic against home team player (increasing away team player set result)! Current match set now at [Home - Away] = ' + countMatchSetResultHome.toString() + ' - ' + countMatchSetResultGuest.toString())
                    }
                  } else if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false && (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict === 1))) {
                    // Skip doing anything, if the player(s) of the opponent team also has a verdict against them.
                    if (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict < 1 && (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === false || this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict < 1)) {
                      countMatchSetResultHome++
                      console.log('[updateTournamentSettlementMatchSetTables:away] Verdic against away team player (increasing home team player set result)! Current match set now at [Home - Away] = ' + countMatchSetResultHome.toString() + ' - ' + countMatchSetResultGuest.toString())
                    }
                  } else if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart > 0 && this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed > 1) {
                    if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam) {
                      // Skip doing anything, if the away team player(s) has a verdict against themself, as the result in that case should already be handled in the previous if-else statements just before this if-else statement.
                      if (!(this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].playerVerdict === 1))) {
                        countMatchSetResultHome++
                      }
                    } else {
                      // Skip increasing the result if the home team player(s) has a verdict against themself, as the result in that case should already be handled in the previous if-else statements just before this if-else statement.
                      if (!(this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict === 1 || (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble === true && this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].playerVerdict === 1))) {
                        countMatchSetResultGuest++
                      }
                    }
                  }

                  // Handle total score calculation in the situation where there is only two player (one per team).
                  // if (this.matchSettlementNumberOfMatches === 1 && this.tournamentRowData.numberOfPlayers === 1) {
                  if (this.matchSettlementNumberOfMatches === 1) {
                    if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false) {
                      // If the sum of match sets of each player is equal to the maximum number of match set possible in the match, then set a score for the entire match according to who won most match set. In any other case set the score to be 0 - 0 .
                      if ((countMatchSetResultGuest + tmpCountMatchSetResultHome) === this.matchSettlementNumberOfSetsPerMatch || (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict === 1 && this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict === 1)) {
                        if (countMatchSetResultGuest > tmpCountMatchSetResultHome) {
                          this.totalResultHome = (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict === 1 ? 1 : 0)
                          this.totalResultGuest = (this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerVerdict === 1 ? 0 : 1)
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon = tmpCountMatchSetResultHome
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchesWon = countMatchSetResultGuest
                        } else {
                          this.totalResultHome = (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict === 1 ? 0 : 1)
                          this.totalResultGuest = (this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerVerdict === 1 ? 1 : 0)
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon = tmpCountMatchSetResultHome
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchesWon = countMatchSetResultGuest
                        }
                      } else {
                        this.totalResultHome = 0
                        this.totalResultGuest = 0
                        this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon = 0
                        this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchesWon = 0
                      }
                    } else {
                      tmpCountMatchSetResultHome = countMatchSetResultHome
                    }
                  } else {
                    // Code for calculating the total match settlement result for the home and guest teams based upon all the calculated matchset subresults wins.
                    // if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam && arrIndex2 >= (this.matchSettlementNumberOfSetsPerMatch * 2 - 2) && countMatchSetResultHome > (this.matchSettlementNumberOfSetsPerMatch / 2)) {
                    if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam && arrIndex2 >= (this.matchSettlementNumberOfSetsPerMatch * 2 - 2) && countMatchSetResultHome === this.matchSettlementNumberOfSetsPerMatch) {
                      // if (this.matchSettlementNumberOfMatches === 1) {
                      //   this.totalResultHome = countMatchSetResultHome
                      // } else {
                      //   this.totalResultHome++
                      // }
                      this.totalResultHome++
                      countMatchSetResultHome = 0

                      // Handle statistic calculation for the number of match set won by player(s).
                      // indexOfTeamPlayerMemberData = this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerMemberId))
                      // indexOfTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerMemberId)) : -1)
                      this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon += 1
                      this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchesWon = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon
                      if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble) {
                        // Handle also double match situations.
                        this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchesWon += 1
                        this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchesWon = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchesWon
                      }
                      console.log('[updateTournamentSettlementMatchSetTables:home] Match ' + (tempArrIndex1 + 1) + ' [Set: ' + Math.ceil((arrIndex2 + 1) / 2) + '] won by ' + this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].playerName + ' / ' + this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerName + ' (ID: ' + this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerMemberId + ')')
                    }
                    // if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false && arrIndex2 >= (this.matchSettlementNumberOfSetsPerMatch * 2 - 1) && countMatchSetResultGuest > (this.matchSettlementNumberOfSetsPerMatch / 2)) {
                    if (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam === false && arrIndex2 >= (this.matchSettlementNumberOfSetsPerMatch * 2 - 1) && countMatchSetResultGuest === this.matchSettlementNumberOfSetsPerMatch) {
                      // if (this.matchSettlementNumberOfMatches === 1) {
                      //   this.totalResultGuest = countMatchSetResultGuest
                      // } else {
                      //   this.totalResultGuest++
                      // }
                      this.totalResultGuest++
                      countMatchSetResultGuest = 0

                      // Handle statistic calculation for the number of match set won by player(s).
                      // indexOfTeamPlayerMemberData = this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerMemberId))
                      // indexOfTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerMemberId)) : -1)
                      this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchesWon += 1
                      this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchesWon = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchesWon
                      if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble) {
                        // Handle also double match situations.
                        this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchesWon += 1
                        this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchesWon = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchesWon
                      }
                      console.log('[updateTournamentSettlementMatchSetTables:guest] Match ' + (tempArrIndex1 + 1) + ' [Set: ' + (arrIndex2 + 1) / 2 + '] won by ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].playerName + ' / ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerName + ' (ID: ' + this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerMemberId + ')')
                    }

                    // Handle the match score result adjustments of a player for situations, where a team loses a match, because the number of players in that team is less than the number of players of the opposing team.
                    if (matchesWonAdjustmentsExecuteOnlyOncePerMatchFlag && indexMatchHomePlayer > -1 && indexMatchGuestPlayer > -1) {
                      if (((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === false) ||
                        (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === false)) {
                        console.log('[updateTournamentSettlementMatchSetTables] Adjust the match score result of the player because of skipped match. (Home team wins that match.) [' + (tempArrIndex1 + 1).toString() + ']')

                        // Handle statistic calculation for the number of match set won by player(s).
                        // indexOfTeamPlayerMemberData = this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].playerMemberId))
                        // indexOfTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleHomeTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].playerMemberId)) : -1)
                        this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon += 1
                        this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexHomeTeam - 1)].matchesWon = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon
                        if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble) {
                          // Handle also double match situations.
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayer2MemberData].matchesWon += 1
                          this.tournamentMatchScheduleHomeTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2HomeTeam - 1)].matchesWon = this.tournamentMatchScheduleHomeTeamPlayersInfoData[indexOfHomeTeamPlayerMemberData].matchesWon
                        }
                      }
                      if (((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer].kampafvikling_spiller_ud_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer].kampafvikling_spiller_hj_valgt === false) ||
                        (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble && indexMatchHomePlayer2 > -1 && indexMatchGuestPlayer2 > -1 && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchGuestPlayer2].kampafvikling_spiller_ud_valgt) && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexMatchHomePlayer2].kampafvikling_spiller_hj_valgt === false)) {
                        console.log('[updateTournamentSettlementMatchSetTables] Adjust match score result of the player because of skipped match. (Guest team wins that match.)' + (tempArrIndex1 + 1).toString() + ']')

                        // Handle statistic calculation for the number of match set won by player(s).
                        // indexOfTeamPlayerMemberData = this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].playerMemberId))
                        // indexOfTeamPlayer2MemberData = (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble ? this.tournamentMatchScheduleGuestTeamPlayersInfoData.findIndex(x => Number(x.playerMemberId) === Number(this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].playerMemberId)) : -1)
                        this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchesWon += 1
                        this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndexGuestTeam - 1)].matchesWon = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayerMemberData].matchesWon
                        if (this.matchSettlementPlayerMatchOrder[tempArrIndex1].isDouble) {
                          // Handle also double match situations.
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchesWon += 1
                          this.tournamentMatchScheduleGuestTeamPlayersInfoData[(this.matchSettlementPlayerMatchOrder[tempArrIndex1].playerIndex2GuestTeam - 1)].matchesWon = this.tournamentMatchScheduleGuestTeamPlayersInfoData[indexOfGuestTeamPlayer2MemberData].matchesWon
                        }
                      }

                      matchesWonAdjustmentsExecuteOnlyOncePerMatchFlag = false
                    }
                  }

                  if (matchSetIndex2 > -1 && (onlyDirtyRowData === false || (this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDirtyFlag & (1 + 2 + 4)) === 4)) {
                    const updateTournamentMatchSetData = {
                      kamp_id: { id: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchId.toString() },
                      kamp_saet_dart: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDart,
                      kamp_saet_lukket: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetClosed,
                      kamp_saet_restscore: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetRemainScore,
                      kamp_saet_saet: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSet,
                      kamp_saet_hjem_ud: this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchHomeOrGuestTeam
                    }

                    console.log('[updateTournamentSettlementMatchSetTables] updateTournamentMatchSetData = ' + JSON.stringify(updateTournamentMatchSetData))

                    Tournaments.TournamentMatchSetDataService.update(Number(tempTournamentMatchSetsData[matchSetIndex2].id).toString(), updateTournamentMatchSetData)
                      .then((response) => {
                        // this.lastUpdateTournamentMatchSetId = response.data.id
                        console.log('[updateTournamentSettlementMatchSetTables] Updated match set data:' + JSON.stringify(response.data))
                        this.matchSettlementPlayerMatchSetResults[matchSetArrayIndex].matchSetDirtyFlag = 0
                      })
                      .catch((err) => {
                        // this.error = err
                        console.log('[updateTournamentSettlementMatchSetTables] Error retrieving relevant match set item for tournament match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString() + ' with match number: ' + (arrIndex1 + 1).toString())
                        console.log('[updateTournamentSettlementMatchSetTables] Error message: ' + err)
                      })
                      .finally(() => {
                        return true
                      })
                  }

                  arrIndex2++
                }

                return true
              })
              .catch((err) => {
                // this.error = err
                console.log('[updateTournamentSettlementMatchSetTables] Error creating match set item for tournament match settlement (LAST): ' + Number(this.tempTournamentMatchSettlement.id).toString() + ' with match number: ' + (arrIndex1 + 1).toString())
                console.log('[updateTournamentSettlementMatchSetTables] Error message: ' + err)

                return true
              })
              .finally(() => {
                this.tournamentMatchResultsCalcProgress++

                return true
              })
          }

          arrIndex1++
        }

        this.updateTournamentSettlementMatch180()
      })
      .catch((err) => {
        // this.error = err
        console.log('[updateTournamentSettlementMatchSetTables] Error retrieving relevant match item for tournament match settlement: ' + Number(this.tempTournamentMatchSettlement.id).toString())
        console.log('[updateTournamentSettlementMatchSetTables] Error message: ' + err)

        return false
      })

    return true
  }

  public updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult (indexNumber: number, mSet: number, homeOrGuestTeam: boolean, checkSetClosedDartValues = false, setDart = '0', setClosed = '0', setRemainScore = '0') : void {
    console.log('[updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult] indexNumber = ' + indexNumber + ' / mSet = ' + mSet + ' / homeOrGuestTeam = ' + homeOrGuestTeam)

    for (const matchSettlementPlayerMatchSetResultsObjItem of this.matchSettlementPlayerMatchSetResults) {
      if (matchSettlementPlayerMatchSetResultsObjItem.matchIndexNumber === indexNumber && matchSettlementPlayerMatchSetResultsObjItem.matchSet === mSet && matchSettlementPlayerMatchSetResultsObjItem.matchHomeOrGuestTeam === homeOrGuestTeam) {
        matchSettlementPlayerMatchSetResultsObjItem.matchSetDart = Math.round(Number(matchSettlementPlayerMatchSetResultsObjItem.matchSetDart.toString().trim()))
        matchSettlementPlayerMatchSetResultsObjItem.matchSetClosed = Math.round(Number(matchSettlementPlayerMatchSetResultsObjItem.matchSetClosed.toString().trim()))
        matchSettlementPlayerMatchSetResultsObjItem.matchSetRemainScore = Math.round(Number(matchSettlementPlayerMatchSetResultsObjItem.matchSetRemainScore.toString().trim()))

        // Check for some values that are invalid for the match set dart field.
        if (checkSetClosedDartValues && (Number(setDart) < 9 || Number(setDart) > 2505) && Number(setDart) !== 0) {
          matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag |= 1 // Set bit 0
        } else {
          matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag = matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag & (255 - 1) // Reset bit 0
        }

        // Check for some values that are invalid for the match set closed field.
        if (checkSetClosedDartValues && (Number(setClosed) < 0 || Number(setClosed) === 1 || Number(setClosed) > 170 || Number(setClosed) === 169 || Number(setClosed) === 168 || Number(setClosed) === 166 || Number(setClosed) === 165 || Number(setClosed) === 163 || Number(setClosed) === 162 || Number(setClosed) === 159)) {
          matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag |= 2 // Set bit 1
        } else {
          matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag = matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag & (255 - 2) // Reset bit 1
        }

        // Check for some values that are invalid for the match set remaider score field.
        if (checkSetClosedDartValues && (Number(setRemainScore) < 0 || Number(setRemainScore) > 501) && Number(setRemainScore) !== 0) {
          matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag |= 8 // Set bit 5
        } else {
          matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag = matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag & (255 - 8) // Reset bit 0
        }

        matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag |= 4 // Set bit 2

        // console.log('[updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult] setDart = ' + setDart)
        // console.log('[updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult] setClosed = ' + setClosed)
        // console.log('[updateDirtyFlagFieldOfMatchSettlementPlayerMatchSetResult] matchSetDirtyFlag = ' + matchSettlementPlayerMatchSetResultsObjItem.matchSetDirtyFlag)
      }
    }
  }

  public updateTournamentSettlementMatch180 () : boolean {
    for (let arrIndex = 0; arrIndex < (this.tournamentMatchScheduleHomeTeamPlayersInfoData.length + this.tournamentMatchScheduleGuestTeamPlayersInfoData.length);) {
      const tempArrayIndex = arrIndex

      Tournaments.TournamentMatch180DataService.getAll('', null, 'kampprogram_id=' + Number(this.lastEditedTournamentMatchScheduleId).toString() + '&medlem_id=' + Number(tempArrayIndex < this.tournamentMatchScheduleHomeTeamPlayersInfoData.length ? this.tournamentMatchScheduleHomeTeamPlayersInfoData[tempArrayIndex].playerMemberId : this.tournamentMatchScheduleGuestTeamPlayersInfoData[tempArrayIndex - this.tournamentMatchScheduleHomeTeamPlayersInfoData.length].playerMemberId).toString())
        .then((response) => {
          let tempTournamentMatchOneEightyData: SysTournamentMatch180[] = []
          tempTournamentMatchOneEightyData = response.data

          if (tempTournamentMatchOneEightyData.length > 0 && tempTournamentMatchOneEightyData[0].id !== undefined && tempTournamentMatchOneEightyData[0].id !== null) {
            const updateTournamentMatchOneEighty = {
              kampprogram_id: this.lastEditedTournamentMatchScheduleId.toString(),
              medlem_id: (tempArrayIndex < this.tournamentMatchScheduleHomeTeamPlayersInfoData.length ? this.tournamentMatchScheduleHomeTeamPlayersInfoData[tempArrayIndex].playerMemberId : this.tournamentMatchScheduleGuestTeamPlayersInfoData[tempArrayIndex - this.tournamentMatchScheduleHomeTeamPlayersInfoData.length].playerMemberId).toString(),
              kamp_180_antal: (tempArrayIndex < this.tournamentMatchScheduleHomeTeamPlayersInfoData.length ? this.tournamentMatchScheduleHomeTeamPlayersInfoData[tempArrayIndex].match180 : this.tournamentMatchScheduleGuestTeamPlayersInfoData[tempArrayIndex - this.tournamentMatchScheduleHomeTeamPlayersInfoData.length].match180).toString()
            }

            console.log('[updateTournamentSettlementMatch180] updateTournamentMatchOneEighty = ' + JSON.stringify(updateTournamentMatchOneEighty))

            Tournaments.TournamentMatch180DataService.update(Number(tempTournamentMatchOneEightyData[0].id).toString(), updateTournamentMatchOneEighty)
              .then((response) => {
                // this.lastUpdatedTournamentMatchOneEightyId = response.data.id
                console.log(response.data)

                return true
              })
              .catch((err) => {
                this.error = err
                // console.log(err)

                return true
              })
          } else {
            const createTournamentMatchOneEighty = {
              kampprogram_id: this.lastEditedTournamentMatchScheduleId.toString(),
              medlem_id: (tempArrayIndex < this.tournamentMatchScheduleHomeTeamPlayersInfoData.length ? this.tournamentMatchScheduleHomeTeamPlayersInfoData[tempArrayIndex].playerMemberId : this.tournamentMatchScheduleGuestTeamPlayersInfoData[tempArrayIndex - this.tournamentMatchScheduleHomeTeamPlayersInfoData.length].playerMemberId).toString(),
              kamp_180_antal: (tempArrayIndex < this.tournamentMatchScheduleHomeTeamPlayersInfoData.length ? this.tournamentMatchScheduleHomeTeamPlayersInfoData[tempArrayIndex].match180 : this.tournamentMatchScheduleGuestTeamPlayersInfoData[tempArrayIndex - this.tournamentMatchScheduleHomeTeamPlayersInfoData.length].match180).toString()
            }

            console.log('[updateTournamentSettlementMatch180] createTournamentMatchOneEighty = ' + JSON.stringify(createTournamentMatchOneEighty))

            Tournaments.TournamentMatch180DataService.create(createTournamentMatchOneEighty)
              .then((response) => {
                // this.lastCreatedTournamentMatchOneEightyId = response.data.id
                console.log(response.data)

                return true
              })
              .catch((err) => {
                this.error = err
                // console.log(err)

                return true
              })
          }
        })
        .catch((err) => {
          // this.error = err
          console.log('[updateTournamentSettlementMatch180] Error retrieving tournament match settlement match 180 data from the API for match schedule Id: ' + Number(this.lastEditedTournamentMatchScheduleId).toString() + ' / Array index: ' + arrIndex)
          console.log('[updateTournamentSettlementMatch180] Error message: ' + err)

          return true
        })

      arrIndex++
    }

    return false
  }

  public isNumber (evt: KeyboardEvent) : void {
    const keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']
    const keyPressed: string = evt.key

    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault()
    }
  }

  public getTournamentMatchSettlementPlayerMatchSetResultThroughIndex (indexNumber: number) : { matchId: number; matchIndexNumber: number; matchSetDart: number; matchSetClosed: number; matchSetRemainScore: number; matchSet: number; matchHomeOrGuestTeam: boolean; matchSetDirtyFlag: number }[] {
    const retVal: { matchId: number; matchIndexNumber: number; matchSetDart: number; matchSetClosed: number; matchSetRemainScore: number; matchSet: number; matchHomeOrGuestTeam: boolean; matchSetDirtyFlag: number }[] = []
    // console.log('[getTournamentMatchSettlementPlayerMatchSetResultThroughIndex] matchSettlementPlayerMatchSetResults = ' + JSON.stringify(this.matchSettlementPlayerMatchSetResults))

    for (const matchSettlementPlayerMatchSetResultsObjItem of this.matchSettlementPlayerMatchSetResults) {
      if (matchSettlementPlayerMatchSetResultsObjItem.matchIndexNumber === indexNumber) {
        retVal.push(matchSettlementPlayerMatchSetResultsObjItem)
      }
    }
    // console.log('[getTournamentMatchSettlementPlayerMatchSetResultThroughIndex] return value [' + indexNumber + '] = ' + JSON.stringify(retVal))

    return retVal
  }

  public getTournamentMatchPlayersRowsData () : { matchRealIndexNumber: number, matchHomeTeamPlayer: string; matchHomeTeamPlayer2: string; matchHomeTeamPlayerName: string; matchHomeTeamPlayer2Name: string; matchGuestTeamPlayer: string; matchGuestTeamPlayer2: string; matchGuestTeamPlayerName: string; matchGuestTeamPlayer2Name: string; matchHomeScoreResultRecorder: string | null; matchGuestScoreResultRecorder: string | null; matchIsDouble: boolean }[] | null {
    const retVal: any = []

    for (let arrIndex = 0; arrIndex < this.matchSettlementNumberOfMatches; arrIndex++) {
      const indexHomeTeamPlayerInMatchSettlementExt = (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id).findIndex(x => Number(x.kampafvikling_spiller_indeks) === Number(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexHomeTeam))
      const indexGuestTeamPlayerInMatchSettlementExt = (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id).findIndex(x => Number(x.kampafvikling_spiller_indeks) === Number(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexGuestTeam))
      const indexHomeTeamPlayerResultRecorderInMatchSettlementExt = (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id).findIndex(x => Number(x.kampafvikling_spiller_indeks) === Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome))
      const indexGuestTeamPlayerResultRecorderInMatchSettlementExt = (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id).findIndex(x => Number(x.kampafvikling_spiller_indeks) === Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest))
      let indexHomeTeamPlayer2InMatchSettlementExt = -1
      let indexGuestTeamPlayer2InMatchSettlementExt = -1

      if (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble === true) {
        indexHomeTeamPlayer2InMatchSettlementExt = (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id).findIndex(x => Number(x.kampafvikling_spiller_indeks) === Number(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2HomeTeam))
        indexGuestTeamPlayer2InMatchSettlementExt = (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id).findIndex(x => Number(x.kampafvikling_spiller_indeks) === Number(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2GuestTeam))
      }
      // console.log('[getTournamentMatchPlayersRowData] tempTournamentMatchSettlement = ' + JSON.stringify(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id))
      // console.log('[getTournamentMatchPlayersRowData] indexHomeTeamPlayerInMatchSettlementExt = ' + indexHomeTeamPlayerInMatchSettlementExt)
      // console.log('[getTournamentMatchPlayersRowData] indexGuestTeamPlayerInMatchSettlementExt = ' + indexGuestTeamPlayerInMatchSettlementExt)
      // console.log('[getTournamentMatchPlayersRowData] indexHomeTeamPlayer2InMatchSettlementExt = ' + indexHomeTeamPlayer2InMatchSettlementExt)
      // console.log('[getTournamentMatchPlayersRowData] indexGuestTeamPlayer2InMatchSettlementExt = ' + indexGuestTeamPlayer2InMatchSettlementExt)
      // console.log('[getTournamentMatchPlayersRowData] matchSettlementPlayerMatchOrder[' + arrIndex.toString() + '].isDouble = ' + this.matchSettlementPlayerMatchOrder[arrIndex].isDouble)
      // if (indexHomeTeamPlayerInMatchSettlementExt > -1) {
      //   console.log('[getTournamentMatchPlayersRowData] kampafvikling_spiller_hj_valgt = ' + this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt)
      // }
      // if (indexGuestTeamPlayerInMatchSettlementExt > -1) {
      //   console.log('[getTournamentMatchPlayersRowData] kampafvikling_spiller_ud_valgt = ' + this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt)
      // }

      if (indexHomeTeamPlayerInMatchSettlementExt > -1 && indexGuestTeamPlayerInMatchSettlementExt > -1 && (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble === false || (indexHomeTeamPlayer2InMatchSettlementExt > -1 && indexGuestTeamPlayer2InMatchSettlementExt > -1))) {
        if (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt) {
          const indexHomeTeamPlayerInMembers = this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => x.id === this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj)
          const indexGuestTeamPlayerInMembers = this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => x.id === this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud)
          const indexHomePlayerResultRecorderInMembers = (indexHomeTeamPlayerResultRecorderInMatchSettlementExt >= 0 ? this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => x.id === this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerResultRecorderInMatchSettlementExt].kampafvikling_spiller_hj) : -1)
          const indexGuestPlayerResultRecorderInMembers = (indexGuestTeamPlayerResultRecorderInMatchSettlementExt >= 0 ? this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => x.id === this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerResultRecorderInMatchSettlementExt].kampafvikling_spiller_ud) : -1)
          let indexHomeTeamPlayer2InMembers = -1
          let indexGuestTeamPlayer2InMembers = -1

          if (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble === true) {
            indexHomeTeamPlayer2InMembers = this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => x.id === this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj)
            indexGuestTeamPlayer2InMembers = this.tempTournamentMatchSettlementPlayersMemberData.findIndex(x => x.id === this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud)
          }

          console.log('[getTournamentMatchPlayersRowData] Processing: Match = ' + arrIndex.toString() + ' ( Hometeam player: ' + this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexHomeTeam.toString() + ' - ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayerInMembers].user_id.firstname + ' VS guestteam player: ' + String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexGuestTeam + 64) + ' - ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayerInMembers].user_id.lastname + ' )')

          if (indexHomeTeamPlayerInMembers > -1 && indexGuestTeamPlayerInMembers > -1 && (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble === false || (indexHomeTeamPlayer2InMembers > -1 && indexGuestTeamPlayer2InMembers > -1))) {
            if (((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt === false) || (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt === false)) && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt)) {
              retVal.push({
                matchRealIndexNumber: arrIndex,
                matchHomeTeamPlayer: (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt ? this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexHomeTeam.toString() : '9'),
                matchHomeTeamPlayer2: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt) ? (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2HomeTeam.toString() : '9') : '9'),
                matchHomeTeamPlayerName: (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayerInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayerInMembers].user_id.lastname : 'TestHomePlayerName'),
                matchHomeTeamPlayer2Name: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt) ? (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayer2InMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayer2InMembers].user_id.lastname : 'TestHomePlayer2Name') : 'TestHomePlayer2Name'),
                matchGuestTeamPlayer: String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexGuestTeam + 64),
                matchGuestTeamPlayer2: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt !== false) ? String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2GuestTeam + 64) : 'Z'),
                matchGuestTeamPlayerName: this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayerInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayerInMembers].user_id.lastname,
                matchGuestTeamPlayer2Name: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_hj_valgt !== false) ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayer2InMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayer2InMembers].user_id.lastname : 'TestGuestPlayer2Name'),
                matchHomeScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome === null || (indexHomePlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome).toString())),
                matchGuestScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest === null || (indexGuestPlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest).toString())),
                matchIsDouble: this.matchSettlementPlayerMatchOrder[arrIndex].isDouble
              })
            } else if ((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt) && ((this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt === false) || (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt === false))) {
              retVal.push({
                matchRealIndexNumber: arrIndex,
                matchHomeTeamPlayer: this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexHomeTeam.toString(),
                matchHomeTeamPlayer2: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt !== false) ? this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2HomeTeam.toString() : '9'),
                matchHomeTeamPlayerName: this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayerInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayerInMembers].user_id.lastname,
                matchHomeTeamPlayer2Name: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt !== false) ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayer2InMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayer2InMembers].user_id.lastname : 'TestHomePlayer2Name'),
                matchGuestTeamPlayer: (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt ? String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexGuestTeam + 64) : 'Z'),
                matchGuestTeamPlayer2: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt) ? (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2GuestTeam + 64) : 'Z') : 'Z'),
                matchGuestTeamPlayerName: (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayerInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayerInMembers].user_id.lastname : 'TestGuestPlayerName'),
                matchGuestTeamPlayer2Name: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble && (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt === null || this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayer2InMatchSettlementExt].kampafvikling_spiller_ud_valgt) ? (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayer2InMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayer2InMembers].user_id.lastname : 'TestGuestPlayer2Name') : 'TestGuestPlayer2Name'),
                matchHomeScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome === null || (indexHomePlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome).toString())),
                matchGuestScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest === null || (indexGuestPlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest).toString())),
                matchIsDouble: this.matchSettlementPlayerMatchOrder[arrIndex].isDouble
              })
            } else if (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexHomeTeamPlayerInMatchSettlementExt].kampafvikling_spiller_hj_valgt === false && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt !== null && this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexGuestTeamPlayerInMatchSettlementExt].kampafvikling_spiller_ud_valgt === false) {
              retVal.push({
                matchRealIndexNumber: arrIndex,
                matchHomeTeamPlayer: '9',
                matchHomeTeamPlayer2: '9',
                matchHomeTeamPlayerName: 'TestHomePlayerName',
                matchHomeTeamPlayer2Name: 'TestHomePlayer2Name',
                matchGuestTeamPlayer: 'Z',
                matchGuestTeamPlayer2: 'Z',
                matchGuestTeamPlayerName: 'TestGuestPlayerName',
                matchGuestTeamPlayer2Name: 'TestGuestPlayer2Name',
                matchHomeScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome === null || (indexHomePlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome).toString())),
                matchGuestScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest === null || (indexGuestPlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest).toString())),
                matchIsDouble: this.matchSettlementPlayerMatchOrder[arrIndex].isDouble
              })
            } else {
              retVal.push({
                matchRealIndexNumber: arrIndex,
                matchHomeTeamPlayer: this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexHomeTeam.toString(),
                matchHomeTeamPlayer2: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2HomeTeam.toString() : '9'),
                matchHomeTeamPlayerName: this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayerInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayerInMembers].user_id.lastname,
                matchHomeTeamPlayer2Name: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayer2InMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomeTeamPlayer2InMembers].user_id.lastname : 'TestHomePlayer2Name'),
                matchGuestTeamPlayer: String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndexGuestTeam + 64),
                matchGuestTeamPlayer2: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? String.fromCharCode(this.matchSettlementPlayerMatchOrder[arrIndex].playerIndex2GuestTeam + 64) : 'Z'),
                matchGuestTeamPlayerName: this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayerInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayerInMembers].user_id.lastname,
                matchGuestTeamPlayer2Name: (this.matchSettlementPlayerMatchOrder[arrIndex].isDouble ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayer2InMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestTeamPlayer2InMembers].user_id.lastname : 'TestGuestPlayer2Name'),
                matchHomeScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome === null || (indexHomePlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexHomePlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderHome).toString())),
                matchGuestScoreResultRecorder: (this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest === null || (indexGuestPlayerResultRecorderInMembers < 0 && Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1) ? null : (Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest) >= 1 ? this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.firstname + ' ' + this.tempTournamentMatchSettlementPlayersMemberData[indexGuestPlayerResultRecorderInMembers].user_id.lastname : Number(this.matchSettlementPlayerMatchOrder[arrIndex].resultRecorderGuest).toString())),
                matchIsDouble: this.matchSettlementPlayerMatchOrder[arrIndex].isDouble
              })
            }
          } else {
            console.log('[getTournamentMatchPlayersRowData] Error encountered: Team player member data not found!')
          }
        } else {
          console.log('[getTournamentMatchPlayersRowData] Info: Team player member(s) was not selected - skipping this one.')
        }
      } else {
        console.log('[getTournamentMatchPlayersRowData] Error encountered: Team player match settlement extra data not found!')
      }
    }
    console.log('[getTournamentMatchPlayersRowData] retVal = ' + JSON.stringify(retVal))

    // Return value test data:
    // retVal = [{ matchHomeTeamPlayer: '1', matchHomeTeamPlayerName: 'Robert H', matchGuestTeamPlayer: 'B', matchGuestTeamPlayerName: 'Knud L' }, { matchHomeTeamPlayer: '2', matchHomeTeamPlayerName: 'Jens O', matchGuestTeamPlayer: 'A', matchGuestTeamPlayerName: 'Franz P' }]

    return retVal
  }

  public cancelTournamentMatchSettlementEdit () : void {
    console.log('Cancel tournament match settlement item edit.')

    this.matchSettlementNumberOfPresentMatchesCreated = 0 // Reset progress value.
    this.matchSettlementNumberOfPresentMatchesSetsCreated = 0 // Reset progress value.
    this.editTournamentMatchSettlementModal = false
    this.teamCaptain = { awayTeamCaptain: null, homeTeamCaptain: null }
    // this.tempTournamentMatchSchedule = {} as SysTournamentMatchSchedule
  }

  public editTournamentMatchSettlementTeamProtestStatus () : void {
    console.log('Edit tournament match settlement team protest status for match schedule item with Id: ' + this.lastEditedTournamentMatchScheduleId)

    if (this.lastEditedTournamentMatchScheduleId !== null && this.lastEditedTournamentMatchScheduleId >= 1) {
      Tournaments.TournamentMatchSchedulesDataService.get(this.lastEditedTournamentMatchScheduleId.toString())
        .then((response) => {
          console.log(response.data)

          // Set the current value of the radio button option list for the team protest status to best matching value from value obtained through the API access.
          if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Protesthjem) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Protest fra hjemmeholdet'
          } else if (response.data.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Protestud) {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Protest fra udeholdet'
          } else {
            this.tournamentMatchSettlementTeamProtestStatusValue = 'Ingen'
          }

          this.tournamentMatchScheduleData.matchScheduleCommentStatus = response.data.kampprogram_afb_udb
          this.editTournamentMatchSettlementTeamProtestStatusModal = true
        })
        .catch((err) => {
          // this.error = err
          console.log(err)

          this.editTournamentMatchSettlementTeamProtestStatusModal = false
        })
    }
  }

  public cancelTournamentMatchSettlementTeamProtestStatusEdit () : void {
    console.log('Cancel tournament match settlement team protest status edit.')

    this.editTournamentMatchSettlementTeamProtestStatusModal = false
  }

  public updateTournamentMatchSettlementTeamProtestStatus () : boolean {
    console.log('Updating match settlement team protest status in the API.')

    if (this.lastEditedTournamentMatchScheduleId !== null && this.lastEditedTournamentMatchScheduleId >= 1) {
      const updateTournamentMatchSchedulesData = {
        kampprogram_afb_udb: (this.tournamentMatchSettlementTeamProtestStatusValue === null ? null : (this.tournamentMatchSettlementTeamProtestStatusValue === 'Protest fra hjemmeholdet' ? tournamentMatchScheduleTeamStatusFriendlyType.Protesthjem : (this.tournamentMatchSettlementTeamProtestStatusValue === 'Protest fra udeholdet' ? tournamentMatchScheduleTeamStatusFriendlyType.Protestud : null)))
      }

      Tournaments.TournamentMatchSchedulesDataService.update(this.lastEditedTournamentMatchScheduleId.toString(), updateTournamentMatchSchedulesData)
        .then((response) => {
          console.log(response.data)

          this.tournamentMatchScheduleData.matchScheduleCommentStatus = updateTournamentMatchSchedulesData.kampprogram_afb_udb
          this.editTournamentMatchSettlementTeamProtestStatusModal = false
          this.retrieveTournamentMatchSchedule()
        })
        .catch((err) => {
          // this.error = err
          console.log(err)

          this.editTournamentMatchSettlementTeamProtestStatusModal = false
        })

      return true
    }

    return false
  }

  public getTournamentMatchSettlementTeamStatusComment (teamStatus: tournamentMatchScheduleTeamStatusFriendlyType, comment: string) : string {
    let retVal = ''

    if (teamStatus === tournamentMatchScheduleTeamStatusFriendlyType.Afbudhjem) {
      retVal = 'Hjemmeholdet meldte afbud'
    } else if (teamStatus === tournamentMatchScheduleTeamStatusFriendlyType.Afbudud) {
      retVal = 'Udeholdet meldte afbud'
    } else if (teamStatus === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelsehjem) {
      retVal = 'Hjemmeholdet udeblev'
    } else if (teamStatus === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelseud) {
      retVal = 'Udeholdet udeblev'
    } else if (teamStatus === tournamentMatchScheduleTeamStatusFriendlyType.Protesthjem) {
      retVal = 'Hjemmeholdet afgav protest'
    } else if (teamStatus === tournamentMatchScheduleTeamStatusFriendlyType.Protestud) {
      retVal = 'Udeholdet afgav protest'
    }
    if (comment !== null && comment.trim().length > 0) {
      retVal += (retVal.length > 0 ? '; ' : '') + comment
    }

    return retVal
  }

  public editTournamentMatchSettlementTeamPlayers (tournamentMatchScheduleId: number, tournamentMatchScheduleMatchNumber: number, tournamentMatchScheduleRowNumberOfPlayersPerTeam: number | null, tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam: number | null, isOldBoys = false) : boolean {
    console.log('Edit tournament match settlement team players for schedule item with Id: ' + tournamentMatchScheduleId)

    this.lastEditedTournamentMatchScheduleId = tournamentMatchScheduleId
    this.isOldBoysFlag = isOldBoys
    this.matchSettlementNumberOfTeamPlayers = (tournamentMatchScheduleRowNumberOfPlayersPerTeam !== null ? Number(tournamentMatchScheduleRowNumberOfPlayersPerTeam) : 1) // Reset value.
    this.matchSettlementNumberOfTeamPlayersMaxSelections = (tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam !== null ? Number(tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam) : 1) // Reset value.
    this.tournamentMatchScheduleData.matchNumber = tournamentMatchScheduleMatchNumber

    // Get team information and player member information for each team of this tournament match settlement.
    Tournaments.TournamentMatchSettlementDataService.getAll('', null, 'kampprogram_id.id=' + tournamentMatchScheduleId.toString())
      .then((response) => {
        this.tempTournamentMatchSettlement = response.data[0]
        console.log(response.data)

        if (this.tempTournamentMatchSettlement === undefined || this.tempTournamentMatchSettlement === null || this.tempTournamentMatchSettlement.kampprogram_id === undefined) {
          const createTournamentMatchSettlementData = {
            kampprogram_id: tournamentMatchScheduleId.toString()
          }

          Tournaments.TournamentMatchSettlementDataService.create(createTournamentMatchSettlementData)
            .then((response) => {
              this.lastCreatedTournamentMatchSettlementId = response.data.id
              this.tempTournamentMatchSettlement = response.data
              console.log(response.data)

              this.tempTournamentMatchSettlement.kampafvikling_ekstras_id = this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.sort(function compare (a, b) { return a.kampafvikling_spiller_indeks - b.kampafvikling_spiller_indeks })
              this.editTournamentMatchSettlementTeamPlayersHelper(tournamentMatchScheduleId, tournamentMatchScheduleRowNumberOfPlayersPerTeam, tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam)
            })
            .catch((err) => {
              this.error = err
              // console.log(err)
            })
            .finally(() => {
              return true
            })
        } else {
          this.tempTournamentMatchSettlement.kampafvikling_ekstras_id = this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.sort(function compare (a, b) { return a.kampafvikling_spiller_indeks - b.kampafvikling_spiller_indeks })
          this.editTournamentMatchSettlementTeamPlayersHelper(tournamentMatchScheduleId, tournamentMatchScheduleRowNumberOfPlayersPerTeam, tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam)
        }
      })
      .catch((err) => {
        this.error = err
      })

    return false
  }

  public createTournamentSeasonMatchPlan (): boolean {
    if (Number(this.tournamentSeasonTextValue.value) > 0 && Number(this.tournamentCategoryTitleValue.value) > 0 &&
      this.matchPlannerData.matchPerDay >= 1 && this.matchPlannerData.meetEachTeamTimes >= 1) {
      this.editCreateTournamentSeasonMatchPlanModal = false
      this.currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex = 1
      this.selectedMatchScheduleSlotToBeUsed = (Number(this.tournamentMatchScheduleSelectedSlotTextValue.value) >= 1 ? Number(this.tournamentMatchScheduleSelectedSlotTextValue.value) : -1)
      this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = 0
      this.cancelSaveTournamentSeasonMatchPlanButtonTriggered = false
      this.actionModeOfSaveTournamentSeasonMatchPlanButton = false
      console.log('[createTournamentSeasonMatchPlan] selectedMatchScheduleSlotToBeUsed = ' + this.selectedMatchScheduleSlotToBeUsed)
      // console.log('[createTournamentSeasonMatchPlan] DST info = ' + JSON.stringify(CommonFunctions.getDSTDetails('Europe/Copenhagen', 2022)))
      // console.log('[createTournamentSeasonMatchPlan] Normal time TZ offset =  ' + CommonFunctions.getTZOffset('Europe/Copenhagen').toString())
      // console.log('[createTournamentSeasonMatchPlan] UTC offset for Jan 2022 = ' + CommonFunctions.getUTCOffset(2022, 2, 10, 15, 0, 0, 'Europe/Copenhagen'))
      // console.log('[createTournamentSeasonMatchPlan] UTC offset for Jul 2022 = ' + CommonFunctions.getUTCOffset(2022, 7, 10, 15, 0, 0, 'Europe/Copenhagen'))
      // console.log('[createTournamentSeasonMatchPlan] Test time 1 = ' + new Date('2022-04-13T00:00:00.000+01:00').toString())
      // console.log('[createTournamentSeasonMatchPlan] Test time 2 = ' + new Date('2022-04-13T00:00:00.000+01:00').toISOString())
      // console.log('[createTournamentSeasonMatchPlan] Test time 3 = ' + new Date('2022-04-13T00:00:00.000+02:00').toISOString())
      // console.log('[createTournamentSeasonMatchPlan] Test time 4 = ' + new Date('2022-04-13T00:00:00.000+01:00').toLocaleString('sv-SE', { timeZone: 'Europe/Copenhagen' }))

      // MatchPlannerDataService.get(Number(this.tournamentCategoryTitleValue.value).toString(), Number(this.tournamentSeasonTextValue.value), this.matchPlannerData.matchPerDay, this.matchPlannerData.skipMatchPerDayFirstRound, this.matchPlannerData.meetEachTeamTimes, this.matchPlannerData.matchNumberOfRoundsWithLargestDivisionTeams, '')
      MatchPlannerDataService.get(Number(this.tournamentCategoryTitleValue.value).toString(), Number(this.tournamentSeasonTextValue.value), this.matchPlannerData.matchPerDay, this.matchPlannerData.skipMatchPerDayFirstRound, this.matchPlannerData.meetEachTeamTimes, this.matchPlannerData.matchNumberOfRoundsWithLargestDivisionTeams, this.matchPlannerData.timeBetweenMatches, (this.matchPlannerData.autoIncreaseNumbTimesTeamsMeetsTreshold < 2 ? null : this.matchPlannerData.autoIncreaseNumbTimesTeamsMeetsTreshold), '')
        .then((response) => {
          this.tempTournamentMatchPlanResponse = response.data
          console.log(response.data)

          this.editCreateTournamentSeasonMatchPlanModal = false

          TeamsDataService.getAll()
            .then((response) => {
              console.log('called4')

              this.tempHolds = response.data
              console.log(response.data)

              // const timezone = 2
              // Specifying timeZone is what causes the conversion, the rest is just formatting.
              // const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false, timeZone: 'Europe/Copenhagen', timeZoneName: 'short' } as Intl.DateTimeFormatOptions
              // const formatter = new Intl.DateTimeFormat('sv-SE', options)

              this.tournamentSeasonMatchPlanTeamsTextOptions = [{ text: 'Vælg her', value: '0' }]
              let arrIndex1 = 0

              for (const objItem of this.tempHolds) {
                if (this.tempHolds[arrIndex1].id !== null && this.tempHolds[arrIndex1].raekke_id !== null && this.tempHolds[arrIndex1].raekke_id.id !== null) {
                  this.tournamentSeasonMatchPlanTeamsTextOptions.push({
                    text: objItem.hold_holdnavn,
                    value: Number(objItem.id).toString()
                  })
                }

                arrIndex1++
              }

              this.tempHolds = []
              this.tournamentSeasonMatchPlanTeamsTextValue = []
              arrIndex1 = 0
              this.tournamentMatchPlanTotalNumberOfMatches = 0

              for (const objItem of this.tempTournamentMatchPlanResponse) {
                // const tempMatches = [{ date: '', homeTeam: { text: 'Vælg her', value: '0' }, guestTeam: { text: 'Vælg her', value: '0' } }]
                const tempMatches = []

                for (const objItem2 of objItem.matches) {
                  // const tempDate = new Date(objItem2.date)
                  // const offset = (tempDate.getTimezoneOffset() + (timezone * 60)) * 60 * 1000
                  // tempDate.setTime(tempDate.getTime() + offset)

                  let tempString = CommonFunctions.convertFromUTCtoLocalDateTime(objItem2.date, 0)
                  const strPos = tempString.indexOf(' ')
                  tempString = (tempString.substring(0, strPos) + 'T' + tempString.substring(strPos + 1)).substring(0, 19)

                  // console.log('[createTournamentSeasonMatchPlan] Datetime: ' + new Date(objItem2.date).toISOString().substring(0, 16))
                  // console.log('[createTournamentSeasonMatchPlan] Datetime (toISO): ' + tempDate.toISOString().substring(0, 16))
                  // console.log('[createTournamentSeasonMatchPlan] Datetime (toString - implementation specific): ' + tempDate.toDateString() + ' ' + tempDate.toTimeString())
                  // console.log('[createTournamentSeasonMatchPlan] Datetime (new): ' + formatter.format(tempDate).substring(0, 19))
                  // console.log('[createTournamentSeasonMatchPlan] Datetime (new): ' + tempString)
                  // tempMatches.push({ date: new Date(objItem2.date).toISOString().substring(0, 16), homeTeam: { text: objItem2.home.hold_holdnavn, value: Number(objItem2.home.id).toString() }, guestTeam: { text: objItem2.away.hold_holdnavn, value: Number(objItem2.away.id).toString() } })
                  tempMatches.push({
                    date: tempString,
                    homeTeam: { text: objItem2.home.hold_holdnavn, value: Number(objItem2.home.id).toString() },
                    guestTeam: { text: objItem2.away.hold_holdnavn, value: Number(objItem2.away.id).toString() }
                  })
                  this.tournamentMatchPlanTotalNumberOfMatches++
                }
                this.tournamentSeasonMatchPlanTeamsTextValue.push({
                  tournamentRow: {
                    id: Number(objItem.raekke.id),
                    name: objItem.raekke.name
                  },
                  matches: tempMatches
                })

                arrIndex1++
              }
              // console.log('[createTournamentSeasonMatchPlan] tournamentSeasonMatchPlanTeamsTextValue = ' + JSON.stringify(this.tournamentSeasonMatchPlanTeamsTextValue))

              this.tempTournamentMatchPlanResponse = []
              this.createTournamentSeasonMatchPlanEditModal = true
            })
            .catch((err) => {
              this.error = err
            })
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })

      return true
    }

    return false
  }

  public cancelUpdateMatchSettlementTeamPlayersEdit () : void {
    console.log('Cancel tournament match settlement team players item edit.')
    this.editTournamentMatchSettlementTeamPlayersModal = false
    this.tournamentMatchScheduleData.matchNumber = 0
  }

  public updateMatchSettlementTeamPlayersEdit () : boolean {
    console.log('Updating match settlement team players setup in the API.')
    this.matchSettlementTeamPlayersExtDataUpdateIds = []
    this.matchSettlementTeamPlayersExtDataUpdateProgress = 0
    this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark = Math.min(this.matchSettlementHomeTeamPlayersNameValue.length, this.matchSettlementGuestTeamPlayersNameValue.length)
    this.matchSettlementTeamPlayersExtDataUpdateStarted = true
    let usePlayerRemapping = false
    let arrOffset = 0
    let isPlayerSelected = false
    let samePlayerOnBothTeams = false
    const matchSettlementHomeTeamPlayersNameValueRemapped: { name: string; value: string; gender: string; birthdaydate: string; isparadart: boolean; clubid: number; teamid: number; selectFlag: boolean }[] = []
    const matchSettlementGuestTeamPlayersNameValueRemapped: { name: string; value: string; gender: string; birthdaydate: string; isparadart: boolean; clubid: number; teamid: number; selectFlag: boolean }[] = []

    console.log('[updateMatchSettlementTeamPlayersEdit] matchSettlementTeamPlayersExtDataUpdateProgressWatermark = ' + this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark)

    // Check if a player is on both teams and bail out if it is the case.
    if (this.matchSettlementHomeTeamPlayersNameValue.length <= this.matchSettlementGuestTeamPlayersNameValue.length) {
      for (let arrIndex = 0; arrIndex < this.matchSettlementHomeTeamPlayersNameValue.length; arrIndex++) {
        if (this.matchSettlementGuestTeamPlayersNameValue.findIndex(x => Number(x.value) === Number(this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value)) !== -1) {
          samePlayerOnBothTeams = true
        }
      }
    } else {
      for (let arrIndex = 0; arrIndex < this.matchSettlementGuestTeamPlayersNameValue.length; arrIndex++) {
        if (this.matchSettlementHomeTeamPlayersNameValue.findIndex(x => Number(x.value) === Number(this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value)) !== -1) {
          samePlayerOnBothTeams = true
        }
      }
    }

    if (samePlayerOnBothTeams) {
      return false
    }

    // Check if match player selection remapping is needed or not.
    if (this.matchSettlementNumberOfTeamPlayersMaxSelections === 8 && (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark >= 5 || (this.isOldBoysFlag && this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark >= 3)) && this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark <= 8) {
      usePlayerRemapping = true

      // Generate remapped match player selection data.
      for (let arrIndex = 0; arrIndex < this.matchSettlementNumberOfTeamPlayersMaxSelections; arrIndex++) {
        matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex] = { name: '', value: '0', gender: '', birthdaydate: '', isparadart: false, clubid: 0, teamid: 0, selectFlag: false }
        matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: '', value: '0', gender: '', birthdaydate: '', isparadart: false, clubid: 0, teamid: 0, selectFlag: false }

        if (arrIndex < 4) {
          // The first four items are identical to non-remapped situation.
          console.log('[updateMatchSettlementTeamPlayersEdit] arrIndex = ' + arrIndex.toString())
          if (this.isOldBoysFlag && arrIndex === 3 && this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark === 3) {
            // Handle special case with Old Boys tournament rows, where it is possible that a team has only 3 players selected. This is for the remapping the single match.
            if (this.matchSettlementHomeTeamPlayersNameValue.length >= 4) {
              matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].name, value: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value, gender: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].gender, birthdaydate: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].birthdaydate, isparadart: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].isparadart, clubid: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].clubid, teamid: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].teamid, selectFlag: true }
            } else {
              // Map player index to zero for unselected player that should have been playing that single match.
              matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementHomeTeamPlayersNameValue[0].name, value: this.matchSettlementHomeTeamPlayersNameValue[0].value, gender: this.matchSettlementHomeTeamPlayersNameValue[0].gender, birthdaydate: this.matchSettlementHomeTeamPlayersNameValue[0].birthdaydate, isparadart: this.matchSettlementHomeTeamPlayersNameValue[0].isparadart, clubid: this.matchSettlementHomeTeamPlayersNameValue[0].clubid, teamid: this.matchSettlementHomeTeamPlayersNameValue[0].teamid, selectFlag: false }
            }

            if (this.matchSettlementGuestTeamPlayersNameValue.length >= 4) {
              matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].name, value: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value, gender: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].gender, birthdaydate: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].birthdaydate, isparadart: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].isparadart, clubid: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].clubid, teamid: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].teamid, selectFlag: true }
            } else {
              // Map player index to zero for unselected player that should have been playing that single match.
              matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementGuestTeamPlayersNameValue[0].name, value: this.matchSettlementGuestTeamPlayersNameValue[0].value, gender: this.matchSettlementGuestTeamPlayersNameValue[0].gender, birthdaydate: this.matchSettlementGuestTeamPlayersNameValue[0].birthdaydate, isparadart: this.matchSettlementGuestTeamPlayersNameValue[0].isparadart, clubid: this.matchSettlementGuestTeamPlayersNameValue[0].clubid, teamid: this.matchSettlementGuestTeamPlayersNameValue[0].teamid, selectFlag: false }
            }
          } else {
            matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].name, value: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value, gender: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].gender, birthdaydate: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].birthdaydate, isparadart: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].isparadart, clubid: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].clubid, teamid: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].teamid, selectFlag: true }
            matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].name, value: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value, gender: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].gender, birthdaydate: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].birthdaydate, isparadart: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].isparadart, clubid: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].clubid, teamid: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].teamid, selectFlag: true }
          }
        } else {
          isPlayerSelected = false

          // Do some real remapping of players for both teams.
          if (this.matchSettlementHomeTeamPlayersNameValue[arrIndex] === undefined) {
            // Map array index data only if not part of the array bottom (either index 7, 6 - 7 or 5 - 7) for the home team.
            if (this.isOldBoysFlag && arrIndex <= this.matchSettlementNumberOfTeamPlayersMaxSelections - 1) {
              if (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark === 3) {
                switch (arrIndex) {
                  case 4:
                    arrOffset = 0
                    isPlayerSelected = true
                    break
                  case 5:
                    arrOffset = 2
                    isPlayerSelected = true
                    break
                  case 6:
                    arrOffset = 1
                    isPlayerSelected = true
                    break
                  case 7:
                    arrOffset = (this.matchSettlementHomeTeamPlayersNameValue.length <= this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark ? 0 : 3)
                    isPlayerSelected = !(this.matchSettlementHomeTeamPlayersNameValue.length <= this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark)
                    break
                  default:
                    arrOffset = arrIndex
                }
              } else if (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark === 4) {
                switch (arrIndex) {
                  case 4:
                    arrOffset = 0
                    isPlayerSelected = true
                    break
                  case 5:
                    arrOffset = 3
                    isPlayerSelected = true
                    break
                  case 6:
                    arrOffset = 1
                    isPlayerSelected = true
                    break
                  case 7:
                    arrOffset = 2
                    isPlayerSelected = true
                    break
                  default:
                    arrOffset = arrIndex
                }
              } else if (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark >= 5) {
                isPlayerSelected = true
                arrOffset = this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex
              }
              console.log('[updateMatchSettlementTeamPlayersEdit] OB Home team player arrIndex = ' + arrIndex.toString() + ' / Remapped index for home team players to = ' + arrOffset.toString())

              matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementHomeTeamPlayersNameValue[arrOffset].name, value: this.matchSettlementHomeTeamPlayersNameValue[arrOffset].value, gender: this.matchSettlementHomeTeamPlayersNameValue[arrOffset].gender, birthdaydate: this.matchSettlementHomeTeamPlayersNameValue[arrOffset].birthdaydate, isparadart: this.matchSettlementHomeTeamPlayersNameValue[arrOffset].isparadart, clubid: this.matchSettlementHomeTeamPlayersNameValue[arrOffset].clubid, teamid: this.matchSettlementHomeTeamPlayersNameValue[arrOffset].teamid, selectFlag: isPlayerSelected }
            } else {
              console.log('[updateMatchSettlementTeamPlayersEdit] Home team player arrIndex = ' + arrIndex.toString() + ' / Remapped index for home team players to = ' + (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex).toString())

              matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementHomeTeamPlayersNameValue[this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex].name, value: this.matchSettlementHomeTeamPlayersNameValue[this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex].value, gender: this.matchSettlementHomeTeamPlayersNameValue[this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex].gender, birthdaydate: this.matchSettlementHomeTeamPlayersNameValue[this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex].birthdaydate, isparadart: this.matchSettlementHomeTeamPlayersNameValue[this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex].isparadart, clubid: this.matchSettlementHomeTeamPlayersNameValue[this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex].clubid, teamid: this.matchSettlementHomeTeamPlayersNameValue[this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark + 2 - arrIndex].teamid, selectFlag: true }
            }
          } else {
            // Map array index data 4 - 6 to array bottom (either index 7, 6 - 7 or 5 - 7) for the guest team.
            console.log('[updateMatchSettlementTeamPlayersEdit] GENERAL Home team player arrIndex = ' + arrIndex.toString())

            matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].name, value: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value, gender: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].gender, birthdaydate: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].birthdaydate, isparadart: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].isparadart, clubid: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].clubid, teamid: this.matchSettlementHomeTeamPlayersNameValue[arrIndex].teamid, selectFlag: true }
          }

          isPlayerSelected = false

          if (this.matchSettlementGuestTeamPlayersNameValue[arrIndex] === undefined) {
            // Map array index data only if not part of the array bottom (either index 7, 6 - 7 or 5 - 7) for the guest team.
            if (this.isOldBoysFlag && arrIndex <= this.matchSettlementNumberOfTeamPlayersMaxSelections - 1) {
              if (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark === 3) {
                switch (arrIndex) {
                  case 4:
                    arrOffset = 2
                    isPlayerSelected = true
                    break
                  case 5:
                    arrOffset = 1
                    isPlayerSelected = true
                    break
                  case 6:
                    arrOffset = 0
                    isPlayerSelected = true
                    break
                  case 7:
                    arrOffset = (this.matchSettlementGuestTeamPlayersNameValue.length <= this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark ? 0 : 3)
                    isPlayerSelected = !(this.matchSettlementGuestTeamPlayersNameValue.length <= this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark)
                    break
                  default:
                    arrOffset = arrIndex
                }
              } else if (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark === 4) {
                switch (arrIndex) {
                  case 4:
                    arrOffset = 3
                    isPlayerSelected = true
                    break
                  case 5:
                    arrOffset = 1
                    isPlayerSelected = true
                    break
                  case 6:
                    arrOffset = 0
                    isPlayerSelected = true
                    break
                  case 7:
                    arrOffset = 2
                    isPlayerSelected = true
                    break
                  default:
                    arrOffset = arrIndex
                }
              } else if (this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark >= 5) {
                isPlayerSelected = true
                arrOffset = (arrIndex === this.matchSettlementNumberOfTeamPlayersMaxSelections - 1) ? this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark - 1 : 3 - ((arrIndex + 1) & 3)
              }
              console.log('[updateMatchSettlementTeamPlayersEdit] OB Guest team player arrIndex = ' + arrIndex.toString() + ' / Remapped index for guest team players to = ' + arrOffset.toString())

              matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementGuestTeamPlayersNameValue[arrOffset].name, value: this.matchSettlementGuestTeamPlayersNameValue[arrOffset].value, gender: this.matchSettlementGuestTeamPlayersNameValue[arrOffset].gender, birthdaydate: this.matchSettlementGuestTeamPlayersNameValue[arrOffset].birthdaydate, isparadart: this.matchSettlementGuestTeamPlayersNameValue[arrOffset].isparadart, clubid: this.matchSettlementGuestTeamPlayersNameValue[arrOffset].clubid, teamid: this.matchSettlementGuestTeamPlayersNameValue[arrOffset].teamid, selectFlag: isPlayerSelected }
            } else {
              if (arrIndex < this.matchSettlementNumberOfTeamPlayersMaxSelections - 1) {
                console.log('[updateMatchSettlementTeamPlayersEdit] Guest team player arrIndex = ' + arrIndex.toString() + ' / Remapped index for guest team players to = ' + (3 - ((arrIndex + 1) & 3)).toString())

                matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].name, value: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].value, gender: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].gender, birthdaydate: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].birthdaydate, isparadart: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].isparadart, clubid: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].clubid, teamid: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].teamid, selectFlag: true }
              }
            }
          } else {
            // Map array index 4 - 6 data to the array bottom (with index 7 being mapped to data of the highest selected player index in the array) for the guest team.
            if (arrIndex === this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark - 1) {
              console.log('[updateMatchSettlementTeamPlayersEdit] GENERAL Guest team player arrIndex = ' + arrIndex.toString() + ' / Remapped index for guest team players to = ' + (3 - ((arrIndex + 1) & 3)).toString())

              matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].name, value: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].value, gender: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].gender, birthdaydate: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].birthdaydate, isparadart: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].isparadart, clubid: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].clubid, teamid: this.matchSettlementGuestTeamPlayersNameValue[3 - ((arrIndex + 1) & 3)].teamid, selectFlag: true }
            } else {
              console.log('[updateMatchSettlementTeamPlayersEdit] GENERAL Guest team player arrIndex = ' + arrIndex.toString() + ' / Remapped index for guest team players to = ' + arrIndex.toString())

              matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex] = { name: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].name, value: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value, gender: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].gender, birthdaydate: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].birthdaydate, isparadart: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].isparadart, clubid: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].clubid, teamid: this.matchSettlementGuestTeamPlayersNameValue[arrIndex].teamid, selectFlag: true }
            }
          }

          console.log('[updateMatchSettlementTeamPlayersEdit] matchSettlementHomeTeamPlayersNameValueRemapped[' + arrIndex + '] = ' + matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].name + ' / ' + matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].value)
          console.log('[updateMatchSettlementTeamPlayersEdit] matchSettlementGuestTeamPlayersNameValueRemapped[' + arrIndex + '] = ' + matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].name + ' / ' + matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].value)
        }
      }
      console.log('[updateMatchSettlementTeamPlayersEdit] matchSettlementHomeTeamPlayersNameValueRemapped = ' + JSON.stringify(matchSettlementHomeTeamPlayersNameValueRemapped))
      console.log('[updateMatchSettlementTeamPlayersEdit] matchSettlementGuestTeamPlayersNameValueRemapped = ' + JSON.stringify(matchSettlementGuestTeamPlayersNameValueRemapped))

      // Adjust progress watermark to be equal to the maximum number of possible players.
      this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark = this.matchSettlementNumberOfTeamPlayersMaxSelections
      console.log('[updateMatchSettlementTeamPlayersEdit] matchSettlementTeamPlayersExtDataUpdateProgressWatermark after remap = ' + this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark)
    }

    for (let arrIndex = 0; arrIndex < this.matchSettlementTeamPlayersExtDataUpdateProgressWatermark; arrIndex++) {
      console.log('[updateMatchSettlementTeamPlayersEdit] Players : ' + (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value) + ' / ' + (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value))

      // Search match settlement extra data with the kampafvikling_spiller_indeks equal to the arrIndex. If it already exists then update its member Ids for the home and guest players. Otherwise create a new item with the relevant data.
      const indexOfMatchSettlementTeamPlayersExtData = this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.findIndex(x => Number(x.kampafvikling_spiller_indeks) === (arrIndex + 1))

      if (indexOfMatchSettlementTeamPlayersExtData === -1) {
        // Check if there is already an existing item with the same fields values as desired in the match settlement extra data from the API.
        Tournaments.TournamentMatchSettlementExtDataService.getAll('', null, 'kampafvikling_spiller_indeks=' + (arrIndex + 1).toString() + '&kampafvikling_spiller_hj=' + (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value) + '&kampafvikling_spiller_ud=' + (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value))
          .then((response) => {
            const tempMatchSettlementExtData = response.data
            console.log(response.data)

            if (tempMatchSettlementExtData !== null && tempMatchSettlementExtData.length >= 1 && tempMatchSettlementExtData[0].id !== null) {
              // Reuse already existing match settlement extra item instead of creating a new item.
              this.matchSettlementTeamPlayersExtDataUpdateIds.push(Number(tempMatchSettlementExtData[0].id))
              const updateTournamentMatchSettlementExtData = {
                kampafvikling_spiller_hj: (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value),
                kampafvikling_spiller_ud: (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value),
                kampafvikling_spiller_hj_valgt: (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].selectFlag : true),
                kampafvikling_spiller_ud_valgt: (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].selectFlag : true)
              }

              console.log('[updateMatchSettlementTeamPlayersEdit] Updating an existing match settlement extra data item (because an item with the same fields values already exists): ' + JSON.stringify(updateTournamentMatchSettlementExtData))

              // Update the match settlement extra data via API access for the matching Id.
              Tournaments.TournamentMatchSettlementExtDataService.update(Number(tempMatchSettlementExtData[0].id).toString(), updateTournamentMatchSettlementExtData)
                .then((response) => {
                  // this.lastUpdatedTournamentMatchSettlementExtId = response.data.id
                  console.log(response.data)
                })
                .catch((err) => {
                  this.error = err
                  // console.log(err)
                })
                .finally(() => {
                  this.matchSettlementTeamPlayersExtDataUpdateProgress++

                  return true
                })
            } else {
              // Create match settlement extra data with the kampafvikling_spiller_indeks equal to the arrIndex.
              const createTournamentMatchSettlementExtData = {
                kampafvikling_spiller_indeks: (arrIndex + 1),
                kampafvikling_spiller_hj: (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value),
                kampafvikling_spiller_ud: (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value),
                kampafvikling_spiller_hj_valgt: (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].selectFlag : true),
                kampafvikling_spiller_ud_valgt: (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].selectFlag : true)
              }

              console.log('[updateMatchSettlementTeamPlayersEdit] Creating a new match settlement extra data item: ' + JSON.stringify(createTournamentMatchSettlementExtData))

              Tournaments.TournamentMatchSettlementExtDataService.create(createTournamentMatchSettlementExtData)
                .then((response) => {
                  this.lastCreatedTournamentMatchSettlementExtId = response.data.id
                  console.log(response.data)

                  this.matchSettlementTeamPlayersExtDataUpdateIds.push(Number(response.data.id))
                })
                .catch((err) => {
                  this.error = err
                  // console.log(err)
                })
                .finally(() => {
                  this.matchSettlementTeamPlayersExtDataUpdateProgress++

                  return true
                })
            }
          })
          .catch((err) => {
            this.error = err
            // console.log(err)

            this.matchSettlementTeamPlayersExtDataUpdateProgress++
          })
          .finally(() => {
            return true
          })
      } else {
        // Add the id of the already existing match settlement extra data to the Id array.
        const tempMatchSettlementExtId = Number(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[indexOfMatchSettlementTeamPlayersExtData].id)
        this.matchSettlementTeamPlayersExtDataUpdateIds.push(tempMatchSettlementExtId)
        const updateTournamentMatchSettlementExtData = {
          kampafvikling_spiller_hj: (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementHomeTeamPlayersNameValue[arrIndex].value),
          kampafvikling_spiller_ud: (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].value : this.matchSettlementGuestTeamPlayersNameValue[arrIndex].value),
          kampafvikling_spiller_hj_valgt: (usePlayerRemapping ? matchSettlementHomeTeamPlayersNameValueRemapped[arrIndex].selectFlag : true),
          kampafvikling_spiller_ud_valgt: (usePlayerRemapping ? matchSettlementGuestTeamPlayersNameValueRemapped[arrIndex].selectFlag : true)
        }

        console.log('[updateMatchSettlementTeamPlayersEdit] Updating an existing match settlement extra data item: ' + JSON.stringify(updateTournamentMatchSettlementExtData))

        // Update the match settlement extra data via API access for the matching Id.
        Tournaments.TournamentMatchSettlementExtDataService.update(tempMatchSettlementExtId.toString(), updateTournamentMatchSettlementExtData)
          .then((response) => {
            // this.lastUpdatedTournamentMatchSettlementExtId = response.data.id
            console.log(response.data)
          })
          .catch((err) => {
            this.error = err
            // console.log(err)
          })
          .finally(() => {
            this.matchSettlementTeamPlayersExtDataUpdateProgress++

            return true
          })
      }
    }

    return true
  }

  public updateMatchSettlementTeamVerdict (homeTeam = false, guestTeam = false) : void {
    console.log('Updating match settlement team verdict setting.')
  }

  public statusTournamentCategory (tournamentCategoryId: number, documentId: string) : void {
    console.log('Change status of tournament category item with Id: ' + tournamentCategoryId)

    Tournaments.TournamentCategoriesDataService.get(documentId)
      .then((response) => {
        this.tempTournamentCategory = response.data
        const updateTournamentCategoryData = {
          data: {
            turneringskategori_status: !this.tempTournamentCategory.turneringskategori_status
          }
        }

        Tournaments.TournamentCategoriesDataService.update(documentId, updateTournamentCategoryData)
          .then(() => {
            // this.lastUpdatedTournamentCategoryId = response.data.id
            const tournamentCategoryIndexToUpdateStatus = this.turneringskategoris.findIndex(x => x.id === tournamentCategoryId)
            this.turneringskategoris[tournamentCategoryIndexToUpdateStatus].turneringskategori_status = updateTournamentCategoryData.data.turneringskategori_status
          })
          .catch((err) => {
            this.error = err
            // console.log(err)
          })
      })
      .catch((err) => {
        this.error = err
      })
  }

  public statusTournamentRow (tournamentRowId: number, documentId: string) : void {
    Tournaments.TournamentRowsDataService.get(documentId)
      .then((response) => {
        this.tempTournamentRow = response.data
        const updateTournamentRowData = {
          data: {
            raekke_status: !this.tempTournamentRow.raekke_status
          }
        }

        Tournaments.TournamentRowsDataService.update(documentId, updateTournamentRowData)
          .then(() => {
            const tournamentRowIndexToUpdateStatus = this.raekkes.findIndex(x => x.id === tournamentRowId)
            this.raekkes[tournamentRowIndexToUpdateStatus].raekke_status = updateTournamentRowData.data.raekke_status
          })
          .catch((err) => {
            this.error = err
          })
      })
      .catch((err) => {
        this.error = err
      })
  }

  public createTournamentCategory () : void {
    if (this.tournamentCategoryData.categoryName.length > 1 && !isNaN(Number(this.tournamentCategoryData.categoryPrice)) && Number(this.tournamentCategoryData.categoryPrice) >= 0) {
      const createTournamentCategoryData = {
        data: {
          turneringskategori_navn: this.tournamentCategoryData.categoryName,
          turneringskategori_pris: Number(this.tournamentCategoryData.categoryPrice).toString(),
          turneringskategori_status: true
        }
      }

      console.log('Attempt to create new tournament category item with Id: ' + (1 + this.lastCreatedTournamentCategoryId))

      Tournaments.TournamentCategoriesDataService.create(createTournamentCategoryData)
        .then((response) => {
          this.lastCreatedTournamentCategoryId = response.data.id
          this.tournamentCategoryData = { categoryName: '', categoryPrice: 0 }
          console.log(response.data)
          this.$Notification.success({ title: 'Ny turneringskategori er blevet oprettet' })
          this.editTournamentCategoryModal = false

          // this.submitted = true
          this.retrieveTournamentCategories()
          this.tabValue = 'Vis og rediger turneringskategorier'
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })
    }
  }

  public createTournamentMatchSchedule () : void {
    if (this.homeTeamNameValue.value !== null && Number(this.homeTeamNameValue.value) > 0 &&
      this.guestTeamNameValue.value !== null && Number(this.guestTeamNameValue.value) > 0 &&
      Number(this.tournamentSeasonTextValue.value) > 0 && Number(this.tournamentRowsNameValue.value) > 0 &&
      this.tournamentMatchScheduleData.matchScheduleDate.length > 0) {
      // Obtain the highest currently used value for match schedule number, and use the next available number for the creation of the new match schedule.
      // Tournaments.TournamentMatchSchedulesDataService.getAll('kampprogram_kampnr:desc', { slicemode: 0, start: 0, limit: 1, page: 0, pagesize: 1, totalcount: 1 }, 'saeson_id.id=' + Number(this.tournamentSeasonTextValue.value).toString() + '&raekke_id.id=' + Number(this.tournamentRowsNameValue.value).toString())
      Tournaments.TournamentMatchSchedulesDataService.getAll('kampprogram_kampnr:desc', { slicemode: 0, start: 0, limit: 1, page: 0, pagesize: 1, totalcount: 1 }, 'saeson_id.id=' + Number(this.tournamentSeasonTextValue.value).toString())
        .then((response) => {
          this.tournamentMatchScheduleData.matchNumber = (response.data !== undefined && response.data !== null && response.data.length > 0) ? Number(response.data[0].kampprogram_kampnr) + 1 : 1
          // console.log('[createTournamentMatchSchedule] kampprogram_kampnr = ' + Number(response.data[0].kampprogram_kampnr).toString())

          const createTournamentMatchScheduleData = {
            data: {
              kampprogram_kampnr: this.tournamentMatchScheduleData.matchNumber.toString(),
              kampprogram_slotindeks: '0',
              kampprogram_dato: (this.tournamentMatchScheduleData.matchScheduleDate.length > 0 ? this.tournamentMatchScheduleData.matchScheduleDate : null),
              kampprogram_hjemmehold: Number(this.homeTeamNameValue.value).toString(),
              kampprogram_udehold: Number(this.guestTeamNameValue.value).toString(),
              kampprogram_kommentar: this.tournamentMatchScheduleData.matchScheduleComment,
              saeson_id: Number(this.tournamentSeasonTextValue.value).toString(),
              raekke_id: Number(this.tournamentRowsNameValue.value).toString()
            }
          }

          console.log('[createTournamentMatchSchedule] Attempt to create new tournament match schedule item with Id: ' + (1 + this.lastCreatedTournamentMatchScheduleId))
          console.log('[createTournamentMatchSchedule] createTournamentMatchScheduleData = ' + JSON.stringify(createTournamentMatchScheduleData))

          Tournaments.TournamentMatchSchedulesDataService.create(createTournamentMatchScheduleData)
            .then((response) => {
              this.lastCreatedTournamentMatchScheduleId = response.data.id
              this.$Notification.success({ title: 'Turneringskampen er blevet oprettet' })
              this.createNewMatchModal = false

              // this.submitted2 = true
              // this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
              // this.retrieveTournamentMatchSchedule()
            })
            .catch((err) => {
              this.error = err
              // console.log(err)
            })

          // this.homeTeamNameValue = { text: 'Vælg her', value: '0' }
          // this.guestTeamNameValue = { text: 'Vælg her', value: '0' }
          // this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0' }
          // this.tournamentRowsNameValue = { text: 'Vælg her', value: '0' }
          // this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })
    }
  }

  public newCreateTournamentMatchSchedule () : void {
    this.submitted2 = false
    this.homeTeamNameValue = { text: 'Vælg her', value: '0' }
    this.guestTeamNameValue = { text: 'Vælg her', value: '0' }
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.tournamentRowsNameValue = { text: 'Vælg her', value: '0' }
    this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
    this.retrieveTournamentMatchSchedule()
  }

  public addNewTournamentRoundToBeCreated () : void {
    console.log('[addNewTournamentRoundToBeCreated] Adding a new tournament round element to the list.')
    this.tournamentRoundsToBeCreated.push({ tagNotClosed: true, date: '', time: '', numberOfMatches: 0 })
  }

  public tournamentRoundToBeCreatedEditDateDayCellClicked (dateVal: any) : void {
    console.log('[tournamentRoundToBeCreatedEditDateDayCellClicked] dateVal = ' + (dateVal === undefined || dateVal === null ? 'undefined or null' : dateVal.toJSON()))

    // Preset the input field value for the number of matches according to whether the selected day is a working weekday or a weekend day. The preset value for a weekend day is 2, and the for other days it is 1.
    if (dateVal !== undefined || dateVal !== null) {
      if (this.editTournamentRoundToBeCreatedDateValue.getDay() === 0 || this.editTournamentRoundToBeCreatedDateValue.getDay() === 6) {
        this.editTournamentRoundToBeCreatedNumberOfMatchesValue = 2
      } else {
        this.editTournamentRoundToBeCreatedNumberOfMatchesValue = 1
      }
    }
  }

  public editPropertiesOfNewTournamentRoundToBeCreated (index = 0) : void {
    console.log('[editPropertiesOfNewTournamentRoundToBeCreated] Editing round item: ' + index.toString())
    this.indexOfEditedTournamentRoundToBeCreated = index
    this.editTournamentRoundToBeCreatedNumberOfMatchesValue = this.tournamentRoundsToBeCreated[index].numberOfMatches
    if (this.tournamentRoundsToBeCreated[index].date.length > 0) {
      this.editTournamentRoundToBeCreatedDateValue = new Date(this.tournamentRoundsToBeCreated[index].date)
    } else {
      this.editTournamentRoundToBeCreatedDateValue = new Date()
    }
    this.editTournamentRoundToBeCreatedDateView = { type: 'month', year: this.editTournamentRoundToBeCreatedDateValue.getFullYear() }
    this.editTournamentRoundToBeCreatedModal = true
  }

  public cancelTournamentRoundToBeCreatedEdit () : void {
    this.editTournamentRoundToBeCreatedModal = false
    this.editTournamentRoundToBeCreatedDateValue = new Date()
    this.editTournamentRoundToBeCreatedDateView = { type: 'month', year: (new Date()).getFullYear() }
    this.editTournamentRoundToBeCreatedNumberOfMatchesValue = 1
  }

  public updateTournamentRoundToBeCreated (index = 0) : boolean {
    console.log('[editPropertiesOfNewTournamentRoundToBeCreated] Updating round item: ' + index.toString())
    this.tournamentRoundsToBeCreated[index].date = this.editTournamentRoundToBeCreatedDateValue.toJSON()
    this.tournamentRoundsToBeCreated[index].numberOfMatches = Number(this.editTournamentRoundToBeCreatedNumberOfMatchesValue)
    this.editTournamentRoundToBeCreatedModal = false

    return true
  }

  public createTournamentRounds () : void {
    if (Number(this.tournamentSeasonTextValue.value) > 0 && Number(this.tournamentCategoryTitleValue.value) > 0) {
      for (const tournamentRoundToBeCreated of this.tournamentRoundsToBeCreated) {
        if (tournamentRoundToBeCreated.tagNotClosed && tournamentRoundToBeCreated.date !== null && tournamentRoundToBeCreated.numberOfMatches > 0) {
          const createTournamentRoundsData = {
            data: {
              saeson_id: Number(this.tournamentSeasonTextValue.value).toString(),
              turneringskategori_id: Number(this.tournamentCategoryTitleValue.value).toString(),
              turneringsrunder_dato: (tournamentRoundToBeCreated.date !== null && tournamentRoundToBeCreated.date.length > 0 ? tournamentRoundToBeCreated.date : null),
              turneringsrunder_kampe: tournamentRoundToBeCreated.numberOfMatches.toString()
            }
          }

          Tournaments.TournamentRoundsDataService.create(createTournamentRoundsData)
            .then((response) => {
              this.lastCreatedTournamentRoundsId = response.data.id
            })
            .catch((err) => {
              console.log(err)
            })
        }
      }

      this.submitted3 = true
    }
  }

  public newCreateTournamentRounds () : void {
    console.log('[newCreateTournamentrounds]')

    this.submitted3 = false
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.tournamentCategoryTitleValue = { text: 'Vælg her', value: '0' }
    this.tournamentRoundsToBeCreated = [{ tagNotClosed: true, date: '', time: '', numberOfMatches: 0 }]
  }

  public editCreateTournamentSeason () : void {
    this.editCreateTournamentSeasonModal = true
  }

  public cancelTournamentSeasonCreateEdit () : void {
    console.log('Cancel tournament season item create.')
    this.editCreateTournamentSeasonModal = false
    this.tournamentSeasonData = { seasonName: '', seasonStartDate: '', seasonEndDate: '', seasonRegistrationDate: '' }
  }

  public createTournamentSeason () : void {
    if (this.tournamentSeasonData.seasonName.length > 1 && this.tournamentSeasonData.seasonStartDate.length > 1 &&
      this.tournamentSeasonData.seasonEndDate.length > 1 && this.tournamentSeasonData.seasonRegistrationDate.length > 1) {
      const createTournamentSeasonData = {
        saeson_status: true,
        saeson_navn: this.tournamentSeasonData.seasonName,
        saeson_start: this.tournamentSeasonData.seasonStartDate,
        saeson_slut: this.tournamentSeasonData.seasonEndDate,
        saeson_tilmelding: this.tournamentSeasonData.seasonRegistrationDate
      }

      SeasonsDataService.create(createTournamentSeasonData)
        .then((response) => {
          let tempSeaon = {} as SysTournamentSaesonId
          tempSeaon = response.data
          this.lastCreatedTournamentSeasonId = response.data.id
          console.log(response.data)

          this.editCreateTournamentSeasonModal = false
          this.tournamentSeasonData = { seasonName: '', seasonStartDate: '', seasonEndDate: '', seasonRegistrationDate: '' }
          this.$Notification.success({ title: tempSeaon.saeson_navn + ' er blevet oprettet' })
          this.retrieveTournamentMatchSchedule()
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })
    }
  }

  public editCreateTournamentSeasonMatchPlan () : void {
    // this.editCreateTournamentSeasonMatchPlanModal = true

    Tournaments.TournamentCategoriesDataService.findByTournamentCategoryStatus(true, '')
      .then((response) => {
        const tempTournamentCategories = response.data as SysTournamentCategoryId[]
        console.log(response.data)

        this.collapseStateValue1 = false
        this.tournamentMatchScheduleSelectedSlotTextValue = { text: 'Automatisk', value: '-1' }
        this.tournamentCategoryTitleOptions = [{ text: 'Vælg her', value: '0' }]

        for (const tempTournamentCategory of tempTournamentCategories) {
          this.tournamentCategoryTitleOptions.push({ text: tempTournamentCategory.turneringskategori_navn, value: Number(tempTournamentCategory.id).toString() })
        }

        this.editCreateTournamentSeasonMatchPlanModal = true
      })
      .catch((err) => {
        this.error = err
        // console.log(err)
      })
  }

  public getTournamentSeasonMatchPlanTeamsRowsTextValuesMatches (rowIndex: number) : any {
    return this.tournamentSeasonMatchPlanTeamsTextValue[rowIndex].matches
  }

  public editCreateTournamentSeasonMatchPlanAlert () : void {
    alert('Advarsel: udførelse af denne funktion vil kunne overskrive eksisterende kampplan-informationer.')
  }

  public cancelTournamentSeasonMatchPlanCreateEdit () : void {
    console.log('Cancel tournament season match plan item create.')
    this.editCreateTournamentSeasonMatchPlanModal = false
    this.createTournamentSeasonMatchPlanEditModal = false
    this.actionModeOfSaveTournamentSeasonMatchPlanButton = false
    this.cancelSaveTournamentSeasonMatchPlanButtonTriggered = false
    this.currentSelectedTournamentSeasonMatchPlanTeamsTextValueRowIndex = 1
    // this.tournamentSeasonTextOptions = [{ text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }]
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    // this.tournamentCategoryTitleOptions = [{ text: 'Vælg her', value: '0' }]
    this.tournamentCategoryTitleValue = { text: 'Vælg her', value: '0' }
    this.matchPlannerData = {
      matchPerDay: 2,
      skipMatchPerDayFirstRound: true,
      meetEachTeamTimes: 2,
      matchNumberOfRoundsWithLargestDivisionTeams: true,
      timeBetweenMatches: 5,
      autoIncreaseNumbTimesTeamsMeetsTreshold: 0
    }
    this.retrieveTournamentMatchSchedule()
  }

  public retrieveTeams (activateEditTournamentMatchScheduleModalFlag: boolean | null = null, useSeasonRowInfo: boolean | null = null): void {
    let extraAPIParameters = ''
    if (activateEditTournamentMatchScheduleModalFlag !== null || (this.teamInputFieldClickCount & 1) === 1) {
      console.log('Get teams data from API.')

      if (useSeasonRowInfo !== null && useSeasonRowInfo === true) {
        if (Number(this.tournamentSeasonTextValue.value) >= 1 && Number(this.tournamentRowsNameValue.value) >= 1) {
          extraAPIParameters = `saeson_id.id=${this.tournamentSeasonTextValue.value.toString()}&raekke_id.id=${this.tournamentRowsNameValue.value.toString()}`
        } else if (Number(this.tournamentSeasonTextValue.value) >= 1) {
          extraAPIParameters = `saeson_id.id=${this.tournamentSeasonTextValue.value.toString()}`
        } else if (Number(this.tournamentRowsNameValue.value) >= 1) {
          extraAPIParameters = `raekke_id.id=${this.tournamentRowsNameValue.value.toString()}`
        }
      }
      // console.log('[retrieveTeams()] extraAPIParameters = ' + extraAPIParameters)

      TeamsDataService.getAll('', null, extraAPIParameters)
        .then((response) => {
          const tempTeams = response.data
          // console.log(response.data)
          console.log('called')

          // Fill the team options array of the selects.
          this.homeTeamNameOptions = [{ text: 'Vælg her', value: '0' }]
          this.guestTeamNameOptions = [{ text: 'Vælg her', value: '0' }]
          for (const teamItem of tempTeams) {
            this.homeTeamNameOptions.push({
              text: teamItem.hold_holdnavn,
              value: (teamItem.id === undefined ? '0' : Number(teamItem.id).toString())
            })
            this.guestTeamNameOptions.push({
              text: teamItem.hold_holdnavn,
              value: (teamItem.id === undefined ? '0' : Number(teamItem.id).toString())
            })

            // Set selection value of team option selection to the value of the currently set match schedule.
            if (teamItem.id !== undefined && this.tempTournamentMatchSchedule.kampprogram_hjemmehold !== undefined && this.tempTournamentMatchSchedule.kampprogram_hjemmehold !== null && Number(this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id) === Number(teamItem.id)) {
              this.homeTeamNameValue = {
                text: this.tempTournamentMatchSchedule.kampprogram_hjemmehold.hold_holdnavn,
                value: Number(this.tempTournamentMatchSchedule.kampprogram_hjemmehold.id).toString()
              }
            }
            if (teamItem.id !== undefined && this.tempTournamentMatchSchedule.kampprogram_udehold !== undefined && this.tempTournamentMatchSchedule.kampprogram_udehold !== null && Number(this.tempTournamentMatchSchedule.kampprogram_udehold.id) === Number(teamItem.id)) {
              this.guestTeamNameValue = {
                text: this.tempTournamentMatchSchedule.kampprogram_udehold.hold_holdnavn,
                value: Number(this.tempTournamentMatchSchedule.kampprogram_udehold.id).toString()
              }
            }
          }
          // console.log('[retrieveTeams] Home team names object = ' + JSON.stringify(this.homeTeamNameOptions))
          // console.log('[retrieveTeams] Guest team names object = ' + JSON.stringify(this.guestTeamNameOptions))

          // Set the edit dialog modal variable according to the value given as a function flag argument, if the value of the flag argument is different from null and has a valid boolean value.
          if (activateEditTournamentMatchScheduleModalFlag !== null && (activateEditTournamentMatchScheduleModalFlag === true || activateEditTournamentMatchScheduleModalFlag === false)) {
            this.editTournamentMatchScheduleModal = activateEditTournamentMatchScheduleModalFlag
          }
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })
    }
  }

  public async saveTournamentSeasonMatchPlan () : Promise<boolean> {
    console.log('[saveTournamentSeasonMatchPlan] Saving match plan.')

    // Check, if the button is a cancel action button right now, and set triggered flag in the case it was (because the button was activated).
    if (this.actionModeOfSaveTournamentSeasonMatchPlanButton) {
      this.cancelSaveTournamentSeasonMatchPlanButtonTriggered = true
      console.log('[saveTournamentSeasonMatchPlan] Cancel save action triggered!')

      return false
    }

    // Ininitialize some variables for the subsequent processing.
    this.actionModeOfSaveTournamentSeasonMatchPlanButton = true
    this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = 0
    let retVal = true
    this.currentMatchNumber = 1
    let rowMatchesObjItemProcessingProgress = 0
    let arrIndex1 = 0
    const maxMatchScheduleSlotSelectable = Math.max(...this.tournamentMatchScheduleSelectedSlotTextOptions.map(e => Number(e.value)))
    console.log('[createTournamentSeasonMatchPlan] maxMatchScheduleSlotSelectable = ' + maxMatchScheduleSlotSelectable)

    if (this.selectedMatchScheduleSlotToBeUsed === -1) {
      // Get the max used match schedule slots of the season and use it to create new ones in the subsequent processing.
      try {
        const seasonResponse = await SeasonsDataService.asyncGet(Number(this.tournamentSeasonTextValue.value).toString())
        const numberOfSlotsUsedValue = seasonResponse.data.kampprog_antal_brugte_slots
        // seasonResponse = { data: null, status: 0, statusText: '', headers: null, config: {} }

        if (numberOfSlotsUsedValue !== undefined && numberOfSlotsUsedValue !== null && numberOfSlotsUsedValue >= 1) {
          this.selectedMatchScheduleSlotToBeUsed = Number(numberOfSlotsUsedValue)
        } else {
          console.log('[saveTournamentSeasonMatchPlan] Error: The value of the kampprog_antal_brugte_slots field in saesons is either missing or has an illegal value!')

          return false
        }
      } catch (err) {
        // this.error = err
        console.log(err)

        return false
      }
    }

    // Loop over all match rows object elements in the array, that contains the match plan information to be bulk saved.
    for (const tournamentRowMatchesObjItem of this.tournamentSeasonMatchPlanTeamsTextValue) {
      let arrIndex2 = 0

      // Check, if the cancel action of the button was triggered, and in case it was update some save process variables, and break the outermost loop, skipping the normal processing.
      if (this.cancelSaveTournamentSeasonMatchPlanButtonTriggered) {
        arrIndex1++
        rowMatchesObjItemProcessingProgress++
        this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = Math.round(rowMatchesObjItemProcessingProgress * 100 / this.tournamentMatchPlanTotalNumberOfMatches)
        console.log('[saveTournamentSeasonMatchPlan] Cancel save trigger 1 skip.')

        break
      }

      // Loop over all match object elements of the match plan to be bulk saved.
      for (const matchObjItem of tournamentRowMatchesObjItem.matches) {
        // Check, if the cancel action of the button was triggered, and in case it was update some save process variables, and break the innermost loop, skipping the normal processing.
        if (this.cancelSaveTournamentSeasonMatchPlanButtonTriggered) {
          arrIndex2++
          rowMatchesObjItemProcessingProgress++
          this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = Math.round(rowMatchesObjItemProcessingProgress * 100 / this.tournamentMatchPlanTotalNumberOfMatches)
          console.log('[saveTournamentSeasonMatchPlan] Cancel save trigger 2 skip.')

          break
        }

        // Continue to the next match object item, if there is a skip indication in any of the team data fields (value -1 = "Oversidder") returned from the API request.
        if (Number(matchObjItem.homeTeam.value) === -1 || Number(matchObjItem.guestTeam.value) === -1) {
          arrIndex2++
          rowMatchesObjItemProcessingProgress++
          this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = Math.round(rowMatchesObjItemProcessingProgress * 100 / this.tournamentMatchPlanTotalNumberOfMatches)
          console.log('[saveTournamentSeasonMatchPlan] Oversidder skip.')

          continue
        }

        try {
          // Check, if match plan schedule entry already exist.
          // const response = await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('kampprogram_kampnr:desc', { slicemode: 0, start: 0, limit: 1, page: 0, pagesize: 1, totalcount: 1 }, 'saeson_id.id=' + this.tournamentSeasonTextValue.value + '&raekke_id.id=' + Number(tournamentRowMatchesObjItem.tournamentRow.id).toString() + '&kampprogram_kampnr=' + currentMatchNumber.toString())
          // const response = await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('kampprogram_kampnr:desc', { slicemode: 0, start: 0, limit: 1, page: 0, pagesize: 1, totalcount: 1 }, 'saeson_id.id=' + this.tournamentSeasonTextValue.value + '&kampprogram_kampnr=' + this.currentMatchNumber.toString())
          let response = await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('kampprogram_kampnr:desc', { slicemode: 0, start: 0, limit: -1, page: 0, pagesize: 1, totalcount: 1 }, 'saeson_id.id=' + this.tournamentSeasonTextValue.value + '&kampprogram_slotindeks=' + this.selectedMatchScheduleSlotToBeUsed.toString())
          const tempTournamentMatchSchedules = response.data as SysTournamentMatchSchedule[]
          console.log(response.data)
          response = await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('kampprogram_kampnr:desc', { slicemode: 0, start: 0, limit: 1, page: 0, pagesize: 1, totalcount: 1 }, 'saeson_id.id=' + this.tournamentSeasonTextValue.value)

          let matchScheduleDatetime = null
          // response = { data: null, status: 0, statusText: '', headers: null, config: {} }

          if (arrIndex1 === 0 && arrIndex2 === 0 && tempTournamentMatchSchedules.length > 0 && tempTournamentMatchSchedules[0].id !== null && tempTournamentMatchSchedules[0].kampprogram_kampnr !== null && Number(tempTournamentMatchSchedules[0].kampprogram_kampnr) >= 1) {
            this.currentMatchNumber = Number(tempTournamentMatchSchedules[0].kampprogram_kampnr) + 1
            // Delete all match schedules within the match schedule slot for that season.
            console.log('[saveTournamentSeasonMatchPlan] Deleting existing match schedules within the slot!!!')

            if (this.selectedMatchScheduleSlotToBeUsed >= 1) {
              let deletedMatchSchedulesRecordsCount = 0

              for (const matchScheduleObjectItem of tempTournamentMatchSchedules) {
                if (matchScheduleObjectItem.id !== null) {
                  console.log('[saveTournamentSeasonMatchPlan] Deleting record with ID: ' + Number(matchScheduleObjectItem.id).toString())

                  try {
                    const deleteResponse = await Tournaments.TournamentMatchSchedulesDataService.asyncDelete(Number(matchScheduleObjectItem.id).toString())
                    deletedMatchSchedulesRecordsCount++
                    this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = Math.round(deletedMatchSchedulesRecordsCount * 100 / tempTournamentMatchSchedules.length)

                    console.log(deleteResponse.data)
                  } catch (err) {
                    // this.error = err
                    console.log(err)

                    return false
                  }
                }

                this.currentMatchNumber = Number(tempTournamentMatchSchedules[(tempTournamentMatchSchedules.length - 1)].kampprogram_kampnr)
                this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = 0
              }
            } else {
              // There are already records for a match schedule existing for that slot. When the selection of slot is set to automatic, do nothing and bail out.
              console.log('[saveTournamentSeasonMatchPlan] Oops, records for a match schedule is already existing - doing nothing.')

              return false
            }
          } else if (arrIndex1 === 0 && arrIndex2 === 0) {
            try {
              response = await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('kampprogram_kampnr:desc', { slicemode: 0, start: 0, limit: 1, page: 0, pagesize: 1, totalcount: 1 }, 'saeson_id.id=' + this.tournamentSeasonTextValue.value)
              console.log(response.data)
            } catch (err) {
              // this.error = err
              console.log(err)

              return false
            }

            this.currentMatchNumber = (response.data.length > 0 && response.data[0].kampprogram_kampnr !== null && Number(response.data[0].kampprogram_kampnr) >= 1 ? (Number(response.data[0].kampprogram_kampnr) + 1) : 1)
          }

          // Create a new entry for that match plan schedule.
          console.log('[saveTournamentSeasonMatchPlan] Create a new match plan entry.')
          if (matchObjItem.date !== null && matchObjItem.date.length > 0) {
            matchScheduleDatetime = this.convertDatetimeToUTC(matchObjItem.date + '.000+00:00')
          }

          const createTournamentMatchSchedulesData = {
            saeson_id: Number(this.tournamentSeasonTextValue.value),
            raekke_id: Number(tournamentRowMatchesObjItem.tournamentRow.id),
            kampprogram_kampnr: this.currentMatchNumber.toString(),
            kampprogram_slotindeks: this.selectedMatchScheduleSlotToBeUsed.toString(),
            /* kampprogram_dato: (matchObjItem.date !== null && matchObjItem.date.length > 0 ? matchObjItem.date + ':00.000Z' : null), */
            kampprogram_dato: (matchScheduleDatetime !== null && matchScheduleDatetime.length > 0 ? (new Date(matchScheduleDatetime)).toISOString() : null),
            kampprogram_hjemmehold: (Number(matchObjItem.homeTeam.value) > 0 ? matchObjItem.homeTeam.value : null),
            kampprogram_udehold: (Number(matchObjItem.guestTeam.value) > 0 ? matchObjItem.guestTeam.value : null)
          }

          console.log('[saveTournamentSeasonMatchPlan] createTournamentMatchSchedulesData = ' + JSON.stringify(createTournamentMatchSchedulesData))
          this.currentMatchNumber++
          this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = Math.round(rowMatchesObjItemProcessingProgress * 100 / this.tournamentMatchPlanTotalNumberOfMatches)

          Tournaments.TournamentMatchSchedulesDataService.create(createTournamentMatchSchedulesData)
            .then((response) => {
              // this.lastUpdateTournamentMatchSchedulesId = response.data.id
              console.log(response.data)

              return true
            })
            .catch((err) => {
              // this.error = err
              console.log(err)

              return false
            })

          // return true
        } catch (err) {
          // this.error = err
          console.log(err)
        }

        arrIndex2++
        rowMatchesObjItemProcessingProgress++
        this.tournamentMatchPlanNumberOfMatchesSavedProgressValue = Math.round(rowMatchesObjItemProcessingProgress * 100 / this.tournamentMatchPlanTotalNumberOfMatches)

        console.log('[saveTournamentSeasonMatchPlan] rowMatchesObjItemProcessingProgress out of tournamentMatchPlanTotalNumberOfMatches = ' + rowMatchesObjItemProcessingProgress + ' of ' + this.tournamentMatchPlanTotalNumberOfMatches)
      }
      console.log('[saveTournamentSeasonMatchPlan] arrIndex2  = ' + arrIndex2.toString())

      arrIndex1++
    }

    // Update the max used slots field of the season.
    if (!this.cancelSaveTournamentSeasonMatchPlanButtonTriggered && this.selectedMatchScheduleSlotToBeUsed >= maxMatchScheduleSlotSelectable) {
      const updateTournamentSeasonData = {
        kampprog_antal_brugte_slots: (this.selectedMatchScheduleSlotToBeUsed + 1).toString()
      }

      SeasonsDataService.update(Number(this.tournamentSeasonTextValue.value).toString(), updateTournamentSeasonData)
        .then((response) => {
          // this.lastUpdateTournamentCategoryId = response.data.id
          console.log(response.data)
        })
        .catch((err) => {
          // this.error = err
          console.log(err)
        })
    }

    console.log('[saveTournamentSeasonMatchPlan] arrIndex1  = ' + arrIndex1.toString())
    retVal = !this.cancelSaveTournamentSeasonMatchPlanButtonTriggered
    console.log('[saveTournamentSeasonMatchPlan] Terminating return value = ' + retVal.toString())
    this.cancelSaveTournamentSeasonMatchPlanButtonTriggered = false
    this.actionModeOfSaveTournamentSeasonMatchPlanButton = false

    return retVal
  }

  public convertDatetimeToUTC (datetime: string) : string {
    let retVal = ''

    if (datetime !== null && datetime.length > 0) {
      // const theLocalDatetime = new Date('2022-04-13T12:00:00.000+00:00')
      const theLocalDatetime = new Date(datetime)
      const offsetToUTC = CommonFunctions.getUTCOffset(theLocalDatetime.getUTCFullYear(), theLocalDatetime.getUTCMonth() + 1, theLocalDatetime.getUTCDate(), theLocalDatetime.getUTCHours(), theLocalDatetime.getUTCMinutes(), theLocalDatetime.getUTCSeconds(), 'Europe/Copenhagen')
      retVal = theLocalDatetime.toISOString().substring(0, 23) + (offsetToUTC >= 0 ? '+' : '') + Math.trunc(offsetToUTC / 60).toString().padStart(2, '0') + ':' + (offsetToUTC % 60).toString().padStart(2, '0')
      console.log('[convertDatetimeToUTC] datetime = ' + datetime)
      console.log('[convertDatetimeToUTC] Date(datetime) = ' + theLocalDatetime.toString())
      console.log('[convertDatetimeToUTC] The time normal datetime string = ' + retVal)
      console.log('[convertDatetimeToUTC] The time converted to UTC ISO datetime = ' + new Date(retVal).toISOString())
    }

    return retVal
  }

  public updateTournamentCategory () : boolean {
    console.log('Update information of tournament category item with Id: ' + this.lastEditedTournamentCategoryId)

    if (this.tournamentCategoryData.categoryName.length > 1 && !isNaN(Number(this.tournamentCategoryData.categoryPrice)) && Number(this.tournamentCategoryData.categoryPrice) >= 0) {
      const updateTournamentCategoryData = {
        data: {
          turneringskategori_navn: this.tournamentCategoryData.categoryName,
          turneringskategori_pris: Number(this.tournamentCategoryData.categoryPrice).toString()
        }
      }

      Tournaments.TournamentCategoriesDataService.update(this.lastEditedTournamentCategoryDocumentId, updateTournamentCategoryData)
        .then(() => {
          // this.lastUpdateTournamentCategoryId = response.data.id
          // this.$Message.success({ text: 'Turnering er blevet opdateret' })
          // this.$Notification.success({ title: 'Turneringskategorien er blevet opdateret' })
          this.$Notification.success({ title: 'Ændringerne af kategoriens oplysninger blev gemt' })
          this.retrieveTournamentCategories()
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })

      this.editTournamentCategoryModal = false
      this.tournamentCategoryData = { categoryName: '', categoryPrice: 0 }
      return true
    }

    return false
  }

  public updateTournamentRow () : boolean {
    console.log('Update information of tournament row item with Id: ' + this.lastEditedTournamentRowId)

    if (this.tournamentRowData.rowName.trim().length > 1 &&
      !isNaN(Number(this.tournamentRowData.numberOfSets)) && Number(this.tournamentRowData.numberOfSets) >= 0 &&
      !isNaN(Number(this.tournamentRowData.minNumberOfTeams)) && Number(this.tournamentRowData.minNumberOfTeams) >= 0 &&
      !isNaN(Number(this.tournamentRowData.maxNumberOfTeams)) && Number(this.tournamentRowData.maxNumberOfTeams) >= 0 &&
      !isNaN(Number(this.tournamentRowData.numberOfTeamsPerClub)) && Number(this.tournamentRowData.numberOfTeamsPerClub) >= 0 &&
      !isNaN(Number(this.tournamentRowData.numberOfPlayers)) && Number(this.tournamentRowData.numberOfPlayers) >= 0 &&
      !isNaN(Number(this.tournamentRowData.maxNumberOfPlayers)) && Number(this.tournamentRowData.maxNumberOfPlayers) >= 0) {
      const updateTournamentRowData = {
        data: {
          raekke_navn: this.tournamentRowData.rowName,
          raekke_antalsaet: Number(this.tournamentRowData.numberOfSets).toString(),
          raekke_minhold: Number(this.tournamentRowData.minNumberOfTeams).toString(),
          raekke_maxhold: Number(this.tournamentRowData.maxNumberOfTeams).toString(),
          raekke_holdprklub: Number(this.tournamentRowData.numberOfTeamsPerClub).toString(),
          raekke_antalspillere: Number(this.tournamentRowData.numberOfPlayers).toString(),
          raekke_maxspillere: Number(this.tournamentRowData.maxNumberOfPlayers).toString()
        }
      }
      const updateTournamentRowWithoutNameData = {
        data: {
          raekke_antalsaet: Number(this.tournamentRowData.numberOfSets).toString(),
          raekke_minhold: Number(this.tournamentRowData.minNumberOfTeams).toString(),
          raekke_maxhold: Number(this.tournamentRowData.maxNumberOfTeams).toString(),
          raekke_holdprklub: Number(this.tournamentRowData.numberOfTeamsPerClub).toString(),
          raekke_antalspillere: Number(this.tournamentRowData.numberOfPlayers).toString(),
          raekke_maxspillere: Number(this.tournamentRowData.maxNumberOfPlayers).toString()
        }
      }
      let matchingTournamentRows: SysTournamentRow[] = []
      let searchBaseNameEndPos = Math.max(this.tournamentRowData.rowName.trim().lastIndexOf(' '), this.tournamentRowData.rowName.trim().lastIndexOf('-'))
      searchBaseNameEndPos = searchBaseNameEndPos >= 0 ? searchBaseNameEndPos : this.tournamentRowData.rowName.length - 1
      const searchBaseName = this.tournamentRowData.rowName.trim().slice(0, searchBaseNameEndPos).toLocaleLowerCase()
      // console.log('searchBaseName = ***' + searchBaseName + '***')

      Tournaments.TournamentRowsDataService.findBySearchTerm(true, true, this.tournamentRowSearchTerm)
        .then((response) => {
          matchingTournamentRows = response.data
          const tempCurrentlyEditedTournamentRowId = this.lastEditedTournamentRowId
          console.log(response.data)

          // Find all ids of tournament rows, that matches the base name in the beginning of the name of the currently edited tournament row.
          const startsWithMatchId: number[] = []
          const documentIds: string[] = []

          for (const matchingTournamentRow of matchingTournamentRows) {
            if (matchingTournamentRow.raekke_navn.trim().toLocaleLowerCase().startsWith(searchBaseName)) {
              documentIds.push(matchingTournamentRow.documentId)
              startsWithMatchId.push(Number(matchingTournamentRow.id))
            }
          }
          matchingTournamentRows = []
          console.log('[updateTournamentRow] startsWithMatchId = ' + JSON.stringify(startsWithMatchId))

          // Update the data of each found tournament rows via the API.
          for (let loopIndex = 0; loopIndex < startsWithMatchId.length; loopIndex++) {
            // Update the data of a matching tournament rows via the API.
            Tournaments.TournamentRowsDataService.update(documentIds[loopIndex], (startsWithMatchId[loopIndex] === tempCurrentlyEditedTournamentRowId ? updateTournamentRowData : updateTournamentRowWithoutNameData))
              .then(() => {
                // this.lastUpdateTournamentRowId = response.data.id

                if (loopIndex >= startsWithMatchId.length - 1) {
                  this.retrieveTournamentRows()
                  this.$Message.success({ text: 'Ændringerne af ' + (loopIndex > 0 ? 'rækkernes' : 'rækkens') + ' oplysninger blev gemt' })
                }
              })
              .catch((err) => {
                this.error = err
              })

            this.retrieveTournamentRows()
          }
        })
        .catch((err) => {
          this.error = err
        })

      this.editTournamentRowModal = false
      this.tournamentRowData = { rowName: '', numberOfSets: 0, minNumberOfTeams: 0, maxNumberOfTeams: 0, numberOfTeamsPerClub: 0, numberOfPlayers: 0, maxNumberOfPlayers: 0 }
      return true
    }

    return false
  }

  public updateTournamentMatchSchedule () : boolean {
    console.log('Updating information of tournament match schedule item with Id: ' + this.lastEditedTournamentMatchScheduleId)

    if (this.homeTeamNameValue.value !== null && Number(this.homeTeamNameValue.value) > 0 && this.guestTeamNameValue.value !== null && Number(this.guestTeamNameValue.value) > 0) {
      let updateTournamentMatchScheduleData
      let matchScheduleProtestCancellationNonAppearanceEnumValue: tournamentMatchScheduleTeamStatusFriendlyType | null = null

      switch (this.tournamentMatchSettlementTeamProtestStatusValue) {
        case 'Protest fra hjemmeholdet':
          matchScheduleProtestCancellationNonAppearanceEnumValue = tournamentMatchScheduleTeamStatusFriendlyType.Protesthjem
          break
        case 'Protest fra udeholdet':
          matchScheduleProtestCancellationNonAppearanceEnumValue = tournamentMatchScheduleTeamStatusFriendlyType.Protestud
          break
        case 'Afbud fra hjemmeholdet':
          matchScheduleProtestCancellationNonAppearanceEnumValue = tournamentMatchScheduleTeamStatusFriendlyType.Afbudhjem
          break
        case 'Afbud fra udeholdet':
          matchScheduleProtestCancellationNonAppearanceEnumValue = tournamentMatchScheduleTeamStatusFriendlyType.Afbudud
          break
        case 'Udeblivelse af hjemmeholdet':
          matchScheduleProtestCancellationNonAppearanceEnumValue = tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelsehjem
          break
        case 'Udeblivelse af udeholdet':
          matchScheduleProtestCancellationNonAppearanceEnumValue = tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelseud
          break
      }
      this.tournamentMatchScheduleData.matchScheduleCommentStatus = matchScheduleProtestCancellationNonAppearanceEnumValue
      const isTotalResultScoreModified = this.checkMatchScheduleTeamStatusAndModifyTotalResultScoreAccordingly()

      if (this.tournamentMatchScheduleData.matchScheduleDateNewDate === null ||
        this.tournamentMatchScheduleData.matchScheduleDateNewDate.startsWith('1970-01-01') ||
        (this.tournamentMatchScheduleData.matchScheduleDateNewDate === this.tournamentMatchScheduleData.matchScheduleDate && (this.tempTournamentMatchSchedule.kampprogram_nydato === null || this.tempTournamentMatchSchedule.kampprogram_nydato.length === 0))) {
        if (this.matchScheduleDateLockFlag) {
          updateTournamentMatchScheduleData = {
            kampprogram_hjemmehold: Number(this.homeTeamNameValue.value).toString(),
            kampprogram_udehold: Number(this.guestTeamNameValue.value).toString(),
            kampprogram_kommentar: this.tournamentMatchScheduleData.matchScheduleComment,
            kampprogram_afb_udb: matchScheduleProtestCancellationNonAppearanceEnumValue
          }
        } else {
          updateTournamentMatchScheduleData = {
            kampprogram_dato: (this.tournamentMatchScheduleData.matchScheduleDate.length > 0 ? (new Date(this.tournamentMatchScheduleData.matchScheduleDate)).toISOString() : null),
            kampprogram_hjemmehold: Number(this.homeTeamNameValue.value).toString(),
            kampprogram_udehold: Number(this.guestTeamNameValue.value).toString(),
            kampprogram_kommentar: this.tournamentMatchScheduleData.matchScheduleComment,
            kampprogram_afb_udb: matchScheduleProtestCancellationNonAppearanceEnumValue
          }
        }
      } else {
        if (this.matchScheduleDateLockFlag) {
          updateTournamentMatchScheduleData = {
            kampprogram_nydato: (this.tournamentMatchScheduleData.matchScheduleDateNewDate.length > 0 ? (new Date(this.tournamentMatchScheduleData.matchScheduleDateNewDate)).toISOString() : null),
            kampprogram_hjemmehold: Number(this.homeTeamNameValue.value).toString(),
            kampprogram_udehold: Number(this.guestTeamNameValue.value).toString(),
            kampprogram_kommentar: this.tournamentMatchScheduleData.matchScheduleComment,
            kampprogram_afb_udb: matchScheduleProtestCancellationNonAppearanceEnumValue
          }
        } else {
          updateTournamentMatchScheduleData = {
            kampprogram_dato: (this.tournamentMatchScheduleData.matchScheduleDate.length > 0 ? (new Date(this.tournamentMatchScheduleData.matchScheduleDate)).toISOString() : null),
            kampprogram_nydato: (this.tournamentMatchScheduleData.matchScheduleDateNewDate.length > 0 ? (new Date(this.tournamentMatchScheduleData.matchScheduleDateNewDate)).toISOString() : null),
            kampprogram_hjemmehold: Number(this.homeTeamNameValue.value).toString(),
            kampprogram_udehold: Number(this.guestTeamNameValue.value).toString(),
            kampprogram_kommentar: this.tournamentMatchScheduleData.matchScheduleComment,
            kampprogram_afb_udb: matchScheduleProtestCancellationNonAppearanceEnumValue
          }
        }
      }

      Tournaments.TournamentMatchSchedulesDataService.update(this.lastEditedTournamentMatchScheduleId.toString(), updateTournamentMatchScheduleData)
        .then((response) => {
          // this.lastUpdateTournamentMatchScheduleId = response.data.id
          // console.log(response.data)

          if (isTotalResultScoreModified) {
            const updateTournamentMatchSettlement = {
              kampafvikling_resultat_hjem: this.tournamentMatchScheduleData.matchHomeTeamResult,
              kampafvikling_resultat_ude: this.tournamentMatchScheduleData.matchGuestTeamResult
              // kampafvikling_dom_mod_hjhold: (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 0.5 ? null : (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1)),
              // kampafvikling_dom_mod_udhold: (this.tournamentMatchScheduleData.matchGuestTeamVerdict === 0.5 ? null : (this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1))
            }

            Tournaments.TournamentMatchSettlementDataService.getAll('', null, 'kampprogram_id.id=' + this.lastEditedTournamentMatchScheduleId.toString())
              .then((response) => {
                // console.log(response.data)

                if ((<any[]>response.data).length < 1 || response.data[0] === undefined || response.data[0] === null || response.data[0].kampprogram_id === undefined) {
                  const createTournamentMatchSettlementData = {
                    kampprogram_id: this.lastEditedTournamentMatchScheduleId.toString(),
                    kampafvikling_resultat_hjem: this.tournamentMatchScheduleData.matchHomeTeamResult,
                    kampafvikling_resultat_ude: this.tournamentMatchScheduleData.matchGuestTeamResult
                    // kampafvikling_dom_mod_hjhold: (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 0.5 ? null : (this.tournamentMatchScheduleData.matchHomeTeamVerdict === 1)),
                    // kampafvikling_dom_mod_udhold: (this.tournamentMatchScheduleData.matchGuestTeamVerdict === 0.5 ? null : (this.tournamentMatchScheduleData.matchGuestTeamVerdict === 1))
                  }

                  Tournaments.TournamentMatchSettlementDataService.create(createTournamentMatchSettlementData)
                    .then((response) => {
                      this.lastCreatedTournamentMatchSettlementId = response.data.id
                      this.tempTournamentMatchSettlement = response.data
                      // console.log(response.data)

                      this.$Notification.success({ title: 'Ændringerne af kampens oplysninger blev gemt' })
                      this.editTournamentMatchScheduleModal = false
                      this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
                      this.retrieveTournamentMatchSchedule()
                    })
                    .catch((err) => {
                      this.error = err
                      // console.log(err)
                    })
                    .finally(() => {
                      return true
                    })
                } else {
                  this.tempTournamentMatchSettlement = response.data[0]

                  // Update the total score result via API access for each team of this match settlement.
                  Tournaments.TournamentMatchSettlementDataService.update(Number(this.tempTournamentMatchSettlement.id).toString(), updateTournamentMatchSettlement)
                    .then((response) => {
                      // this.lastUpdatedTournamentMatchSettlementId = response.data.id
                      // console.log(response.data)

                      this.$Notification.success({ title: 'Ændringerne af kampens oplysninger blev gemt' })
                      this.editTournamentMatchScheduleModal = false
                      this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
                      this.retrieveTournamentMatchSchedule()
                    })
                    .catch((err) => {
                      this.error = err
                      // console.log(err)
                    })
                }
              })
              .catch((err) => {
                this.error = err
              })
          } else {
            this.$Notification.success({ title: 'Ændringerne af kampens oplysninger blev gemt' })
            this.editTournamentMatchScheduleModal = false
            this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
            this.retrieveTournamentMatchSchedule()
          }

          // Update or create information about whether the match execution was approved (or not).
          const createTournamentMatchFinalApprovalData = {
            kampprogram_id: Number(this.lastEditedTournamentMatchScheduleId).toString(),
            kampgodkendt_godkendt: this.matchFinalApproval.new
          }
          const updateTournamentMatchFinalApproval = {
            kampgodkendt_godkendt: this.matchFinalApproval.new
          }

          if (this.matchFinalApproval.new !== this.matchFinalApproval.orig) {
            Tournaments.TournamentMatchFinalApproval.getAll('', null, 'kampprogram_id.id=' + this.lastEditedTournamentMatchScheduleId.toString())
              .then((response) => {
                // console.log(response.data)

                if ((<any[]>response.data).length < 1 || response.data[0] === undefined || response.data[0] === null || response.data[0].kampprogram_id === undefined) {
                  Tournaments.TournamentMatchFinalApproval.create(createTournamentMatchFinalApprovalData)
                    .then((response) => {
                      console.log('[updateTournamentMatchSchedule()] Match approved setting was created with value = ' + this.matchFinalApproval.new.toString())
                    })
                    .catch((err) => {
                      console.log(err)
                    })
                    .finally(() => {
                      return true
                    })
                } else {
                  const tempTournamentMatchFinalApproval = response.data[0] as SysTournamentMatchFinalApproval

                  Tournaments.TournamentMatchFinalApproval.update(Number(tempTournamentMatchFinalApproval.id).toString(), updateTournamentMatchFinalApproval)
                    .then((response) => {
                      console.log('[updateTournamentMatchSchedule()] Match approved setting was updated to value = ' + this.matchFinalApproval.new.toString())
                    })
                    .catch((err) => {
                      console.log(err)
                    })
                    .finally(() => {
                      return true
                    })
                }
              })
              .catch((err) => {
                this.error = err
              })
          }
        })
        .catch((err) => {
          this.error = err
          // console.log(err)

          this.editTournamentMatchScheduleModal = false
          this.tournamentMatchScheduleData = { matchNumber: 0, matchScheduleDate: '', matchScheduleDateNewDate: '', matchScheduleComment: '', matchScheduleCommentStatus: null, matchHomeTeamId: 0, matchHomeTeamName: '', matchHomeTeamResult: 0, matchGuestTeamId: 0, matchGuestTeamName: '', matchGuestTeamResult: 0, matchHomeTeamVerdict: 0.5, matchGuestTeamVerdict: 0.5, matchTournamentRow: { id: 0, status: false, name: '' } }
        })

      return true
    }

    return false
  }

  public editCreateNewTournamentSeason () : void {
    //
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.newTournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.tournamentCategoryTitleValue = { text: 'Vælg her', value: '0' }
    // this.tournamentSeasonSeriesTextValue = { text: 'Vælg her', value: '0' }
    this.editCreateNewTournamentSeasonModal = true
  }

  public cancelCreateNewTournamentSeasonEdit () : void {
    this.editCreateNewTournamentSeasonModal = false
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.newTournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.tournamentCategoryTitleValue = { text: 'Vælg her', value: '0' }
    // this.tournamentSeasonSeriesTextValue = { text: 'Vælg her', value: '0' }
  }

  public editFinalizeTournamentSeason () : void {
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.tournamentSeasonSeriesTextValue = { text: 'Vælg her', value: '0' }
    this.currentMatchesTeamRankingsSavedProgressValue = 0
    this.editFinalizeTournamentSeasonModal = true
  }

  public cancelTournamentSeasonFinalizationEdit () : void {
    this.editFinalizeTournamentSeasonModal = false
    this.tournamentSeasonTextValue = { text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }
    this.tournamentSeasonSeriesTextValue = { text: 'Vælg her', value: '0' }
    this.currentMatchesTeamRankingsSavedProgressValue = 0
  }

  public async saveCurrentMatchesTeamRankings () : Promise<void> {
    // FIXME: Should be changed so that individual tournament categories can be saved individualy.
    if (Number(this.tournamentSeasonTextValue.value) >= 1 && Number(this.tournamentSeasonSeriesTextValue.value) >= 1) {
      this.disableStartButtonWhenSavingCurrentMatchesTeamRankings = true
      let teamRankingsArray: teamRankingsArrayType[] = []
      let seriesString = '1. division'
      let seriesId = 58
      const seasonId = Number(this.tournamentSeasonTextValue.value)
      let tempTournamentRows: SysTournamentRow[] = []
      this.currentMatchesTeamRankingsSavedProgressValue = 0
      this.numberOfTeamRankingsArrayItemsSaved = 0

      try {
        tempTournamentRows = (await Tournaments.TournamentRowsDataService.asyncGetAll('', null, `raekke_status=true&saeson_id=${seasonId.toString()}`)).data
        console.log(tempTournamentRows)

        // Loop through all rows of the season and perform calculation of placement, point etc. and send it to the API for storage.
        for (const tournamentRowsItem of tempTournamentRows) {
          if (Number(tournamentRowsItem.id) >= 1) {
            if ((Number(this.tournamentSeasonSeriesTextValue.value) === 1 && !tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 2 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('forår')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 3 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('efterår')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 4 && (tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('division') || tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('danmark') || tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('kval') || tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('playoff') || tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('serie')) && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('hovedturnering')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 5 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('hverdag') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('hverdagsrækken')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 6 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('oldboys') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('oldboys') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().trim().endsWith('35+')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 7 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('oldboys') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('oldboys') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().trim().endsWith('35+ vest')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 8 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('oldboys') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('oldboys') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().trim().endsWith('50+')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 9 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('damepairs') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('damepairs')) ||
              (Number(this.tournamentSeasonSeriesTextValue.value) === 10 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('bornholm') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('bornholm'))) {
              seriesString = tournamentRowsItem.raekke_navn
              seriesId = Number(tournamentRowsItem.id)
              const retrieveRulesPromise = Tournaments.TournamentRulesDataService.getAll()
              const retrieveTeamsPromise = TeamsDataService.getAll('', null, `saeson_id=${seasonId.toString()}&raekke_id=${seriesId}`)
              const retrieveMatchSchedulePromise = Tournaments.TournamentMatchSchedulesDataService.getAll('', null, `saeson_id=${seasonId}&raekke_id=${seriesId}`)

              await Promise.all([retrieveRulesPromise, retrieveTeamsPromise, retrieveMatchSchedulePromise])
                .then(async (response) => {
                  const rules = response[0].data as SysTournamentRules[]
                  const teams = response[1].data as SysTeam[]
                  const matchSchedule = response[2].data as SysTournamentMatchSchedule[]
                  let teamRankingsPlacement = 0

                  try {
                    teamRankingsArray = await TournamentCommonFunctions.buildMatchesTeamRankings(seriesString, rules, teams, matchSchedule)
                  } catch (err) {
                    console.log(err)
                  }

                  console.log('[saveCurrentMatchesTeamRankings()] teamRankingsArray = ' + JSON.stringify(teamRankingsArray))

                  if (teamRankingsArray === undefined || teamRankingsArray === null || teamRankingsArray.length === 0) {
                    this.numberOfTeamRankingsArrayItemsSaved++
                    this.currentMatchesTeamRankingsSavedProgressValue = Math.round((this.numberOfTeamRankingsArrayItemsSaved * 100) / tempTournamentRows.length)
                  }

                  for (const teamRankingsArrayItem of teamRankingsArray) {
                    teamRankingsPlacement++

                    // Check if there already is an entry for the particular team, and if there is then continue the loop without further processing.
                    try {
                      const getResponse = await Tournaments.TournamentMatchesTeamRankingsDataService.asyncGetAll('', null, 'hold_id.id=' + teamRankingsArrayItem.teamId.toString())

                      if ((<any[]>getResponse.data).length >= 1 && getResponse.data[0] !== undefined && getResponse.data[0] !== null && getResponse.data[0].hold_id !== undefined) {
                        if (Number(teamRankingsPlacement.toString()) === teamRankingsArray.length) {
                          this.numberOfTeamRankingsArrayItemsSaved++
                          this.currentMatchesTeamRankingsSavedProgressValue = Math.round((this.numberOfTeamRankingsArrayItemsSaved * 100) / tempTournamentRows.length)
                          console.log('[saveCurrentMatchesTeamRankings()] Saved ' + this.numberOfTeamRankingsArrayItemsSaved + ' out of ' + tempTournamentRows.length)
                        }

                        continue
                      }
                    } catch (err) {
                      console.log(err)
                      continue
                    }

                    // Tournaments.TournamentMatchesTeamRankingsDataService.getAll('', null, 'hold_id.id=' + teamRankingsArrayItem.teamId.toString())
                    //   .then((response) => {
                    //     console.log(response.data)

                    const createMatchesTeamRankings = {
                      hold_id: teamRankingsArrayItem.teamId.toString(),
                      stillinger_placering: teamRankingsPlacement.toString(),
                      stillinger_kampe: teamRankingsArrayItem.matches.toString(),
                      stillinger_vundet: teamRankingsArrayItem.won.toString(),
                      stillinger_uafgjort: teamRankingsArrayItem.tied.toString(),
                      stillinger_tabt: teamRankingsArrayItem.lost.toString(),
                      stillinger_score: teamRankingsArrayItem.wonScore.toString() + '-' + teamRankingsArrayItem.lostScore.toString(),
                      stillinger_point: teamRankingsArrayItem.points.toString()
                    }

                    console.log('[saveCurrentMatchesTeamRankings()] Creating placement #' + teamRankingsPlacement + ' entry for ranking with: ' + JSON.stringify(createMatchesTeamRankings))

                    // if ((<any[]>response.data).length < 1 || response.data[0] === undefined || response.data[0] === null || response.data[0].hold_id === undefined) {
                    try {
                      const createResponse = await Tournaments.TournamentMatchesTeamRankingsDataService.asyncCreate(createMatchesTeamRankings)
                      console.log(createResponse.data)
                    } catch (err) {
                      // this.error = err
                      console.log(err)
                    }

                    if (Number(createMatchesTeamRankings.stillinger_placering) === teamRankingsArray.length) {
                      this.numberOfTeamRankingsArrayItemsSaved++
                      this.currentMatchesTeamRankingsSavedProgressValue = Math.round((this.numberOfTeamRankingsArrayItemsSaved * 100) / tempTournamentRows.length)
                      console.log('[saveCurrentMatchesTeamRankings()] Saved ' + this.numberOfTeamRankingsArrayItemsSaved + ' out of ' + tempTournamentRows.length)
                    }

                    // } else {
                    //   if (Number(createMatchesTeamRankings.stillinger_placering) === teamRankingsArray.length) {
                    //     this.numberOfTeamRankingsArrayItemsSaved++
                    //     this.currentMatchesTeamRankingsSavedProgressValue = Math.round((this.numberOfTeamRankingsArrayItemsSaved * 100) / tempTournamentRows.length)
                    //     console.log('[saveCurrentMatchesTeamRankings()] Saved ' + this.numberOfTeamRankingsArrayItemsSaved + ' out of ' + tempTournamentRows.length)
                    //   }
                    // }
                    // })
                    // .catch((err) => {
                    //   this.error = err
                    // })
                  }
                })
                .catch((err) => {
                  console.log(err)
                })
                // .finally(() => {
                // })
            } else {
              this.numberOfTeamRankingsArrayItemsSaved++
              this.currentMatchesTeamRankingsSavedProgressValue = Math.round((this.numberOfTeamRankingsArrayItemsSaved * 100) / tempTournamentRows.length)
            }
          }
        }

        this.disableStartButtonWhenSavingCurrentMatchesTeamRankings = false
      } catch (err) {
        console.log(err)
      }
    }
  }

  public async showTeamRankingsAdjustableDivisioning () : Promise<void> {
    if (Number(this.tournamentSeasonTextValue.value) >= 1 && Number(this.newTournamentSeasonTextValue.value) >= 1 && Number(this.tournamentCategoryTitleValue.value) >= 1) {
      this.editCreateNewTournamentSeasonModal = false

      let seriesId = 58
      const seasonId = Number(this.tournamentSeasonTextValue.value)
      const newSeasonId = Number(this.newTournamentSeasonTextValue.value)
      const retriveSeasonId = newSeasonId
      let tempTournamentCategories: SysTournamentCategoryId[] = []
      // let tempTournamentRows: SysTournamentRow[] = []
      let rowMaxOrdinal = 0 // This is for the new season only. Maximum value ordinal corresponds to lowest division.
      const rowMaxBranchSubOrdinal: number[] = [-1] // This is for the new season only. This value corresponds a branch within same ordinal (eg. 3A or 3B within 3rd division).
      const rowParentIdOfPreviousSeasonArray: { id: number, parentRowId: number, maxNumberOfTeams: number, numberOfUpMovements: number, assignedOrdinal: number, assignedBranchSubOrdinal: number, regionId: number[] }[] = []
      const rowParentIdOfNewSeasonArray: { id: number, parentRowId: number, maxNumberOfTeams: number, numberOfUpMovements: number, assignedOrdinal: number, assignedBranchSubOrdinal: number, regionId: number[] }[] = []
      const juniorCategoryFlag = (this.tournamentCategoryTitleValue.text.toLocaleLowerCase().includes('junior') ? 1 : 0) | (this.tournamentCategoryTitleValue.text.toLocaleLowerCase().includes('forår') ? 2 : 0) | (this.tournamentCategoryTitleValue.text.toLocaleLowerCase().includes('efterår') ? 4 : 0)
      console.log('[showTeamRankingsAdjustableDivisioning()] juniorCategoryFlag = ' + juniorCategoryFlag)
      const tempTeamsNotFoundInPreviousSeason: teamsNewDivisionPlacementsDataType[] = []
      this.tempHolds = []
      this.newTournamentRowTextOptions = []

      try {
        tempTournamentCategories = (await Tournaments.TournamentCategoriesDataService.asyncGetAll('', null, '')).data
        this.tempTournamentRowsOfPreviousSeason = (await Tournaments.TournamentRowsDataService.asyncGetAll('', null, `raekke_status=true&saeson_id=${seasonId.toString()}`)).data
        // The status of the rows in the new season (or half year season) will be set to false in the beginning when it is created.
        // this.tempTournamentRows = (await Tournaments.TournamentRowsDataService.asyncGetAll('', null, `raekke_status=false&saeson_id=${retriveSeasonId.toString()}`)).data
        this.tempTournamentRows = (await Tournaments.TournamentRowsDataService.asyncGetAll('', null, `saeson_id=${retriveSeasonId.toString()}`)).data
        console.log(this.tempTournamentRowsOfPreviousSeason)
        console.log(this.tempTournamentRows)
        const indexCategoryForJuniorSpringInPreviousSeason = tempTournamentCategories.findIndex(x => (x.turneringskategori_navn.toLocaleLowerCase().includes('junior') && x.turneringskategori_navn.toLocaleLowerCase().includes('forår')))
        const indexCategoryForJuniorFallInPreviousSeason = tempTournamentCategories.findIndex(x => (x.turneringskategori_navn.toLocaleLowerCase().includes('junior') && x.turneringskategori_navn.toLocaleLowerCase().includes('efterår')))

        // const currentBranchSubOrdinal = 0
        let regionIdArr: number[] = []

        // Build an array with tournament rows information and ordinals for division placement (top division has ordinal 0, the next division beneath has ordinal 1 and so on).
        for (const tournamentRowsItem of this.tempTournamentRowsOfPreviousSeason) {
          if (tournamentRowsItem.id !== null && Number(tournamentRowsItem.id) >= 1) {
            regionIdArr = []

            for (let indexRegion = 0; indexRegion < tournamentRowsItem.region_id.length; indexRegion++) {
              regionIdArr.push(Number(tournamentRowsItem.region_id[indexRegion].id))
            }

            // if ((Number(this.tournamentSeasonSeriesTextValue.value) === 1 && !tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior')) || (Number(this.tournamentSeasonSeriesTextValue.value) === 2 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('forår')) || (Number(this.tournamentSeasonSeriesTextValue.value) === 3 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('efterår'))) {
            if (((juniorCategoryFlag & 7) === 0 && !tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior')) || ((juniorCategoryFlag & 3) === 3 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('efterår')) || ((juniorCategoryFlag & 5) === 5 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('forår'))) {
              if (tournamentRowsItem.parent !== null) {
                rowParentIdOfPreviousSeasonArray.push({ id: Number(tournamentRowsItem.id), parentRowId: Number(tournamentRowsItem.parent.id), maxNumberOfTeams: Number(tournamentRowsItem.raekke_maxhold), numberOfUpMovements: Number(tournamentRowsItem.raekke_oprykning), assignedOrdinal: -1, assignedBranchSubOrdinal: (tournamentRowsItem.raekke_gren === undefined || tournamentRowsItem.raekke_gren === null ? 0 : Number(tournamentRowsItem.raekke_gren)), regionId: regionIdArr })
              } else {
                rowParentIdOfPreviousSeasonArray.push({ id: Number(tournamentRowsItem.id), parentRowId: 0, maxNumberOfTeams: Number(tournamentRowsItem.raekke_maxhold), numberOfUpMovements: Number(tournamentRowsItem.raekke_oprykning), assignedOrdinal: 0, assignedBranchSubOrdinal: 0, regionId: regionIdArr })
              }
            }
          }
        }

        let loopFlag = false
        let loopCnt = 0

        do {
          //
          for (const rowParentIdArrayItem of rowParentIdOfPreviousSeasonArray) {
            if (rowParentIdArrayItem.id >= 1) {
              if (Number(rowParentIdArrayItem.parentRowId) >= 1) {
                const indexOfRowParentIdArray = rowParentIdOfPreviousSeasonArray.findIndex(x => x.id === rowParentIdArrayItem.parentRowId)

                if (indexOfRowParentIdArray >= 0) {
                  if (rowParentIdOfPreviousSeasonArray[indexOfRowParentIdArray].assignedOrdinal >= 0) {
                    rowParentIdArrayItem.assignedOrdinal = rowParentIdOfPreviousSeasonArray[indexOfRowParentIdArray].assignedOrdinal + 1
                  } else {
                    loopFlag = true
                  }
                } else {
                  console.log('[showTeamRankingsAdjustableDivisioning()] Oops, parent Id ' + rowParentIdArrayItem.parentRowId + ' is not found the rowParentIdOfPreviousSeasonArray array.')
                }
              }
            }
          }

          loopCnt++
        } while (loopFlag === true && loopCnt <= rowParentIdOfPreviousSeasonArray.length)
        console.log('[showTeamRankingsAdjustableDivisioning()] rowParentIdOfPreviousSeasonArray = ' + JSON.stringify(rowParentIdOfPreviousSeasonArray))

        // Build an array with tournament rows information and ordinals for division placement (top division has ordinal 0, the next division beneath has ordinal 1 and so on).
        for (const tournamentRowsItem of this.tempTournamentRows) {
          if (tournamentRowsItem.id !== null && Number(tournamentRowsItem.id) >= 1) {
            regionIdArr = []

            for (let indexRegion = 0; indexRegion < tournamentRowsItem.region_id.length; indexRegion++) {
              regionIdArr.push(Number(tournamentRowsItem.region_id[indexRegion].id))
            }

            // if ((Number(this.tournamentSeasonSeriesTextValue.value) === 1 && !tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior')) || (Number(this.tournamentSeasonSeriesTextValue.value) === 2 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('forår')) || (Number(this.tournamentSeasonSeriesTextValue.value) === 3 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('efterår'))) {
            if (((juniorCategoryFlag & 7) === 0 && !tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior')) || ((juniorCategoryFlag & 3) === 3 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('forår')) || ((juniorCategoryFlag & 5) === 5 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('efterår'))) {
              if (tournamentRowsItem.parent !== null) {
                rowParentIdOfNewSeasonArray.push({ id: Number(tournamentRowsItem.id), parentRowId: Number(tournamentRowsItem.parent.id), maxNumberOfTeams: Number(tournamentRowsItem.raekke_maxhold), numberOfUpMovements: Number(tournamentRowsItem.raekke_oprykning), assignedOrdinal: -1, assignedBranchSubOrdinal: (tournamentRowsItem.raekke_gren === undefined || tournamentRowsItem.raekke_gren === null ? 0 : Number(tournamentRowsItem.raekke_gren)), regionId: regionIdArr })
              } else {
                rowParentIdOfNewSeasonArray.push({ id: Number(tournamentRowsItem.id), parentRowId: 0, maxNumberOfTeams: Number(tournamentRowsItem.raekke_maxhold), numberOfUpMovements: Number(tournamentRowsItem.raekke_oprykning), assignedOrdinal: 0, assignedBranchSubOrdinal: 0, regionId: regionIdArr })
              }
            }
          }
        }

        loopFlag = false
        loopCnt = 0

        do {
          //
          for (const rowParentIdArrayItem of rowParentIdOfNewSeasonArray) {
            if (rowParentIdArrayItem.id >= 1) {
              if (Number(rowParentIdArrayItem.parentRowId) >= 1) {
                const indexOfRowParentIdArray = rowParentIdOfNewSeasonArray.findIndex(x => x.id === rowParentIdArrayItem.parentRowId)

                if (indexOfRowParentIdArray >= 0) {
                  if (rowParentIdOfNewSeasonArray[indexOfRowParentIdArray].assignedOrdinal >= 0) {
                    rowParentIdArrayItem.assignedOrdinal = rowParentIdOfNewSeasonArray[indexOfRowParentIdArray].assignedOrdinal + 1
                    if (rowParentIdArrayItem.assignedOrdinal > rowMaxOrdinal) {
                      rowMaxOrdinal = rowParentIdArrayItem.assignedOrdinal
                    }
                  } else {
                    loopFlag = true
                  }
                } else {
                  console.log('[showTeamRankingsAdjustableDivisioning()] Oops, parent Id ' + rowParentIdArrayItem.parentRowId + ' is not found the rowParentIdOfNewSeasonArray array.')
                }

                // Keep track of the maximum value of the branch sub ordinal of each ordinal.
                if (rowMaxBranchSubOrdinal[rowParentIdArrayItem.assignedOrdinal] === undefined) {
                  rowMaxBranchSubOrdinal[rowParentIdArrayItem.assignedOrdinal] = rowParentIdArrayItem.assignedBranchSubOrdinal
                } else {
                  if (rowMaxBranchSubOrdinal[rowParentIdArrayItem.assignedOrdinal] < rowParentIdArrayItem.assignedBranchSubOrdinal) {
                    rowMaxBranchSubOrdinal[rowParentIdArrayItem.assignedOrdinal] = rowParentIdArrayItem.assignedBranchSubOrdinal
                  }
                }
              }
            }
          }

          loopCnt++
        } while (loopFlag === true && loopCnt <= rowParentIdOfNewSeasonArray.length)
        console.log('[showTeamRankingsAdjustableDivisioning()] rowParentIdOfNewSeasonArray = ' + JSON.stringify(rowParentIdOfNewSeasonArray))
        console.log('[showTeamRankingsAdjustableDivisioning()] rowMaxOrdinal = ' + rowMaxOrdinal)
        console.log('[showTeamRankingsAdjustableDivisioning()] rowMaxBranchSubOrdinal[] = ' + rowMaxBranchSubOrdinal)

        // Get the indexes of the rowParentIdOfNewSeasonArrayItem where the ordinal assigned is equal to the maximum value.
        const indexOfRowParentIdOfNewSeasonArrayWithRowMaxOrdinalValues: number[] = []
        loopCnt = 0
        for (const rowParentIdOfNewSeasonArrayItem of rowParentIdOfNewSeasonArray) {
          if (rowParentIdOfNewSeasonArrayItem.assignedOrdinal === rowMaxOrdinal) {
            indexOfRowParentIdOfNewSeasonArrayWithRowMaxOrdinalValues.push(loopCnt)
          }

          loopCnt++
        }

        let extraFilterParamTeams = ''
        let extraFilterParamTeamRankings = ''
        this.teamsNewDivisionPlacements = []
        this.numberOfTeamsInPreviousSeason = 0
        this.rowMaxOrdinalValuesLoopIndex = 0 // This variable is being used for distributing new teams into the various rows with the same maximum value of the ordinal.

        // Generate extra filter parameter for the tournament row ids of the previous season.
        for (let arrindex1 = 0; arrindex1 < rowParentIdOfPreviousSeasonArray.length; arrindex1++) {
          extraFilterParamTeamRankings += '&hold_id.raekke_id_in=' + rowParentIdOfPreviousSeasonArray[arrindex1].id
        }

        console.log('[showTeamRankingsAdjustableDivisioning()] tempTournamentRows = ' + JSON.stringify(this.tempTournamentRows))

        // Loop through all rows of the new season and build the object array to be used for the team divisioning suggestion.
        for (const tournamentRowsItem of this.tempTournamentRows) {
          if (Number(tournamentRowsItem.id) >= 1) {
            if (((juniorCategoryFlag & 7) === 0 && !tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior')) || ((juniorCategoryFlag & 3) === 3 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('forår')) || ((juniorCategoryFlag & 5) === 5 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('efterår'))) {
              seriesId = Number(tournamentRowsItem.id)
              this.newTournamentRowTextOptions.push({ text: tournamentRowsItem.raekke_navn, value: Number(tournamentRowsItem.id).toString() }) // FIXME: This should be the rows of the new season instead of the rows of the previous season. DONE

              // The tournament category of the rows for Junior does alternate between 'spring' category and 'fall' category depending on which part of the half-year season, that is the new one.
              if ((juniorCategoryFlag & 3) === 3 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('forår')) {
                // extraFilterParamTeams = `&raekke_id.turneringskategori_id=${tournamentRowsItem.turneringskategori_id.id}`
                extraFilterParamTeams = `&raekke_id.turneringskategori_id=${tempTournamentCategories[indexCategoryForJuniorFallInPreviousSeason].id}`
                // Must be the previous (halfyear) season, 'efterår'
                // extraFilterParamTeamRankings = `&hold_id.raekke_id.turneringskategori_id=${tempTournamentCategories[indexCategoryForJuniorFallInPreviousSeason].id}`
              } else if ((juniorCategoryFlag & 5) === 5 && tournamentRowsItem.raekke_navn.toLocaleLowerCase().includes('junior') && tournamentRowsItem.turneringskategori_id.turneringskategori_navn.toLocaleLowerCase().includes('efterår')) {
                extraFilterParamTeams = `&raekke_id.turneringskategori_id=${tournamentRowsItem.turneringskategori_id.id}`
                // Must be the previous (halfyear) season, 'forår'
                // extraFilterParamTeamRankings = ''
                // extraFilterParamTeamRankings = `&hold_id.raekke_id.turneringskategori_id=${tempTournamentCategories[indexCategoryForJuniorSpringInPreviousSeason].id}`
              } else {
                // Assume that the category of the tournament rows are unchanged in the new season from that of the previous season.
                extraFilterParamTeams = `&raekke_id.turneringskategori_id=${tournamentRowsItem.turneringskategori_id.id}`
              }

              // const retrieveRulesPromise = Tournaments.TournamentRulesDataService.getAll()
              // const retrieveTeamsPromise = TeamsDataService.getAll('', null, `saeson_id=${retriveSeasonId.toString()}&raekke_id=${seriesId}` + extraFilterParamTeams)
              // const retrieveTeamsPromise = TeamsDataService.getAll('', null, `saeson_id=${retriveSeasonId.toString()}&raekke_id=${seriesId}`)
              // const retrieveTeamRankingsPromise = Tournaments.TournamentMatchesTeamRankingsDataService.getAll('', null, `hold_id.saeson_id=${seasonId.toString()}&hold_id.raekke_id=${seriesId}` + extraFilterParamTeamRankings)
              // const retrieveTeamRankingsPromise = Tournaments.TournamentMatchesTeamRankingsDataService.getAll('', null, `hold_id.saeson_id=${seasonId.toString()}` + extraFilterParamTeamRankings)

              const tempTeamsInRow = (await TeamsDataService.asyncGetAll('', null, `saeson_id=${retriveSeasonId.toString()}&raekke_id=${seriesId}` + extraFilterParamTeams)).data as SysTeam[]
              const rankings = (await Tournaments.TournamentMatchesTeamRankingsDataService.asyncGetAll('', null, `hold_id.saeson_id=${seasonId.toString()}` + extraFilterParamTeamRankings)).data as SysTournamentMatchesTeamRankings[]

              console.log('[showTeamRankingsAdjustableDivisioning()] rankings = ' + JSON.stringify(rankings))
              this.tempHolds = [...this.tempHolds, ...tempTeamsInRow] // Append the teams found for this tournament row to the total teams array, that will be used later in the getNewTournamentSeasonTeamsRowsTextValues() method.
              this.numberOfTeamsInPreviousSeason = this.numberOfTeamsInPreviousSeason + rankings.length

              // if ((juniorCategoryFlag & 1) === 1 && (juniorCategoryFlag & 254) >= 2) {
              for (const rankingItem of rankings) {
                if (rankingItem.hold_id.hold_holdnavn !== undefined) {
                  const indexOfTeamInNewSeason = tempTeamsInRow.findIndex(x => x.hold_holdnavn.trim().replace(/\s+/g, '').replace(/[.,\s]/g, '').toLocaleLowerCase() === rankingItem.hold_id.hold_holdnavn.trim().replace(/\s+/g, '').replace(/[.,\s]/g, '').toLocaleLowerCase())

                  if (indexOfTeamInNewSeason >= 0) {
                    // WIP
                    // const indexOfRowParentIdOfPreviousSeasonArray = rowParentIdOfPreviousSeasonArray.findIndex(x => x.id === Number(tempTeamsInRow[indexOfTeamInNewSeason].raekke_id.id))
                    const indexOfRowParentIdOfPreviousSeasonArray = rowParentIdOfPreviousSeasonArray.findIndex(x => x.id === Number(rankingItem.hold_id.raekke_id))
                    const indexOfRowParentIdOfNewSeasonArray = rowParentIdOfNewSeasonArray.findIndex(x => x.assignedOrdinal === (indexOfRowParentIdOfPreviousSeasonArray >= 0 ? rowParentIdOfPreviousSeasonArray[indexOfRowParentIdOfPreviousSeasonArray].assignedOrdinal : 0) && x.assignedBranchSubOrdinal === (indexOfRowParentIdOfPreviousSeasonArray >= 0 ? rowParentIdOfPreviousSeasonArray[indexOfRowParentIdOfPreviousSeasonArray].assignedBranchSubOrdinal : 0))
                    console.log('[showTeamRankingsAdjustableDivisioning()] Original team placement = ' + rankingItem.stillinger_placering)
                    console.log('[showTeamRankingsAdjustableDivisioning()] tempTeamsInRow[indexOfTeamInNewSeason] = ' + JSON.stringify(tempTeamsInRow[indexOfTeamInNewSeason]))
                    // this.teamsNewDivisionPlacements.push({ id: Number(rankingItem.hold_id.id), origPlacement: tempTeamsInRow[indexOfTeamInNewSeason].stillinger_id.stillinger_placering, rowIdOfOrigPlacement: Number(tempTeamsInRow[indexOfTeamInNewSeason].raekke_id.id), newPlacement: tempTeamsInRow[indexOfTeamInNewSeason].stillinger_id.stillinger_placering, rowIdOfNewPlacement: Number(tempTeamsInRow[indexOfTeamInNewSeason].raekke_id.id), origRowOrdinal: (indexOfRowParentIdOfNewSeasonArray >= 0 ? rowParentIdOfNewSeasonArray[indexOfRowParentIdOfNewSeasonArray].assignedOrdinal : -1) })
                    this.teamsNewDivisionPlacements.push({ id: Number(tempTeamsInRow[indexOfTeamInNewSeason].id), origId: Number(rankingItem.hold_id.id), origPlacement: rankingItem.stillinger_placering, rowIdOfOrigPlacement: Number(rankingItem.hold_id.raekke_id), newPlacement: rankingItem.stillinger_placering, rowIdOfNewPlacement: rowParentIdOfNewSeasonArray[indexOfRowParentIdOfNewSeasonArray].id, origRowOrdinal: (indexOfRowParentIdOfPreviousSeasonArray >= 0 ? rowParentIdOfPreviousSeasonArray[indexOfRowParentIdOfPreviousSeasonArray].assignedOrdinal : -1), newRowOrdinal: (indexOfRowParentIdOfPreviousSeasonArray >= 0 ? rowParentIdOfPreviousSeasonArray[indexOfRowParentIdOfPreviousSeasonArray].assignedOrdinal : -1), origRowSubOrdinal: (indexOfRowParentIdOfPreviousSeasonArray >= 0 ? rowParentIdOfPreviousSeasonArray[indexOfRowParentIdOfPreviousSeasonArray].assignedBranchSubOrdinal : -1), newRowSubOrdinal: (indexOfRowParentIdOfPreviousSeasonArray >= 0 ? rowParentIdOfPreviousSeasonArray[indexOfRowParentIdOfPreviousSeasonArray].assignedBranchSubOrdinal : -1) })
                    console.log('SeriesId = ' + seriesId + ' / rowIdOfNewPlacement = ' + rowParentIdOfNewSeasonArray[indexOfRowParentIdOfNewSeasonArray].id)
                  }
                }
              }

              console.log('[showTeamRankingsAdjustableDivisioning()] teamsNewDivisionPlacements (initial) = ' + JSON.stringify(this.teamsNewDivisionPlacements))
              // const nextRowSubOrdinal = 0 // Value for next branch sub ordinal of the tournament row ordinal, that will be used to assign to a new team (that has not been playing in the previous season).

              // FIXME: Add also information of new teams, that have not been playing in previous season to the teamsNewDivisionPlacements object array. They should be added to the lowest division (highest ordinal tournament rows in eaqual measure). DONE
              if (indexOfRowParentIdOfNewSeasonArrayWithRowMaxOrdinalValues.length >= 1) {
                for (const tempTeamsInRowItem of tempTeamsInRow) {
                  if (this.teamsNewDivisionPlacements.findIndex(x => x.id === Number(tempTeamsInRowItem.id)) < 0) {
                    tempTeamsNotFoundInPreviousSeason.push({ id: Number(tempTeamsInRowItem.id), origId: 0, origPlacement: 0, rowIdOfOrigPlacement: 0, newPlacement: 0, rowIdOfNewPlacement: rowParentIdOfNewSeasonArray[indexOfRowParentIdOfNewSeasonArrayWithRowMaxOrdinalValues[this.rowMaxOrdinalValuesLoopIndex]].id, origRowOrdinal: rowMaxOrdinal, newRowOrdinal: rowMaxOrdinal, origRowSubOrdinal: rowParentIdOfNewSeasonArray[indexOfRowParentIdOfNewSeasonArrayWithRowMaxOrdinalValues[this.rowMaxOrdinalValuesLoopIndex]].assignedBranchSubOrdinal, newRowSubOrdinal: rowParentIdOfNewSeasonArray[indexOfRowParentIdOfNewSeasonArrayWithRowMaxOrdinalValues[this.rowMaxOrdinalValuesLoopIndex]].assignedBranchSubOrdinal })

                    if (this.rowMaxOrdinalValuesLoopIndex < indexOfRowParentIdOfNewSeasonArrayWithRowMaxOrdinalValues.length - 1) {
                      this.rowMaxOrdinalValuesLoopIndex++
                    } else {
                      this.rowMaxOrdinalValuesLoopIndex = 0
                    }
                  }
                }
              }

              console.log('[showTeamRankingsAdjustableDivisioning()] tempTeamsNotFoundInPreviousSeason = ' + JSON.stringify(tempTeamsNotFoundInPreviousSeason))
              // }
            }
          }
        }

        let maxPlacementInRow = 10

        // Adjust for each division row the placement upwards to leave no gap in placement sequence (in case one team or more are not playing in the new season compared to the previous one).
        for (const rowParentIdOfNewSeasonItem of rowParentIdOfNewSeasonArray) {
          let loopNewPlacement = 1
          let loopCurrentPlacement = 1
          maxPlacementInRow = rowParentIdOfNewSeasonItem.maxNumberOfTeams

          do {
            for (const objItem of this.teamsNewDivisionPlacements) {
              if (objItem.rowIdOfNewPlacement === rowParentIdOfNewSeasonItem.id) {
                if (objItem.newPlacement === loopCurrentPlacement) {
                  objItem.newPlacement = loopNewPlacement
                  loopNewPlacement++
                }
              }
            }

            loopCurrentPlacement++
          } while (loopCurrentPlacement <= maxPlacementInRow)
        }

        // Find the maximum placement value used so far in the teamsNewDivisionPlacements object array of each tournament row, that has the maximum ordinal value.
        const maxPlacementInRowObj: { rowId: number, maxPlacement: number }[] = []

        // Initialize the array first for each relevant rows (so we do not get undefined error later).
        for (const objItem of rowParentIdOfNewSeasonArray) {
          if (objItem.assignedOrdinal === rowMaxOrdinal) {
            maxPlacementInRowObj.push({ rowId: objItem.id, maxPlacement: 0 })
          }
        }

        for (const objItem of this.teamsNewDivisionPlacements) {
          if (objItem.origRowOrdinal === rowMaxOrdinal) {
            const indexOfMaxPlacementInRowObj = maxPlacementInRowObj.findIndex(x => x.rowId === objItem.rowIdOfNewPlacement)

            if (indexOfMaxPlacementInRowObj >= 0) {
              if (maxPlacementInRowObj[indexOfMaxPlacementInRowObj].maxPlacement < objItem.newPlacement) {
                maxPlacementInRowObj[indexOfMaxPlacementInRowObj].maxPlacement = objItem.newPlacement
              }
            } else {
              maxPlacementInRowObj.push({ rowId: objItem.rowIdOfNewPlacement, maxPlacement: objItem.newPlacement })
            }
          }
        }
        console.log('[showTeamRankingsAdjustableDivisioning()] maxPlacementInRowObj = ' + JSON.stringify(maxPlacementInRowObj))

        // Fixup the placement of the new teams, that did not exist in the previous season.
        for (const objItem of tempTeamsNotFoundInPreviousSeason) {
          const indexOfMaxPlacementInRowObj = maxPlacementInRowObj.findIndex(x => x.rowId === objItem.rowIdOfNewPlacement)

          if (indexOfMaxPlacementInRowObj >= 0) {
            maxPlacementInRowObj[indexOfMaxPlacementInRowObj].maxPlacement++
            objItem.origPlacement = maxPlacementInRowObj[indexOfMaxPlacementInRowObj].maxPlacement
            objItem.newPlacement = maxPlacementInRowObj[indexOfMaxPlacementInRowObj].maxPlacement
          } else {
            console.log('[showTeamRankingsAdjustableDivisioning()] Oops, row Id (rowId) ' + objItem.rowIdOfNewPlacement + ' of the team was not found in maxPlacementInRowObj !')
          }
        }

        this.teamsNewDivisionPlacements = [...this.teamsNewDivisionPlacements, ...tempTeamsNotFoundInPreviousSeason]

        if (this.advancedTournamentTeamsNewSeasonDivisionPlacementsModeFlag) {
          // WIP: Perform adjustments to the placements and divisions (rows) of the teams.
          let numbOfTeamsUpMovements = 2
          let numbOfTeamsDownMovements = numbOfTeamsUpMovements // The value of both up and down movements should always be the same.
          let currentOrdinalToBeMovedUpTo = -1
          let currentOrdinalToBeMovedFrom = 0
          let currentOrdinalToBeMovedDownTo = 1
          // let currentSubOrdinalToBeMovedUpTo = 0
          // let currentSubOrdinalToBeMovedFrom = 0
          // let currentSubOrdinalToBeMovedDownTo = 0
          let indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo: number[] = []
          let indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom: number[] = []
          let indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo: number[] = []

          // For each row ordinal find index for all subordinals.
          const indexesOfRowParentIdOfNewSeasonArrayByOrdinals: number[][] = []
          let loopCurrentIndex = 0
          let offsetInArrayToBeMovedUpTo = 0
          let offsetInArrayToBeMovedFrom = 0
          let offsetInArrayToBeMovedDownTo = 0
          let lowestPlacementWithinTheOrdinal = 10
          let lowestPlacementWithinTheFromOrdinal = 10
          let filteredTeamsNewDivisionPlacements: teamsNewDivisionPlacementsDataType[] = []

          for (let ordinalValue = 0; ordinalValue <= rowMaxOrdinal; ordinalValue++) {
            indexesOfRowParentIdOfNewSeasonArrayByOrdinals[ordinalValue] = []
            loopCurrentIndex = 0

            for (const rowParentIdOfNewSeasonItem of rowParentIdOfNewSeasonArray) {
              if (rowParentIdOfNewSeasonItem.assignedOrdinal === ordinalValue) {
                indexesOfRowParentIdOfNewSeasonArrayByOrdinals[ordinalValue].push(loopCurrentIndex)
              }

              loopCurrentIndex++
            }
          }

          console.log('[showTeamRankingsAdjustableDivisioning()] indexesOfRowParentIdOfNewSeasonArrayByOrdinals = ' + JSON.stringify(indexesOfRowParentIdOfNewSeasonArrayByOrdinals))

          // Move one team up or down at a time, starting from ordinal 0. WIP
          do {
            console.log('[showTeamRankingsAdjustableDivisioning()] Begin with currentOrdinalToBeMovedFrom = ' + currentOrdinalToBeMovedFrom)
            indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[currentOrdinalToBeMovedFrom]
            numbOfTeamsUpMovements = rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].numberOfUpMovements
            numbOfTeamsDownMovements = numbOfTeamsUpMovements
            console.log('[showTeamRankingsAdjustableDivisioning()] Number of teams placement up / down movements in current division (id: ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].id + '): ' + numbOfTeamsUpMovements)

            for (let movementCnt = 1; movementCnt <= numbOfTeamsUpMovements; movementCnt++) {
              console.log('[showTeamRankingsAdjustableDivisioning()] Starting team movement ' + movementCnt)

              // Move teams up.
              if (currentOrdinalToBeMovedUpTo >= 0) {
                indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[currentOrdinalToBeMovedUpTo]
                // indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[currentOrdinalToBeMovedDownTo]
                numbOfTeamsUpMovements = (numbOfTeamsUpMovements <= (indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length / indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo.length) ? 1 : numbOfTeamsUpMovements)

                loopCnt = 0
                offsetInArrayToBeMovedUpTo = 0
                offsetInArrayToBeMovedFrom = 0
                // lowestPlacementWithinTheOrdinal = 10

                do {
                  // Find the current maximum value of the placement of a team in the row, where the team is to be moved to.
                  // const maxPlacement = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement = this.teamsNewDivisionPlacements[indexOfTeamObjItem].rowIdOfNewPlacement).reduce((a,b) =>a.newPlacement > b.newPlacement ? a : b).newPlacement
                  console.log('[showTeamRankingsAdjustableDivisioning()] lowestPlacementWithinTheOrdinal: Row Id = ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id)
                  console.log('[showTeamRankingsAdjustableDivisioning()] lowestPlacementWithinTheOrdinal: teamsNewDivisionPlacements = ' + JSON.stringify(this.teamsNewDivisionPlacements))
                  // lowestPlacementWithinTheOrdinal = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id).reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement
                  filteredTeamsNewDivisionPlacements = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id)
                  lowestPlacementWithinTheOrdinal = (filteredTeamsNewDivisionPlacements.length >= 1 ? filteredTeamsNewDivisionPlacements.reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement : 1)
                  filteredTeamsNewDivisionPlacements = []
                  // Adjust the value according to the number of movements. (For example with two number of movements the first movement should have the destination placement to be one above the lowest placement in the tournament row. With the last movement the adjustment of the value should always be equal to zero. WRONG!)
                  // lowestPlacementWithinTheOrdinal = lowestPlacementWithinTheOrdinal - (numbOfTeamsUpMovements - movementCnt) - (indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo.length - (offsetInArrayToBeMovedUpTo + 1))
                  // lowestPlacementWithinTheOrdinal = (indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length >= 2 ? lowestPlacementWithinTheOrdinal - 3 : lowestPlacementWithinTheOrdinal - (numbOfTeamsUpMovements - 1))
                  lowestPlacementWithinTheOrdinal = lowestPlacementWithinTheOrdinal - 1
                  // Clamp the value to highest possible placement within at tournament row.
                  if (lowestPlacementWithinTheOrdinal < 1) {
                    lowestPlacementWithinTheOrdinal = 1
                  }
                  console.log('[showTeamRankingsAdjustableDivisioning()] lowestPlacementWithinTheOrdinal = ' + lowestPlacementWithinTheOrdinal + ' in row id = ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id)

                  const indexOfTeamObjItem = this.teamsNewDivisionPlacements.findIndex(x => x.newRowOrdinal === currentOrdinalToBeMovedFrom && x.newRowSubOrdinal === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].assignedBranchSubOrdinal && x.newPlacement === 1)
                  console.log('[showTeamRankingsAdjustableDivisioning()] Processing for currentOrdinalToBeMovedUpTo = ' + currentOrdinalToBeMovedUpTo + ' with offsetInArrayToBeMovedUpTo = ' + offsetInArrayToBeMovedUpTo)
                  console.log('[showTeamRankingsAdjustableDivisioning()] Processing for currentOrdinalToBeMovedUpTo = ' + currentOrdinalToBeMovedUpTo + ' with indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo] = ' + JSON.stringify(indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]))

                  if (indexOfTeamObjItem >= 0 && currentOrdinalToBeMovedUpTo >= 0) {
                    console.log('[showTeamRankingsAdjustableDivisioning()] Moving team up: ' + JSON.stringify(this.teamsNewDivisionPlacements[indexOfTeamObjItem]))
                    console.log('[showTeamRankingsAdjustableDivisioning()] New placement in row id: ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id)
                    this.teamsNewDivisionPlacements[indexOfTeamObjItem].newRowOrdinal = currentOrdinalToBeMovedUpTo
                    this.teamsNewDivisionPlacements[indexOfTeamObjItem].newRowSubOrdinal = rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].assignedBranchSubOrdinal
                    this.moveNewTournamentSeasonTeamInDivisionPlacementsObjectArr({ id: this.teamsNewDivisionPlacements[indexOfTeamObjItem].id, newPlacement: lowestPlacementWithinTheOrdinal, newRowId: rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id })

                    offsetInArrayToBeMovedUpTo++

                    if (offsetInArrayToBeMovedUpTo >= indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo.length) {
                      offsetInArrayToBeMovedUpTo = 0
                    }
                  }

                  offsetInArrayToBeMovedFrom++
                  if (offsetInArrayToBeMovedFrom >= indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length) {
                    offsetInArrayToBeMovedFrom = 0
                  }

                  loopCnt++
                } while (loopCnt < Math.max(indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo.length, indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length))
              }
            }

            for (let movementCnt = 1; movementCnt <= numbOfTeamsDownMovements; movementCnt++) {
              // Move teams down.
              if (currentOrdinalToBeMovedDownTo <= rowMaxOrdinal) {
                // indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[currentOrdinalToBeMovedUpTo]
                indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[currentOrdinalToBeMovedFrom]
                indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[currentOrdinalToBeMovedDownTo]
                numbOfTeamsDownMovements = (numbOfTeamsDownMovements <= (indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo.length / indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length) ? 1 : numbOfTeamsDownMovements)

                loopCnt = 0
                offsetInArrayToBeMovedDownTo = 0
                offsetInArrayToBeMovedFrom = 0
                // lowestPlacementWithinTheOrdinal = 10

                do {
                  // Find the current maximum value of the placement of a team in the row, where the team is to be moved to.
                  // const maxPlacement = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement = this.teamsNewDivisionPlacements[indexOfTeamObjItem].rowIdOfNewPlacement).reduce((a,b) =>a.newPlacement > b.newPlacement ? a : b).newPlacement
                  // lowestPlacementWithinTheOrdinal = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo[offsetInArrayToBeMovedDownTo]].id).reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement
                  filteredTeamsNewDivisionPlacements = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].id)
                  // console.log('[showTeamRankingsAdjustableDivisioning()] teamsNewDivisionPlacements = ' + JSON.stringify(this.teamsNewDivisionPlacements))
                  // console.log('[showTeamRankingsAdjustableDivisioning()] filteredTeamsNewDivisionPlacements = ' + JSON.stringify(filteredTeamsNewDivisionPlacements))
                  lowestPlacementWithinTheOrdinal = (filteredTeamsNewDivisionPlacements.length >= 1 ? filteredTeamsNewDivisionPlacements.reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement : 1)
                  filteredTeamsNewDivisionPlacements = []

                  // Clamp the value to highest possible placement within at tournament row.
                  if (lowestPlacementWithinTheOrdinal < 1) {
                    lowestPlacementWithinTheOrdinal = 1
                  }
                  console.log('[showTeamRankingsAdjustableDivisioning()] lowestPlacementWithinTheOrdinal = ' + lowestPlacementWithinTheOrdinal + ' in row id = ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].id)

                  const indexOfTeamObjItem = this.teamsNewDivisionPlacements.findIndex(x => x.newRowOrdinal === currentOrdinalToBeMovedFrom && x.newRowSubOrdinal === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].assignedBranchSubOrdinal && x.newPlacement === lowestPlacementWithinTheOrdinal)
                  console.log('[showTeamRankingsAdjustableDivisioning()] currentOrdinalToBeMovedFrom = ' + currentOrdinalToBeMovedFrom)
                  // console.log('[showTeamRankingsAdjustableDivisioning()] indexOfTeamObjItem = ' + indexOfTeamObjItem.toString())
                  console.log('[showTeamRankingsAdjustableDivisioning()] Processing for currentOrdinalToBeMovedDownTo = ' + currentOrdinalToBeMovedDownTo + ' with offsetInArrayToBeMovedDownTo = ' + offsetInArrayToBeMovedDownTo)
                  console.log('[showTeamRankingsAdjustableDivisioning()] Processing for currentOrdinalToBeMovedDownTo = ' + currentOrdinalToBeMovedDownTo + ' with indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo[offsetInArrayToBeMovedDownTo] = ' + JSON.stringify(indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo[offsetInArrayToBeMovedDownTo]))

                  if (indexOfTeamObjItem >= 0 && currentOrdinalToBeMovedDownTo >= 0 && currentOrdinalToBeMovedDownTo <= rowMaxOrdinal) {
                    console.log('[showTeamRankingsAdjustableDivisioning()] Moving team down: ' + JSON.stringify(this.teamsNewDivisionPlacements[indexOfTeamObjItem]))
                    console.log('[showTeamRankingsAdjustableDivisioning()] New placement in row id: ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo[offsetInArrayToBeMovedDownTo]].id)
                    this.teamsNewDivisionPlacements[indexOfTeamObjItem].newRowOrdinal = currentOrdinalToBeMovedDownTo
                    this.teamsNewDivisionPlacements[indexOfTeamObjItem].newRowSubOrdinal = rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo[offsetInArrayToBeMovedDownTo]].assignedBranchSubOrdinal
                    this.moveNewTournamentSeasonTeamInDivisionPlacementsObjectArr({ id: this.teamsNewDivisionPlacements[indexOfTeamObjItem].id, newPlacement: (1 + numbOfTeamsDownMovements), newRowId: rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo[offsetInArrayToBeMovedDownTo]].id })

                    offsetInArrayToBeMovedDownTo++

                    if (offsetInArrayToBeMovedDownTo >= indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo.length) {
                      offsetInArrayToBeMovedDownTo = 0
                    }
                  }

                  offsetInArrayToBeMovedFrom++
                  if (offsetInArrayToBeMovedFrom >= indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length) {
                    offsetInArrayToBeMovedFrom = 0
                  }

                  loopCnt++
                } while (loopCnt < Math.max(indexesOfRowParentIdOfNewSeasonArrayToBeMovedDownTo.length, indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length))
              }
            }

            currentOrdinalToBeMovedUpTo++
            currentOrdinalToBeMovedFrom++
            currentOrdinalToBeMovedDownTo++
          } while (currentOrdinalToBeMovedFrom <= rowMaxOrdinal)

          console.log('[showTeamRankingsAdjustableDivisioning()] teamsNewDivisionPlacements (after regular up & down movements) = ' + JSON.stringify(this.teamsNewDivisionPlacements))

          // Adjust all teams placements up to fill out maximum number teams in each row ordinal.
          const rowMaxNumbOfTeamsInOrdinal = [10, 10, 15]
          let loopBreakFlag = false

          // if (rowMaxOrdinal >= 1) {
          for (let ordinalValue = 0; ordinalValue < rowMaxOrdinal; ordinalValue++) {
            let currentOrdinalToBeMovedFromOffset = 1
            indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[ordinalValue]
            indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom = indexesOfRowParentIdOfNewSeasonArrayByOrdinals[ordinalValue + currentOrdinalToBeMovedFromOffset]
            loopCurrentIndex = 0

            do {
              loopCnt = 0
              offsetInArrayToBeMovedUpTo = loopCurrentIndex
              offsetInArrayToBeMovedFrom = 0

              do {
                // lowestPlacementWithinTheOrdinal = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id).reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement
                filteredTeamsNewDivisionPlacements = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id)
                lowestPlacementWithinTheOrdinal = (filteredTeamsNewDivisionPlacements.length >= 1 ? filteredTeamsNewDivisionPlacements.reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement : 1)
                console.log('[showTeamRankingsAdjustableDivisioning()] ordinalValue + currentOrdinalToBeMovedFromOffset = ' + (ordinalValue + currentOrdinalToBeMovedFromOffset).toString())
                console.log('[showTeamRankingsAdjustableDivisioning()] indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom = ' + JSON.stringify(indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom))
                console.log('[showTeamRankingsAdjustableDivisioning()] offsetInArrayToBeMovedFrom = ' + offsetInArrayToBeMovedFrom)
                // lowestPlacementWithinTheFromOrdinal = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].id).reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement
                filteredTeamsNewDivisionPlacements = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].id)
                lowestPlacementWithinTheFromOrdinal = (filteredTeamsNewDivisionPlacements.length >= 1 ? filteredTeamsNewDivisionPlacements.reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement : 1)
                filteredTeamsNewDivisionPlacements = []
                console.log('[showTeamRankingsAdjustableDivisioning()] lowestPlacementWithinTheFromOrdinal = ' + lowestPlacementWithinTheFromOrdinal)

                if (lowestPlacementWithinTheOrdinal < rowMaxNumbOfTeamsInOrdinal[ordinalValue] && lowestPlacementWithinTheFromOrdinal >= 1) {
                  const indexOfTeamObjItem = this.teamsNewDivisionPlacements.findIndex(x => x.newRowOrdinal === (ordinalValue + currentOrdinalToBeMovedFromOffset) && x.newRowSubOrdinal === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].assignedBranchSubOrdinal && x.newPlacement === 1)
                  console.log('[showTeamRankingsAdjustableDivisioning()] indexOfTeamObjItem = ' + indexOfTeamObjItem + ' for ordinal / subordinal = ' + (ordinalValue + currentOrdinalToBeMovedFromOffset) + ' / ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom[offsetInArrayToBeMovedFrom]].assignedBranchSubOrdinal)

                  if (indexOfTeamObjItem >= 0) {
                    console.log('[showTeamRankingsAdjustableDivisioning()] Moving team up: ' + JSON.stringify(this.teamsNewDivisionPlacements[indexOfTeamObjItem]))
                    console.log('[showTeamRankingsAdjustableDivisioning()] New placement in row id: ' + rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id)
                    this.teamsNewDivisionPlacements[indexOfTeamObjItem].newRowOrdinal = ordinalValue
                    this.teamsNewDivisionPlacements[indexOfTeamObjItem].newRowSubOrdinal = rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].assignedBranchSubOrdinal
                    this.moveNewTournamentSeasonTeamInDivisionPlacementsObjectArr({ id: this.teamsNewDivisionPlacements[indexOfTeamObjItem].id, newPlacement: (lowestPlacementWithinTheOrdinal + 1), newRowId: rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[offsetInArrayToBeMovedUpTo]].id })

                    offsetInArrayToBeMovedUpTo++

                    if (offsetInArrayToBeMovedUpTo >= indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo.length) {
                      offsetInArrayToBeMovedUpTo = 0
                    }
                  }
                }

                offsetInArrayToBeMovedFrom++
                if (offsetInArrayToBeMovedFrom >= indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length) {
                  offsetInArrayToBeMovedFrom = 0
                }

                loopCnt++
              } while (loopCnt < Math.max(indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo.length, indexesOfRowParentIdOfNewSeasonArrayToBeMovedFrom.length))

              loopCurrentIndex = 0
              if (lowestPlacementWithinTheOrdinal >= rowMaxNumbOfTeamsInOrdinal[ordinalValue]) {
                // If maximum placement is reached in the row ordinal, that teams are being moved up to, then jump out of this loop.
                loopBreakFlag = true
                for (; loopCurrentIndex < indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo.length; loopCurrentIndex++) {
                  filteredTeamsNewDivisionPlacements = this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[loopCurrentIndex]].id)

                  // if (this.teamsNewDivisionPlacements.filter(el => el.rowIdOfNewPlacement === rowParentIdOfNewSeasonArray[indexesOfRowParentIdOfNewSeasonArrayToBeMovedUpTo[loopCurrentIndex]].id).reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement < rowMaxNumbOfTeamsInOrdinal[ordinalValue]) {
                  if (filteredTeamsNewDivisionPlacements.length === 0 || filteredTeamsNewDivisionPlacements.reduce((a, b) => a.newPlacement > b.newPlacement ? a : b).newPlacement < rowMaxNumbOfTeamsInOrdinal[ordinalValue]) {
                    loopBreakFlag = false
                  }
                }

                filteredTeamsNewDivisionPlacements = []

                if (loopBreakFlag) {
                  break
                }
              }

              currentOrdinalToBeMovedFromOffset++
            } while ((ordinalValue + currentOrdinalToBeMovedFromOffset) < rowMaxOrdinal)
          }
          // }
        }

        this.sortTeamsNewDivisionPlacementsArray()

        console.log('[showTeamRankingsAdjustableDivisioning()] teamsNewDivisionPlacements (final) = ' + JSON.stringify(this.teamsNewDivisionPlacements))
        this.editSuggestedTournamentSeasonTeamPlacementsModal = true
      } catch (err) {
        console.log(err)
      }
    }
  }

  // Update the the tournamnet row relation of each team for the proper start of a new season.
  public acceptTournamentSeasonTeamPlacements () : void {
    for (const teamsNewDivisionPlacement of this.teamsNewDivisionPlacements) {
      const updateTeam = {
        raekke_id: teamsNewDivisionPlacement.rowIdOfNewPlacement
      }

      TeamsDataService.update(Number(teamsNewDivisionPlacement.id).toString(), updateTeam)
        .then((response) => {
          console.log(response.data)
        })
        .catch((err) => {
          // this.error = err
          console.log(err)

          this.$Message.success({ text: 'Der opstod en fejl ved forsøget at gemme ændringerne' })
        })
    }

    this.editSuggestedTournamentSeasonTeamPlacementsModal = false

    this.$Message.success({ text: 'Ændringerne af holdenes række oplysninger blev forsøgt gemt' })
  }

  public cancelSuggestedTournamentSeasonTeamPlacementsEdit () : void {
    this.editSuggestedTournamentSeasonTeamPlacementsModal = false
  }

  public editOneTournamentSeasonTeamPlacement (newTournamentSeasonTeamsRowsTextValue: { id: number, placement: number, teamname: string, text: string, value: string }) : void {
    this.teamToBeChangedTournamentSeasonTeamPlacement = { text: newTournamentSeasonTeamsRowsTextValue.teamname, value: newTournamentSeasonTeamsRowsTextValue.id }
    this.newTournamentRowTextValue = { text: newTournamentSeasonTeamsRowsTextValue.text, value: newTournamentSeasonTeamsRowsTextValue.value }
    this.newPlacementTextOptions = []
    this.origRowIdOfTeamPlacement = Number(newTournamentSeasonTeamsRowsTextValue.value)

    for (const teamsNewDivisionPlacementItem of this.teamsNewDivisionPlacements) {
      if (teamsNewDivisionPlacementItem.rowIdOfNewPlacement === Number(newTournamentSeasonTeamsRowsTextValue.value)) {
        this.newPlacementTextOptions.push({ text: teamsNewDivisionPlacementItem.newPlacement.toString(), value: teamsNewDivisionPlacementItem.newPlacement.toString() })
      }
    }

    this.lastInitialNewPlacementValue = newTournamentSeasonTeamsRowsTextValue.placement
    this.newPlacementTextValue = { text: newTournamentSeasonTeamsRowsTextValue.placement.toString(), value: newTournamentSeasonTeamsRowsTextValue.placement.toString() }
    this.lastEditedTeamInTournamentSeasonTeamPlacement = newTournamentSeasonTeamsRowsTextValue.id
    this.editOneTournamentSeasonTeamPlacementModal = true
  }

  public changeOneTournamentSeasonTeamPlacement () : void {
    console.log('[changeOneTournamentSeasonTeamPlacement()] Changing the placement and division of the team')

    this.moveNewTournamentSeasonTeamInDivisionPlacementsObjectArr({ id: this.lastEditedTeamInTournamentSeasonTeamPlacement, newPlacement: Number(this.newPlacementTextValue.value), newRowId: Number(this.newTournamentRowTextValue.value) })
    this.sortTeamsNewDivisionPlacementsArray()

    this.editOneTournamentSeasonTeamPlacementModal = false
  }

  public cancelOneTournamentSeasonTeamPlacementEdit () : void {
    this.editOneTournamentSeasonTeamPlacementModal = false
  }

  public getNumberOfTeamsInTeamPlacementTournamentRow (rowId: number) : number {
    const retVal = this.teamsNewDivisionPlacements.reduce((a, c) => c.rowIdOfNewPlacement === rowId ? ++a : a, 0)

    return retVal
  }

  public getNewTournamentSeasonTeamsRowIdToRowName (tournamentRowId = 0) : string {
    let retVal = '???'
    const indexOfRow = this.tempTournamentRows.findIndex(x => x.id === tournamentRowId)

    if (indexOfRow >= 0) {
      retVal = this.tempTournamentRows[indexOfRow].raekke_navn
    }

    return retVal
  }

  public getNewTournamentSeasonTeamsRowIdsValues () : number[] {
    let indexRowIdAreadyPresent = -1
    const retVal: number[] = []

    for (const teamsNewDivisionPlacementItem of this.teamsNewDivisionPlacements) {
      indexRowIdAreadyPresent = retVal.findIndex(x => x === teamsNewDivisionPlacementItem.rowIdOfNewPlacement)

      if (indexRowIdAreadyPresent < 0) {
        retVal.push(teamsNewDivisionPlacementItem.rowIdOfNewPlacement)
      }
    }

    return retVal
  }

  public getNewTournamentSeasonTeamsRowsTextValues (tournamentRowId = 0) : any[] {
    const retVal: { id: number, placement: number, teamname: string, text: string, value: string }[] = []
    console.log('[getNewTournamentSeasonTeamsRowsTextValues()] tempTournamentRows = ' + JSON.stringify(this.tempTournamentRows))
    console.log(this.tempTournamentRows)
    console.log('[getNewTournamentSeasonTeamsRowsTextValues()] teamsNewDivisionPlacements = ' + JSON.stringify(this.teamsNewDivisionPlacements))

    for (const teamsNewDivisionPlacementItem of this.teamsNewDivisionPlacements) {
      const indexOfTeam = this.tempHolds.findIndex(x => x.id === Number(teamsNewDivisionPlacementItem.id))
      const indexOfRow = this.tempTournamentRows.findIndex(x => x.id === Number(teamsNewDivisionPlacementItem.rowIdOfNewPlacement))
      console.log('[getNewTournamentSeasonTeamsRowsTextValues()] indexOfTeam = ' + indexOfTeam + ' for team id = ' + teamsNewDivisionPlacementItem.id)
      console.log('[getNewTournamentSeasonTeamsRowsTextValues()] indexOfRow = ' + indexOfRow)
      // console.log('[getNewTournamentSeasonTeamsRowsTextValues()] tempHolds = ' + JSON.stringify(this.tempHolds))

      if (indexOfTeam >= 0 && indexOfRow >= 0) {
        if (tournamentRowId === 0) {
          retVal.push({ id: teamsNewDivisionPlacementItem.id, placement: teamsNewDivisionPlacementItem.newPlacement, teamname: this.tempHolds[indexOfTeam].hold_holdnavn, text: this.tempTournamentRows[indexOfRow].raekke_navn, value: teamsNewDivisionPlacementItem.rowIdOfNewPlacement.toString() })
        } else {
          if (teamsNewDivisionPlacementItem.rowIdOfNewPlacement === tournamentRowId) {
            retVal.push({ id: teamsNewDivisionPlacementItem.id, placement: teamsNewDivisionPlacementItem.newPlacement, teamname: this.tempHolds[indexOfTeam].hold_holdnavn, text: this.tempTournamentRows[indexOfRow].raekke_navn, value: teamsNewDivisionPlacementItem.rowIdOfNewPlacement.toString() })
          }
        }
      }
    }

    return retVal
  }

  public moveNewTournamentSeasonTeamInDivisionPlacementsObjectArr (newTournamentSeasonTeamObj: { id: number, newPlacement: number, newRowId: number }) : void {
    console.log('[moveNewTournamentSeasonTeamInDivisionPlacementsObjectArr()] Done.')

    const indexOfTeamsNewDivisionPlacements = this.teamsNewDivisionPlacements.findIndex(x => x.id === Number(newTournamentSeasonTeamObj.id))
    let tempIndex = 0
    let maxPlacement = 0

    if (indexOfTeamsNewDivisionPlacements >= 0) {
      if (this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].rowIdOfNewPlacement === newTournamentSeasonTeamObj.newRowId) {
        if (this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].newPlacement < newTournamentSeasonTeamObj.newPlacement) {
          for (let placementIndex = this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].newPlacement + 1; placementIndex <= newTournamentSeasonTeamObj.newPlacement; placementIndex++) {
            tempIndex = this.teamsNewDivisionPlacements.findIndex(x => (x.rowIdOfNewPlacement === this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].rowIdOfNewPlacement && x.newPlacement === placementIndex))

            if (tempIndex >= 0) {
              this.teamsNewDivisionPlacements[tempIndex].newPlacement = placementIndex - 1
            }
          }
        } else if (this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].newPlacement > newTournamentSeasonTeamObj.newPlacement) {
          for (let placementIndex = this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].newPlacement - 1; placementIndex >= newTournamentSeasonTeamObj.newPlacement; placementIndex--) {
            tempIndex = this.teamsNewDivisionPlacements.findIndex(x => (x.rowIdOfNewPlacement === this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].rowIdOfNewPlacement && x.newPlacement === placementIndex))

            if (tempIndex >= 0) {
              this.teamsNewDivisionPlacements[tempIndex].newPlacement = placementIndex + 1
            }
          }
        }
      } else {
        maxPlacement = this.getNumberOfTeamsInTeamPlacementTournamentRow(this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].rowIdOfNewPlacement)
        console.log('1. maxPlacement = ' + maxPlacement)

        // First remove the selected team from its current placement and division.
        for (let placementIndex = this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].newPlacement + 1; placementIndex <= maxPlacement; placementIndex++) {
          tempIndex = this.teamsNewDivisionPlacements.findIndex(x => (x.rowIdOfNewPlacement === this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].rowIdOfNewPlacement && x.newPlacement === placementIndex))

          if (tempIndex >= 0) {
            this.teamsNewDivisionPlacements[tempIndex].newPlacement = placementIndex - 1
          }
        }

        // Then insert the selected team into the chosen (division) row and at the chosen placement.
        maxPlacement = this.getNumberOfTeamsInTeamPlacementTournamentRow(newTournamentSeasonTeamObj.newRowId)
        console.log('2. maxPlacement = ' + maxPlacement)

        for (let placementIndex = maxPlacement + 1; placementIndex >= newTournamentSeasonTeamObj.newPlacement; placementIndex--) {
          tempIndex = this.teamsNewDivisionPlacements.findIndex(x => (x.rowIdOfNewPlacement === newTournamentSeasonTeamObj.newRowId && x.newPlacement === placementIndex))

          if (tempIndex >= 0) {
            this.teamsNewDivisionPlacements[tempIndex].newPlacement = placementIndex + 1
          }
        }
      }

      this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].newPlacement = newTournamentSeasonTeamObj.newPlacement
      this.teamsNewDivisionPlacements[indexOfTeamsNewDivisionPlacements].rowIdOfNewPlacement = newTournamentSeasonTeamObj.newRowId
    }
  }

  public sortTeamsNewDivisionPlacementsArray () : void {
    const res = this.teamsNewDivisionPlacements.sort((a, b) => ((a.newRowOrdinal * 65536) + a.newPlacement - (b.newRowOrdinal * 65536) - b.newPlacement))
    console.log('res = ' + JSON.stringify(res))
  }

  public getSeasonOptionsData () : void{
    SeasonsDataService.getAll()
      .then((response) => {
        const tempSeasons = response.data as SysTournamentSaesonId[]
        const trueSeasons = tempSeasons.filter(el => el.saeson_status === true)
        const highestTrueId = Math.max(...trueSeasons.map(o => Number(o.id)))
        const currentSeason = tempSeasons.find(el => el.id === highestTrueId)
        if (currentSeason !== undefined) {
          this.filterSeasonTextValue = { text: currentSeason.saeson_navn, value: Number(currentSeason.id).toString() }
        }

        // Fill the season options array of the filter and regular options select.
        this.filterSeasonTextOptions = [{ text: 'Vis alt', value: '0' }]
        this.tournamentSeasonTextOptions = [{ text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }]
        for (const season of tempSeasons) {
          this.filterSeasonTextOptions.push({ text: season.saeson_navn, value: (season.id === undefined ? '0' : Number(season.id).toString()) })
          this.tournamentSeasonTextOptions.push({
            text: season.saeson_navn,
            value: (season.id === undefined ? '0' : Number(season.id).toString()),
            numberOfUsedSlots: (season.kampprog_antal_brugte_slots === null ? '0' : Number(season.kampprog_antal_brugte_slots).toString())
          })
        }
        // console.log('Season names object = ' + JSON.stringify(this.filterSaesonTextOptions))
      })
      .catch((err) => {
        this.error = err
        // console.log(err)
      })
  }

  public async retrieveTeamsOverview (): Promise<void> {
    if (this.teamFirstTimeRetrieve) {
      this.teamFirstTimeRetrieve = false
      const seasonPromise = SeasonsDataService.getAll()
      const clubPromise = ClubsDataService.getAll()
      const tournamenCategroyPromise = Tournaments.TournamentCategoriesDataService.getAll('', null, 'filters[turneringskategori_status][$eq]=true')

      await Promise.all([seasonPromise, clubPromise, tournamenCategroyPromise])
        .then((response) => {
          this.teamSeasons = response[0].data
          const tempClubs = response[1].data as SysClub[]
          this.teamTournamentCategory = response[2].data as SysTournamentCategoryId[]

          const highestId = Math.max(...this.teamSeasons.map(o => Number(o.id)))
          const currentSeason = this.teamSeasons.find(el => Number(el.id) === highestId)

          if (currentSeason !== undefined) {
            this.teamSeasonFilterValue = { text: currentSeason.saeson_navn, value: Number(currentSeason.id) }
          }

          this.teamSeasonFilterOptions = []
          for (const season of this.teamSeasons) {
            this.teamSeasonFilterOptions.push({ text: season.saeson_navn, value: Number(season.id) })
          }

          this.tournamentCategoryFilterOptions = []
          for (const category of this.teamTournamentCategory) {
            this.tournamentCategoryFilterOptions.push({
              text: category.turneringskategori_navn,
              value: Number(category.id)
            })
          }

          // this.teamSeasonFilterOptions.unshift({ text: 'Vis alt', value: 0 })

          this.tournamentCategoryFilterOptions.unshift({ text: 'Vis alt', value: 0 })

          for (const club of tempClubs) {
            this.teamFilterOptions.push({ text: club.klubber_klubnavn, value: Number(club.id) })
          }
          this.teamFilterOptions.unshift({ text: 'Vis alt', value: 0 })
        })
        .catch((err) => {
          console.log(err)
        })
    }

    this.tournamentRowFilterOptions = []
    const seasonIndex = this.teamSeasons.findIndex(el => Number(el.id) === Number(this.teamSeasonFilterValue.value))

    if (seasonIndex !== -1 && (this.teamSeasons[seasonIndex].raekke_id !== undefined || this.teamSeasons[seasonIndex].raekke_id !== null)) {
      for (const item of this.teamSeasons[seasonIndex].raekke_id) {
        this.tournamentRowFilterOptions.push({ text: item.raekke_navn, value: Number(item.id) })
      }
    }

    this.tournamentRowFilterOptions.unshift({ text: 'Vis alt', value: 0 })
    const teamParameters = `filter[saeson_id.id]=${this.teamSeasonFilterValue.value}` + (this.teamFilterValue.value === 0 ? '' : `&filter[klubber_id.id]=${this.teamFilterValue.value}`) + (this.tournamentCategoryFilterValue.value === 0 ? '' : `&filter[raekke_id.turneringskategori_id]=${this.tournamentCategoryFilterValue.value}`) + (this.tournamentRowFilterValue.value === 0 ? '' : `&filter[raekke_id.id]=${this.tournamentRowFilterValue.value}`)

    try {
      this.totalTeamPages = (await TeamsDataService.getCount(teamParameters)).data
    } catch (err) {
      console.log(err)
    }

    this.totalNumberOfTeamPages = Math.ceil(this.totalTeamPages / this.teamPageSizeValue)
    TeamsDataService.getAll(this.currentTeamSort, {
      slicemode: 1,
      start: 0,
      limit: -1,
      page: (this.currentTeamPage - 1),
      pagesize: this.teamPageSizeValue,
      totalcount: this.totalTeamPages
    }, teamParameters)
      .then((response) => {
        console.log('called11')

        this.teams = response.data

        for (const teamItem of this.teams) {
          this.totalCancelTeam(Number(teamItem.id))
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  public retrieveTournamentMatchSchedule () : void {
    let extraParameter = ''
    let tempSeasons: SysTournamentSaesonId[] = []
    console.log('Retrieving Match Schedule')
    const getSeasonOptionsData = async () => {
      if (this.firstTimeRetrieveSeasonData) {
        await SeasonsDataService.getAll()
          .then((resonse) => {
            console.log('Season Data')
            tempSeasons = resonse.data
            const trueSeasons = tempSeasons.filter(el => el.saeson_status === true)
            const higestId = Math.max(...trueSeasons.map(o => Number(o.id)))
            const currentSeason = tempSeasons.find(el => el.id === higestId)
            if (currentSeason === undefined) {
              return
            }

            this.filterSeasonTextValue = { text: currentSeason.saeson_navn, value: Number(currentSeason.id).toString() }
            // if (currentSeason !== undefined) {
            //   this.filterSeasonTextValue = { text: currentSeason.saeson_navn, value: Number(currentSeason.id).toString() }
            // }
            // Fill the season options array of the filter and regular options select.
            this.filterSeasonTextOptions = [{ text: 'Alle', value: '0' }]
            this.tournamentSeasonTextOptions = [{ text: 'Vælg her', value: '0', numberOfUsedSlots: '0' }]
            for (const season of tempSeasons) {
              this.filterSeasonTextOptions.push({ text: season.saeson_navn, value: (season.id === undefined ? '0' : Number(season.id).toString()) })
              this.tournamentSeasonTextOptions.push({ text: season.saeson_navn, value: (season.id === undefined ? '0' : Number(season.id).toString()), numberOfUsedSlots: (season.kampprog_antal_brugte_slots === null ? '0' : Number(season.kampprog_antal_brugte_slots).toString()) })
            }
            this.firstTimeRetrieveSeasonData = false
          })
          .catch((err) => {
            this.error = err
          })
      }
    }
    const promises = []
    promises.push(getSeasonOptionsData())
    Promise.all(promises)
      .then(() => {
        if (this.filterSeasonTextValue !== null && Number(this.filterSeasonTextValue.value) > 0) {
          extraParameter += 'saeson_id.id=' + this.filterSeasonTextValue.value
        }
        console.log('Counting tournament match schedules')
        Tournaments.TournamentMatchSchedulesDataService.getCount(extraParameter)
          .then((response) => {
            this.totalPages3 = response.data
            this.totalNumberOfPages3 = Math.ceil(this.totalPages3 / this.pageSizeValue3)
            console.log(this.currentPage3 + ' of ' + this.totalNumberOfPages3 + ' - total number of entries: ' + this.totalPages3)
            console.log('Fetching tournament match schedule data from API.')
            if (this.tournamentMatchScheduleSearchTerm.length > 0) {
              Tournaments.TournamentMatchSchedulesDataService.findBySearchTerm(this.tournamentMatchScheduleSearchTerm, this.currentMatchSort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage3 - 1), pagesize: this.pageSizeValue3, totalcount: this.totalPages3 }, extraParameter)
                .then((response) => {
                  this.kampprograms = response.data
                  console.log(response.data)
                  this.forceRerenderTournamentsList()
                  this.$forceUpdate()
                })
                .catch((err) => {
                  this.error = err
                  // console.log(err)
                })
            } else {
              Tournaments.TournamentMatchSchedulesDataService.getAll(this.currentMatchSort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage3 - 1), pagesize: this.pageSizeValue3, totalcount: this.totalPages3 }, extraParameter)
                .then((response) => {
                  this.kampprograms = response.data
                  console.log(response.data)
                  this.forceRerenderTournamentsList()
                  this.$forceUpdate()
                  let matchResultParameter = ''
                  for (const item of this.kampprograms) {
                    matchResultParameter += '&kampprogram_id.kampprogram_kampnr=' + item.kampprogram_kampnr
                  }
                  matchResultParameter = matchResultParameter.slice(1)
                  this.retrieveMatchResults(matchResultParameter)
                })
                .catch((err) => {
                  this.error = err
                  // console.log(err)
                })
            }
          })
          .catch((err) => {
            this.error = err
          })
      })
      .catch((err) => {
        this.error = err
      })
  }

  public retrieveMatchResults (resultsParameters: string) : void {
    Tournaments.TournamentMatchSettlementDataService.getAll('', null, resultsParameters)
      .then((response) => {
        this.matchResults = response.data
      })
      .catch((err) => {
        this.error = err
      })
  }

  public getMatchResults (matchNumber: number) : string {
    let retVal = '0 — 0'
    const matchResult = this.matchResults.find(el => el.kampprogram_id.kampprogram_kampnr === matchNumber)
    if (matchResult !== undefined) {
      retVal = (matchResult.kampafvikling_resultat_hjem === null ? '0' : matchResult.kampafvikling_resultat_hjem.toString()) + ' — ' + (matchResult.kampafvikling_resultat_ude === null ? '0' : matchResult.kampafvikling_resultat_ude.toString())
    }
    return retVal
  }

  public retrieveAllTournamentRows () : void {
    Tournaments.TournamentRowsDataService.getAll()
      .then((response) => {
        const tempTournamentRows = response.data
        // Fill the tournament rows options array of the select.
        this.tournamentRowsNameOptions = [{ text: 'Vælg her', value: '0' }]
        for (const tournamentRowsItem of tempTournamentRows) {
          this.tournamentRowsNameOptions.push({ text: tournamentRowsItem.raekke_navn, value: (tournamentRowsItem.id === undefined ? '0' : Number(tournamentRowsItem.id).toString()) })
        }
      })
      .catch((err) => {
        this.error = err
        // console.log(err)
      })
  }

  public retrieveTournamentRows () : void {
    this.retrieveAllTournamentRows()

    console.log('Counting tournament rows')

    Tournaments.TournamentRowsDataService.getCount()
      .then((response) => {
        this.totalPages2 = response.data
        this.totalNumberOfPages2 = Math.ceil(this.totalPages2 / this.pageSizeValue2)
      })
      .catch((err) => {
        this.error = err
      })
    console.log('Fetching tournament rows data from API.')

    if (this.tournamentRowSearchTerm.length > 0) {
      Tournaments.TournamentRowsDataService.findBySearchTerm((this.filterStatusStringValue2 === 'Aktiv'), (this.filterStatusStringValue2 === 'Vis alt'), this.tournamentRowSearchTerm, this.currentRowSort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage2 - 1), pagesize: this.pageSizeValue2, totalcount: this.totalPages2 })
        .then((response) => {
          this.raekkes = response.data
          this.forceRerenderTournamentsList()
          this.$forceUpdate()
        })
        .catch((err) => {
          this.error = err
        })
    } else {
      if (this.filterStatusStringValue2 === 'Vis alt') {
        Tournaments.TournamentRowsDataService.getAll(this.currentRowSort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage2 - 1), pagesize: this.pageSizeValue2, totalcount: this.totalPages2 })
          .then((response) => {
            this.raekkes = response.data
            this.forceRerenderTournamentsList()
            this.$forceUpdate()
          })
          .catch((err) => {
            this.error = err
          })
      } else {
        Tournaments.TournamentRowsDataService.findByTournamentRowStatus((this.filterStatusStringValue2 === 'Aktiv'), this.currentRowSort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage2 - 1), pagesize: this.pageSizeValue2, totalcount: this.totalPages2 })
          .then((response) => {
            this.raekkes = response.data
            this.forceRerenderTournamentsList()
            this.$forceUpdate()
          })
          .catch((err) => {
            this.error = err
          })
      }
    }
  }

  public retrieveTournamentAllCategories () : void {
    Tournaments.TournamentCategoriesDataService.findByTournamentCategoryStatus(true, '')
      .then((response) => {
        const tempTournamentCategories = response.data as SysTournamentCategoryId[]
        console.log(response.data)

        this.tournamentCategoryTitleOptions = [{ text: 'Vælg her', value: '0' }]

        for (const tempTournamentCategory of tempTournamentCategories) {
          this.tournamentCategoryTitleOptions.push({ text: tempTournamentCategory.turneringskategori_navn, value: Number(tempTournamentCategory.id).toString() })
        }
      })
      .catch((err) => {
        // this.error = err
        console.log(err)
      })
  }

  public async retrievePlayersValidationHistory () : Promise<void> {
    const extraParams = this.isStatusClosed ? 'filters[status][$eq]=closed' : 'filters[status][$ne]=closed'
    History.ValidatedPlayersHistoriesDataService.getCount(extraParams)
      .then((response) => {
        this.totalHistoryPages = response.data
        this.totalNumberOfHistoryPages = Math.ceil(this.totalHistoryPages / this.historyPageSizeValue)
      })
      .catch((err) => {
        this.error = err
      })

    History.ValidatedPlayersHistoriesDataService.getAll({ slicemode: 1, start: 0, limit: -1, page: (this.currentHistoryPage - 1), pagesize: this.historyPageSizeValue, totalcount: this.totalHistoryPages }, `${extraParams}&sort=${this.currentPlayerMatchHistorySort}`)
      .then((response) => {
        this.playersHistories = response.data
        // this.updatePlayersHistoriesData()
        this.$forceUpdate()
      })
      .catch((err) => {
        this.error = err
      })
  }

  public updatePlayersHistoriesData () : void {
    if (this.filterPlayerValidationHistoryValue === 'Hjem') {
      this.playersHistoriesData = this.playersHistories.filter((item: any) => {
        if (item.team === 'home') {
          return item
        }
      })
    } else if (this.filterPlayerValidationHistoryValue === 'Ude') {
      this.playersHistoriesData = this.playersHistories.filter((item: any) => {
        if (item.team === 'away') {
          return item
        }
      })
    } else {
      this.playersHistoriesData = this.playersHistories
    }
  }

  public retrieveTournamentCategories () : void {
    Tournaments.TournamentCategoriesDataService.getCount()
      .then((response) => {
        this.totalPages = response.data
        this.totalNumberOfPages = Math.ceil(this.totalPages / this.pageSizeValue)
        console.log(this.currentPage + ' of ' + this.totalNumberOfPages + ' - total number of entries: ' + this.totalPages)
      })
      .catch((err) => {
        this.error = err
      })
    console.log('Fetching tournament categories data from API.')

    if (this.tournamentCategorySearchTerm.length > 0) {
      Tournaments.TournamentCategoriesDataService.findBySearchTerm((this.filterStatusStringValue === 'Aktiv'), (this.filterStatusStringValue === 'Vis alt'), this.tournamentCategorySearchTerm, this.currentCategorySort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage - 1), pagesize: this.pageSizeValue, totalcount: this.totalPages })
        .then((response) => {
          this.turneringskategoris = response.data
          console.log(response.data)
          this.forceRerenderTournamentsList()
          this.$forceUpdate()
        })
        .catch((err) => {
          this.error = err
          // console.log(err)
        })
    } else {
      if (this.filterStatusStringValue === 'Vis alt') {
        Tournaments.TournamentCategoriesDataService.getAll(this.currentCategorySort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage - 1), pagesize: this.pageSizeValue, totalcount: this.totalPages })
          .then((response) => {
            this.turneringskategoris = response.data
            console.log(response.data)
            this.forceRerenderTournamentsList()
            this.$forceUpdate()
          })
          .catch((err) => {
            this.error = err
            // console.log(err)
          })
      } else {
        Tournaments.TournamentCategoriesDataService.findByTournamentCategoryStatus((this.filterStatusStringValue === 'Aktiv'), this.currentCategorySort, { slicemode: 1, start: 0, limit: -1, page: (this.currentPage - 1), pagesize: this.pageSizeValue, totalcount: this.totalPages })
          .then((response) => {
            this.turneringskategoris = response.data
            console.log(response.data)
            this.forceRerenderTournamentsList()
            this.$forceUpdate()
          })
          .catch((err) => {
            this.error = err
            // console.log(err)
          })
      }
    }
  }

  // Methods for the Tournaments rules

  @Watch('rulesCategoryFilterValue')
  onRulesFilterChange () : void {
    if (this.rulesCategoryFilterValue.id === 0) {
      this.extraRulesParameter = ''
    } else {
      this.extraRulesParameter = `filters[turneringskategori_id][id][$eq]=${this.rulesCategoryFilterValue.id.toString()}`
    }
    this.retrieveTournamentRules()
  }

  @Watch('rulesModal')
  onRulesModalChange (toggleValue: boolean) : void {
    if (!toggleValue) {
      this.editingExistingRule = false
      this.tournamentRuleData = { documentId: '', id: 0, categoryValue: { categoryId: 0, categoryName: 'Vælg her' }, regionValue: [], tournamentResult: '', pointsAwarded: 0 }
    }
  }

  @Watch('rulesDeleteWarningModal')
  onDeleteWarningModalChange (toggleValue: boolean) : void {
    if (!toggleValue) {
      this.currentDeletingRuleId = 0
    }
  }

  public retrieveTournamentRules () : void {
    Tournaments.TournamentRulesDataService.getAll(this.currentRulesSort, null, this.extraRulesParameter)
      .then((response) => {
        this.rules = response.data
      })
      .catch((err) => {
        this.error = err
      })
  }

  public getRegions (regions: SysTournamentRegionId[]) : string {
    let retVal = ''
    let firstLoop = true

    for (const item of regions) {
      retVal += (firstLoop ? item.region_navn : ', ' + item.region_navn)

      if (firstLoop) {
        firstLoop = false
      }
    }

    return retVal
  }

  public async retrieveRegionsForRule () : Promise<void> {
    const countResponse = await CommonFunctions.getCountApi('regions')

    this.totalPages = countResponse?.data
    this.totalNumberOfPages = Math.ceil(this.totalPages / this.pageSizeValue)

    this.regionOptions = [{ regionId: 0, regionName: 'Alle regioner' }]
    await RegionsDataService.getAll('', null, '', this.totalPages?.toString())
      .then((response) => {
        const tempRegions = response.data as SysRegion[]

        for (const item of tempRegions) {
          this.regionOptions.push({
            regionId: Number(item.id),
            regionName: item.region_navn
          })
        }
        console.log(this.regionOptions)
      })
      .catch((err) => {
        this.error = err
      })
  }

  public retrieveCategoriesForRules () : void {
    this.rulesCategoryFilterOptions = [{ id: 0, value: 'Vis alt' }]
    this.categoryOptions = []

    Tournaments.TournamentCategoriesDataService.getAll('', null, 'filters[turneringskategori_status][$eq]=true')
      .then((response) => {
        const tempCategories = response.data as SysTournamentCategoryId[]

        for (const item of tempCategories) {
          this.rulesCategoryFilterOptions.push({
            id: Number(item.id),
            value: item.turneringskategori_navn
          })
          this.categoryOptions.push({
            categoryId: Number(item.id),
            categoryName: item.turneringskategori_navn
          })
        }
      })
      .catch((err) => {
        this.error = err
      })
  }

  public newRule () : void {
    this.rulesModal = true
    this.editingExistingRule = false
  }

  public choosenRegions (regionValue: {regionId: number, regionName: string}[]) : string {
    let retVal = ''

    if (regionValue.length === 0) {
      retVal = 'Ingen'
    } else {
      let firstLoop = true

      for (const item of regionValue) {
        retVal += (firstLoop ? item.regionName : ', ' + item.regionName)

        if (firstLoop) {
          firstLoop = false
        }
      }
    }

    return retVal
  }

  public arrayEquals (a: number[], b: number[]) : boolean {
    return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index])
  }

  public createNewRule () : void {
    if (Number(this.tournamentRuleData.categoryValue.categoryId) === 0 || this.tournamentRuleData.regionValue.length === 0 || this.tournamentRuleData.tournamentResult.length === 0 || this.tournamentRuleData.pointsAwarded.toString().length === 0) {
      return this.$Message.danger({ text: 'Et eller flere felter er ikke udfyldt korrekt' })
    }

    const regionNumberArray = []
    const regions = this.regionOptions.slice(1)
    const regionIndex = this.tournamentRuleData.regionValue.findIndex(el => Number(el.regionId) === 0)
    if (regionIndex !== -1) {
      for (const item of regions) {
        regionNumberArray.push(Number(item.regionId))
      }
    } else {
      for (const item of this.tournamentRuleData.regionValue) {
        regionNumberArray.push(Number(item.regionId))
      }
    }

    // Check that there is not already a rule.
    // Checks if there is already a rule with the same category and result.
    if (!this.checkedRuleFlag) {
      const categoryAndResultExitst = this.rules.find((el) => Number(el.turneringskategori_id.id) === Number(this.tournamentRuleData.categoryValue.categoryId) && el.turneringsregler_resultat === this.tournamentRuleData.tournamentResult.trim())
      if (categoryAndResultExitst !== undefined) {
        // If both category and result already exist as rule, do additional checks of regions.
        if (regionNumberArray.length === 9) {
          this.rulesWarningModal = true

          return
        }

        const regionIds: number[] = []
        for (const item of categoryAndResultExitst.regions) {
          regionIds.push(Number(item.id))
        }

        const regionIsIdentical = this.arrayEquals(regionNumberArray, regionIds)
        if (regionIsIdentical) {
          this.rulesWarningModal = true

          return
        }
      }
    }

    const createRule = {
      data: {
        turneringskategori_id: this.tournamentRuleData.categoryValue.categoryId,
        regions: regionNumberArray,
        turneringsregler_point: this.tournamentRuleData.pointsAwarded,
        turneringsregler_resultat: this.tournamentRuleData.tournamentResult.trim()
      }
    }

    Tournaments.TournamentRulesDataService.create(createRule)
      .then((response) => {
        console.log(response.data)
        this.retrieveTournamentRules()
        this.rulesModal = false
        this.checkedRuleFlag = false
      })
      .catch((err) => {
        this.checkedRuleFlag = false
        this.error = err
      })
  }

  public deleteWarning (rulesId: number, documentId: string) : void {
    this.rulesDeleteWarningModal = true
    this.currentDeletingRuleId = rulesId
    this.currentDeletingRuleDocumentId = documentId
  }

  public deleteRule (rulesDocId: string) : void {
    Tournaments.TournamentRulesDataService.delete(rulesDocId)
      .then(() => {
        this.$Message.success({ text: 'Reglen er blevet slettet' })
        this.rulesDeleteWarningModal = false
        this.currentDeletingRuleId = 0
        this.retrieveTournamentRules()
      })
      .catch((err) => {
        console.log(err)
      })
  }

  public editRule (documentId: string) : void {
    Tournaments.TournamentRulesDataService.get(documentId)
      .then((response) => {
        const tempRule = response.data as SysTournamentRules

        const tempRegions: { regionId: number, regionName: string }[] = []
        if (tempRule.regions.length === 9) {
          tempRegions.push({ regionId: 0, regionName: 'Alle regioner' })
        } else {
          for (const item of tempRule.regions) {
            tempRegions.push({
              regionId: Number(item.id),
              regionName: item.region_navn
            })
          }
        }

        this.tournamentRuleData = {
          documentId: documentId,
          id: Number(tempRule.id),
          categoryValue: { categoryId: Number(tempRule.turneringskategori_id.id), categoryName: tempRule.turneringskategori_id.turneringskategori_navn },
          regionValue: tempRegions,
          pointsAwarded: tempRule.turneringsregler_point,
          tournamentResult: tempRule.turneringsregler_resultat
        }

        this.rulesModal = true
        this.editingExistingRule = true
      })
      .catch((err) => {
        this.error = err
      })
  }

  public updateRule () : void {
    if (Number(this.tournamentRuleData.categoryValue.categoryId) === 0 || this.tournamentRuleData.regionValue.length === 0 || this.tournamentRuleData.tournamentResult.length === 0 || this.tournamentRuleData.pointsAwarded.toString().length === 0) {
      return this.$Message.danger({ text: 'Et eller flere felter er ikke udfyldt korrekt' })
    }

    const regionNumberArray = []
    const regions = this.regionOptions.slice(1)
    const regionIndex = this.tournamentRuleData.regionValue.findIndex(el => Number(el.regionId) === 0)

    if (regionIndex !== -1) {
      for (const item of regions) {
        regionNumberArray.push(Number(item.regionId))
      }
    } else {
      for (const item of this.tournamentRuleData.regionValue) {
        regionNumberArray.push(Number(item.regionId))
      }
    }

    // Check that there is not already a rule.
    // Checks if there is already a rule with the same category and result.
    if (!this.checkedRuleFlag) {
      const categoryAndResultExitst = this.rules.find((el) => Number(el.turneringskategori_id.id) === Number(this.tournamentRuleData.categoryValue.categoryId) && el.turneringsregler_resultat === this.tournamentRuleData.tournamentResult.trim() && Number(el.id) !== Number(this.tournamentRuleData.id))
      if (categoryAndResultExitst !== undefined) {
        // If both category and result already exist as rule, do additional checks of regions.
        if (regionNumberArray.length === 9) {
          this.rulesWarningModal = true

          return
        }

        const regionIds: number[] = []
        for (const item of categoryAndResultExitst.regions) {
          regionIds.push(Number(item.id))
        }

        const regionIsIdentical = this.arrayEquals(regionNumberArray, regionIds)
        if (regionIsIdentical) {
          this.rulesWarningModal = true

          return
        }
      }
    }

    const updateRule = {
      data: {
        turneringskategori_id: this.tournamentRuleData.categoryValue.categoryId,
        regions: regionNumberArray,
        turneringsregler_point: this.tournamentRuleData.pointsAwarded,
        turneringsregler_resultat: this.tournamentRuleData.tournamentResult
      }
    }

    Tournaments.TournamentRulesDataService.update(this.tournamentRuleData.documentId, updateRule)
      .then(() => {
        this.$Message.success({ text: 'Ændringerne af reglens oplysninger blev gemt' })
        this.rulesModal = false
        this.checkedRuleFlag = false
        this.retrieveTournamentRules()
      })
      .catch((err) => {
        this.checkedRuleFlag = false
        this.error = err
      })
  }

  private editTournamentMatchSettlementTeamPlayersHelper (tournamentMatchScheduleId: number, tournamentMatchScheduleRowNumberOfPlayersPerTeam: number | null, tournamentMatchScheduleRowMaxNumberOfPlayersPerTeam: number | null): void {
    if (this.tempTournamentMatchSettlement !== undefined && this.tempTournamentMatchSettlement !== null && this.tempTournamentMatchSettlement.kampprogram_id !== undefined && this.tempTournamentMatchSettlement.kampprogram_id !== null) {
      // const matchSettlementDataExtPlayersMemberFindParam = '' + this.kampprograms[].kampprogram_hjemmehold
      // const matchSettlementDataExtPlayersMemberFindParam = 'hold_id.id=' + this.tempTournamentMatchSettlement.kampprogram_id.kampprogram_hjemmehold + '&hold_id.id=' + this.tempTournamentMatchSettlement.kampprogram_id.kampprogram_udehold
      const matchSettlementDataExtPlayersMemberFindParam = ''
      this.tempTournamentMatchSettlementTeamIds[0] = Number(this.tempTournamentMatchSettlement.kampprogram_id.kampprogram_hjemmehold)
      this.tempTournamentMatchSettlementTeamIds[1] = Number(this.tempTournamentMatchSettlement.kampprogram_id.kampprogram_udehold)
      const tempTournamentMatchSettlementClubIds = [0, 0]

      // Obtain first the clubIds for the two teams involved.
      TeamsDataService.getAll('', null, 'id=' + Number(this.tempTournamentMatchSettlement.kampprogram_id.kampprogram_hjemmehold).toString() + '&id=' + Number(this.tempTournamentMatchSettlement.kampprogram_id.kampprogram_udehold).toString())
        .then((response) => {
          console.log('called3')
          // this.tempTournamentMatchSettlement = response.data[0]
          console.log(response.data)

          if (response.data !== null) {
            // console.log('GOOD1 = ' + Number(response.data[0].klubber_id.id))
            if (Number(response.data[0].id) === this.tempTournamentMatchSettlementTeamIds[0]) {
              // tempTournamentMatchSettlementClubIds[0] = Number(53)
              tempTournamentMatchSettlementClubIds[0] = Number(response.data[0].klubber_id.id)
              // console.log('GOOD1b = ' + Number(response.data[0].klubber_id.id))
            } else if (Number(response.data[0].id) === this.tempTournamentMatchSettlementTeamIds[1]) {
              tempTournamentMatchSettlementClubIds[1] = Number(response.data[0].klubber_id.id)
            }
            // console.log('GOOD2')
            if (Number(response.data[1].id) === this.tempTournamentMatchSettlementTeamIds[0]) {
              tempTournamentMatchSettlementClubIds[0] = Number(response.data[1].klubber_id.id)
            } else if (Number(response.data[1].id) === this.tempTournamentMatchSettlementTeamIds[1]) {
              tempTournamentMatchSettlementClubIds[1] = Number(response.data[1].klubber_id.id)
            }
            // console.log('GOOD3 = ' + JSON.stringify(tempTournamentMatchSettlementClubIds))
          }

          MembersDataService.getAll('', null, matchSettlementDataExtPlayersMemberFindParam)
            .then((response) => {
              this.tempTournamentMatchSettlementPlayersMemberData = response.data
              console.log(response.data)

              // Fill team players select options with relevant data.
              let homeArrIndex = 0
              let guestArrIndex = 0
              let tempClubId = 0
              let tempTeamId = 0
              this.matchSettlementHomeTeamPlayersNameOptions = []
              this.matchSettlementGuestTeamPlayersNameOptions = []

              for (const objItem of this.tempTournamentMatchSettlementPlayersMemberData) {
                if (objItem.medlem_status === true) {
                  tempClubId = (objItem.klubber_id === undefined || objItem.klubber_id === null ? 0 : Number(objItem.klubber_id.id))
                  tempTeamId = (objItem.hold_id === undefined || objItem.hold_id === null ? 0 : Number(objItem.hold_id.id))
                  console.log('[editTournamentMatchSettlementTeamPlayersHelper] Club Id to be checked = ' + tempClubId)
                  // console.log('[editTournamentMatchSettlementTeamPlayersHelper] Club Id check = ' + Number((tempClubId === tempTournamentMatchSettlementClubIds[0] ? 0 : 1) + (tempClubId === tempTournamentMatchSettlementClubIds[1] ? 1 : 0)))
                  // console.log('[editTournamentMatchSettlementTeamPlayersHelper] Team Id check = ' + Number((tempTeamId === this.tempTournamentMatchSettlementTeamIds[0] ? 0 : 1) + (tempTeamId === this.tempTournamentMatchSettlementTeamIds[1] ? 1 : 0)))

                  // Generate home team players select options.
                  if (tempClubId === tempTournamentMatchSettlementClubIds[0]) {
                    // if (tempTeamId === this.tempTournamentMatchSettlementTeamIds[0]) {
                    // if (this.tempTournamentMatchSettlementTeamIds[0] !== null) {
                    this.matchSettlementHomeTeamPlayersNameOptions[homeArrIndex] = {
                      key: homeArrIndex,
                      name: objItem.user_id.firstname + ' ' + objItem.user_id.lastname + ' [' + (objItem.medlem_licens === null ? '' : objItem.medlem_licens) + '], Klub: ' + (objItem.klubber_id === undefined || objItem.klubber_id === null ? 'Ingen' : objItem.klubber_id.klubber_klubnavn),
                      value: Number(objItem.id).toString(),
                      gender: Number(objItem.koen_id.id).toString(),
                      birthdaydate: objItem.medlem_foedselsdag,
                      isparadart: objItem.medlem_paradart,
                      clubid: (objItem.klubber_id === undefined || objItem.klubber_id === null ? 0 : Number(objItem.klubber_id.id)),
                      teamid: tempTeamId
                    }

                    homeArrIndex++
                  }

                  // Generate guest team players select options.
                  if (tempClubId === tempTournamentMatchSettlementClubIds[1]) {
                    // if (tempTeamId === this.tempTournamentMatchSettlementTeamIds[1]) {
                    // if (this.tempTournamentMatchSettlementTeamIds[1] !== null) {
                    this.matchSettlementGuestTeamPlayersNameOptions[guestArrIndex] = {
                      key: guestArrIndex,
                      name: objItem.user_id.firstname + ' ' + objItem.user_id.lastname + ' [' + (objItem.medlem_licens === null ? '' : objItem.medlem_licens) + '], Klub: ' + (objItem.klubber_id === undefined || objItem.klubber_id === null ? 'Ingen' : objItem.klubber_id.klubber_klubnavn),
                      value: Number(objItem.id).toString(),
                      gender: Number(objItem.koen_id.id).toString(),
                      birthdaydate: objItem.medlem_foedselsdag,
                      isparadart: objItem.medlem_paradart,
                      clubid: (objItem.klubber_id === undefined || objItem.klubber_id === null ? 0 : Number(objItem.klubber_id.id)),
                      teamid: tempTeamId
                    }

                    guestArrIndex++
                  }
                }
              }

              console.log('[editTournamentMatchSettlementTeamPlayersHelper] matchSettlementHomeTeamPlayersNameOptions[] = ' + JSON.stringify(this.matchSettlementHomeTeamPlayersNameOptions))
              console.log('[editTournamentMatchSettlementTeamPlayersHelper] matchSettlementGuestTeamPlayersNameOptions[] = ' + JSON.stringify(this.matchSettlementGuestTeamPlayersNameOptions))

              this.matchSettlementHomeTeamPlayersNameValue = []
              this.matchSettlementGuestTeamPlayersNameValue = []

              for (let arrIndex = 0; arrIndex < this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.length; arrIndex++) {
                if (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[arrIndex].kampafvikling_spiller_hj !== null) {
                  const indexOfmatchSettlementHomeTeamPlayersNameOptions = this.matchSettlementHomeTeamPlayersNameOptions.findIndex(x => Number(x.value) === Number(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[arrIndex].kampafvikling_spiller_hj))
                  console.log('[editTournamentMatchSettlementTeamPlayersHelper]  kampafvikling_spiller_hj[' + arrIndex + '] = ' + Number(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[arrIndex].kampafvikling_spiller_hj))
                  console.log('[editTournamentMatchSettlementTeamPlayersHelper]  indexOfmatchSettlementHomeTeamPlayersNameOptions = ' + indexOfmatchSettlementHomeTeamPlayersNameOptions)

                  if (indexOfmatchSettlementHomeTeamPlayersNameOptions > -1) {
                    this.matchSettlementHomeTeamPlayersNameValue.push({
                      name: this.matchSettlementHomeTeamPlayersNameOptions[indexOfmatchSettlementHomeTeamPlayersNameOptions].name,
                      value: this.matchSettlementHomeTeamPlayersNameOptions[indexOfmatchSettlementHomeTeamPlayersNameOptions].value,
                      gender: this.matchSettlementHomeTeamPlayersNameOptions[indexOfmatchSettlementHomeTeamPlayersNameOptions].gender,
                      birthdaydate: this.matchSettlementHomeTeamPlayersNameOptions[indexOfmatchSettlementHomeTeamPlayersNameOptions].birthdaydate,
                      isparadart: this.matchSettlementHomeTeamPlayersNameOptions[indexOfmatchSettlementHomeTeamPlayersNameOptions].isparadart,
                      clubid: this.matchSettlementHomeTeamPlayersNameOptions[indexOfmatchSettlementHomeTeamPlayersNameOptions].clubid,
                      teamid: this.matchSettlementHomeTeamPlayersNameOptions[indexOfmatchSettlementHomeTeamPlayersNameOptions].teamid
                    })
                  }
                }
              }

              for (let arrIndex = 0; arrIndex < this.tempTournamentMatchSettlement.kampafvikling_ekstras_id.length; arrIndex++) {
                if (this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[arrIndex].kampafvikling_spiller_ud !== null) {
                  const indexOfmatchSettlementGuestTeamPlayersNameOptions = this.matchSettlementGuestTeamPlayersNameOptions.findIndex(x => Number(x.value) === Number(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[arrIndex].kampafvikling_spiller_ud))
                  console.log('[editTournamentMatchSettlementTeamPlayersHelper]  kampafvikling_spiller_hj[' + arrIndex + '] = ' + Number(this.tempTournamentMatchSettlement.kampafvikling_ekstras_id[arrIndex].kampafvikling_spiller_hj))
                  console.log('[editTournamentMatchSettlementTeamPlayersHelper]  indexOfmatchSettlementGuestTeamPlayersNameOptions = ' + indexOfmatchSettlementGuestTeamPlayersNameOptions)

                  if (indexOfmatchSettlementGuestTeamPlayersNameOptions > -1) {
                    this.matchSettlementGuestTeamPlayersNameValue.push({
                      name: this.matchSettlementGuestTeamPlayersNameOptions[indexOfmatchSettlementGuestTeamPlayersNameOptions].name,
                      value: this.matchSettlementGuestTeamPlayersNameOptions[indexOfmatchSettlementGuestTeamPlayersNameOptions].value,
                      gender: this.matchSettlementGuestTeamPlayersNameOptions[indexOfmatchSettlementGuestTeamPlayersNameOptions].gender,
                      birthdaydate: this.matchSettlementGuestTeamPlayersNameOptions[indexOfmatchSettlementGuestTeamPlayersNameOptions].birthdaydate,
                      isparadart: this.matchSettlementGuestTeamPlayersNameOptions[indexOfmatchSettlementGuestTeamPlayersNameOptions].isparadart,
                      clubid: this.matchSettlementGuestTeamPlayersNameOptions[indexOfmatchSettlementGuestTeamPlayersNameOptions].clubid,
                      teamid: this.matchSettlementGuestTeamPlayersNameOptions[indexOfmatchSettlementGuestTeamPlayersNameOptions].teamid
                    })
                  }
                }
              }

              console.log('[editTournamentMatchSettlementTeamPlayersHelper] matchSettlementHomeTeamPlayersNameValue[] = ' + JSON.stringify(this.matchSettlementHomeTeamPlayersNameValue))

              this.editTournamentMatchSettlementTeamPlayersModal = true
              // this.tempTournamentMatchSettlementPlayersMemberData = []
            })
            .catch((err) => {
              this.error = err
            })
        })
        .catch((err) => {
          this.error = err
        })
    }
  }

  @Watch('teamSeasonFilterValue')
  onTeamSeasonFilterValueChange () : void {
    this.retrieveTeamsOverview()
  }

  @Watch('tournamentCategoryFilterValue')
  onTournamentCategoryFilterValueChange () : void {
    this.retrieveTeamsOverview()
  }

  @Watch('teamFilterValue')
  onTeamFilterValueChange () : void {
    this.retrieveTeamsOverview()
  }

  @Watch('tournamentRowFilterValue')
  onTournamentRowFilterValue () : void {
    this.retrieveTeamsOverview()
  }

  @Watch('teamPageSizeValueString')
  onTeamPageSizeValueChange (newVal: any) : void {
    this.teamPageSizeValue = Number(newVal)
    this.currentTeamPage = 1
    this.retrieveTeamsOverview()
    CommonFunctions.scrollToTop()
  }

  public turnToNewTeamPage (pageChange: number) : void {
    this.currentTeamPage += pageChange

    if (this.currentTeamPage < 1) {
      this.currentTeamPage = 1
    } else if (this.currentTeamPage >= this.totalTeamPages) {
      this.currentTeamPage = this.totalTeamPages
    }

    this.retrieveTeamsOverview()
  }

  public jumpToTeamPage (pageNumber: number) : void {
    this.currentTeamPage = pageNumber

    if (this.currentTeamPage < 1) {
      this.currentTeamPage = 1
    } else if (this.currentTeamPage > this.totalNumberOfTeamPages) {
      this.currentTeamPage = this.totalNumberOfTeamPages
    }

    this.retrieveTeamsOverview()
  }

  public teamSort (sortBy = '') : void {
    switch (sortBy) {
      case 'teamName': {
        if (this.oldTeamSort !== sortBy) {
          this.currentTeamSort = 'hold_holdnavn:desc'
          this.oldTeamSort = sortBy
        } else {
          this.currentTeamSort = 'hold_holdnavn:asc'
          this.oldTeamSort = ''
        }

        break
      }
      case 'clubName': {
        if (this.oldTeamSort !== sortBy) {
          this.currentTeamSort = '[klubber_id][klubber_klubnavn]=asc,hold_holdnavn:asc'
          this.oldTeamSort = sortBy
        } else {
          this.currentTeamSort = '[klubber_id][klubber_klubnavn]=desc,hold_holdnavn:asc'
          this.oldTeamSort = ''
        }

        break
      }
      case 'row': {
        if (this.oldTeamSort !== sortBy) {
          this.currentTeamSort = 'raekke_id.raekke_navn:asc,hold_holdnavn:asc'
          this.oldTeamSort = sortBy
        } else {
          this.currentTeamSort = 'raekke_id.raekke_navn:desc,hold_holdnavn:asc'
          this.oldTeamSort = ''
        }

        break
      }
      default: {
        this.currentTeamSort = 'hold_holdnavn:asc'
        this.oldTeamSort = ''
        this.teamFilterValue = { text: 'Vis alt', value: 0 }
        this.tournamentCategoryFilterValue = { text: 'Vis alt', value: 0 }
        this.tournamentRowFilterValue = { text: 'Vis alt', value: 0 }
        this.currentTeamPage = 1

        break
      }
    }
    this.retrieveTeamsOverview()
  }

  public getCategoryNameFromId (id: number) : string {
    let retVal = ''
    const index = this.teamTournamentCategory.findIndex(el => Number(el.id) === id)

    if (index !== -1) {
      retVal = this.teamTournamentCategory[index].turneringskategori_navn
    }
    return retVal
  }

  public async editTeamInfo (teamId: number) : Promise<void> {
    this.numberCancellations = 0
    this.numberNonAppearance = 0
    const retrieveTeamInfoPromise = TeamsDataService.get(teamId.toString())
    const retrieveTeamsMatchSchedule = Tournaments.TournamentMatchSchedulesDataService.getAll('', null, `_where[_or][0][kampprogram_hjemmehold]=${teamId}&_where[_or][1][kampprogram_udehold]=${teamId}`)

    Promise.all([retrieveTeamInfoPromise, retrieveTeamsMatchSchedule])
      .then(async (response) => {
        this.teamData = response[0].data as SysTeam
        this.teamMatchSchedule = response[1].data as SysTournamentMatchSchedule[]
        this.teamDataModal = true
        let matchSettlementId = ''

        if (this.teamMatchSchedule.length > 0) {
          for (const item of this.teamMatchSchedule) {
            if (Number(item.kampprogram_hjemmehold.id) === Number(this.teamData.id)) {
              this.numberCancellations += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudhjem ? 1 : 0
              this.numberNonAppearance += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelsehjem ? 1 : 0
            } else {
              this.numberCancellations += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudud ? 1 : 0
              this.numberNonAppearance += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelseud ? 1 : 0
            }

            matchSettlementId += '&kampprogram_id.id=' + item.id
          }
          matchSettlementId = matchSettlementId.slice(1)
          console.log(matchSettlementId)

          try {
            this.teamMatchSettlement = (await Tournaments.TournamentMatchSettlementDataService.getAll('', null, matchSettlementId)).data as SysTournamentMatchSettlement[]
          } catch (err) {
            console.log(err)
          }
        }

        // console.log(this.teamData)
        // console.log(this.teamMatchSchedule)
        // console.log(this.teamMatchSettlement)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  public async totalCancelTeam (teamId: number) : Promise<void> {
    let numberCancellations = 0
    let numberNonAppearance = 0

    try {
      const teamMatchSchedule = (await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('', null, `_where[_or][0][kampprogram_hjemmehold]=${teamId}&_where[_or][1][kampprogram_udehold]=${teamId}`)).data as SysTournamentMatchSchedule[]

      if (teamMatchSchedule.length > 0) {
        for (const item of teamMatchSchedule) {
          if (Number(item.kampprogram_hjemmehold.id) === Number(teamId)) {
            numberCancellations += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudhjem ? 1 : 0
            numberNonAppearance += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelsehjem ? 1 : 0
          } else {
            numberCancellations += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudud ? 1 : 0
            numberNonAppearance += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelseud ? 1 : 0
          }
        }

        this.totalCancelTeamArr[teamId] = numberCancellations + numberNonAppearance
      } else {
        this.totalCancelTeamArr[teamId] = 0
      }
    } catch (err) {
      console.log(err)
    }

    // Promise.all([retrieveTeamInfoPromise, retrieveTeamsMatchSchedule])
    //   .then(async (response) => {
    //     this.teamData = response[0].data as SysTeam
    //     this.teamMatchSchedule = response[1].data as SysTournamentMatchSchedule[]
    //     let matchSettlementId = ''

    //     if (this.teamMatchSchedule.length > 0) {
    //       for (const item of this.teamMatchSchedule) {
    //         if (Number(item.kampprogram_hjemmehold.id) === Number(this.teamData.id)) {
    //           this.numberCancellations += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudhjem ? 1 : 0
    //           this.numberNonAppearance += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelsehjem ? 1 : 0
    //         } else {
    //           this.numberCancellations += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Afbudud ? 1 : 0
    //           this.numberNonAppearance += item.kampprogram_afb_udb === tournamentMatchScheduleTeamStatusFriendlyType.Udeblivelseud ? 1 : 0
    //         }

    //         matchSettlementId += '&kampprogram_id.id=' + item.id
    //       }
    //       matchSettlementId = matchSettlementId.slice(1)
    //       console.log(matchSettlementId)
    //     }

    //     console.log(this.teamData)
    //     console.log(this.teamMatchSchedule)
    //     console.log(this.teamMatchSettlement)
    //   })
    //   .catch((err) => {
    //     console.log(err)
    //   })
    // console.log('[totalCancelTeam()] Total cancellations + non-appearance of team with Id ' + teamId + ': ' + (numberCancellations + numberNonAppearance).toString())
    // return numberCancellations + numberNonAppearance
  }

  public getTeamResults (matchScheduleId: number) : string {
    let retVal = '0-0'
    const index = this.teamMatchSettlement.findIndex(el => Number(el.kampprogram_id.id) === matchScheduleId)

    if (index !== -1) {
      retVal = (this.teamMatchSettlement[index].kampafvikling_resultat_hjem === null ? 0 : this.teamMatchSettlement[index].kampafvikling_resultat_hjem.toString()) + '-' + (this.teamMatchSettlement[index].kampafvikling_resultat_ude === null ? 0 : this.teamMatchSettlement[index].kampafvikling_resultat_ude.toString())
    }

    return retVal
  }

  // Team withdraw methods
  @Watch('teamWithDrawWarningModal')
  onWithDrawModalChange (toggleValue: boolean) : void {
    if (!toggleValue) {
      this.teamWithDrawId = 0
    }
  }

  public async withDrawTeam () : Promise<void> {
    let teamData = {} as SysTeam
    try {
      teamData = (await TeamsDataService.get(this.teamWithDrawId.toString())).data as SysTeam
    } catch (err) {
      console.log(err)
    }
    console.log(teamData)
    const tournamnetCatgoryPromise = Tournaments.TournamentCategoriesDataService.get(teamData.raekke_id.turneringskategori_id.toString())
    const retrieveTeamsMatchSchedulePromise = Tournaments.TournamentMatchSchedulesDataService.getAll('', null, `_where[_or][0][kampprogram_hjemmehold.id]=${teamData.id}&_where[_or][1][kampprogram_udehold.id]=${teamData.id}`)
    const removeSelectedTeamEmailPayload = {
      tournamentId: teamData?.raekke_id?.id,
      teamId: teamData?.id,
      teamName: teamData?.hold_holdnavn,
      clubId: teamData?.klubber_id?.id,
      tournamentName: teamData?.raekke_id?.raekke_navn,
      cancelCount: this.numberCancellations,
      absenceCount: this.numberNonAppearance
    }
    const removeSelectedTeamEmailPromise = TeamsDataService.removeSelectedTeamEmail(removeSelectedTeamEmailPayload)
    await Promise.all([removeSelectedTeamEmailPromise])
      .then((response) => {
        console.log('RESPONSE', response[0].data)
      })
      .catch((error) => {
        console.log('ERROR', error)
      })
    await Promise.all([tournamnetCatgoryPromise, retrieveTeamsMatchSchedulePromise])
      .then(async (response) => {
        const category = response[0].data as SysTournamentCategoryId
        const matches = response[1].data as SysTournamentMatchSchedule[]
        let loseScore = 16
        console.log(response[0].data)
        console.log(response[1].data)

        if (category.turneringskategori_navn.toLowerCase().includes('hovedturning')) {
          loseScore = 16
        } else if (category.turneringskategori_navn.toLowerCase().includes('hverdagsrækken')) {
          if (teamData.raekke_id.raekke_antalspillere === 4) {
            loseScore = 16
          } else {
            loseScore = 9
          }
        } else if (category.turneringskategori_navn.toLowerCase().includes('damepairs')) {
          loseScore = 5
        } else if (category.turneringskategori_navn.toLowerCase().includes('junior')) {
          loseScore = 5
        } else if (category.turneringskategori_navn.toLowerCase().includes('oldboys')) {
          loseScore = 6
        } else {
          loseScore = 16
        }

        const remainingMatches = matches.filter(el => el.kampgodkendt_id === null)

        console.log(remainingMatches)
        const promises = []

        for (const item of remainingMatches) {
          let matchSettlement: SysTournamentMatchSettlement[] = []
          try {
            matchSettlement = (await Tournaments.TournamentMatchSettlementDataService.getAll('', null, `kampprogram_id.id=${item.id}`)).data
          } catch (err) {
            console.log(err)
          }
          // Conditions based on the number of legs for Juniorturnering
          if (category.turneringskategori_navn.toLowerCase().includes('junior')) {
            const antalsaetOfMatch = item?.raekke_id?.raekke_antalsaet
            if (antalsaetOfMatch === 3) {
              loseScore = 3
            } else if (antalsaetOfMatch === 4) {
              loseScore = 4
            } else {
              loseScore = 5
            }
          }
          if (matchSettlement.length > 0) {
            const updateMatchSettlement = {
              kampafvikling_resultat_hjem: (Number(item.kampprogram_hjemmehold.id) === Number(teamData.id) ? 0 : loseScore),
              kampafvikling_resultat_ude: (Number(item.kampprogram_udehold.id) === Number(teamData.id) ? 0 : loseScore)
            }
            promises.push(Tournaments.TournamentMatchSettlementDataService.update(Number(matchSettlement[0].id).toString(), updateMatchSettlement))
          } else {
            const createMatchSettlement = {
              kampprogram_id: item.id,
              kampafvikling_resultat_hjem: (Number(item.kampprogram_hjemmehold.id) === Number(teamData.id) ? 0 : loseScore),
              kampafvikling_resultat_ude: (Number(item.kampprogram_udehold.id) === Number(teamData.id) ? 0 : loseScore)
            }
            promises.push(Tournaments.TournamentMatchSettlementDataService.create(createMatchSettlement))
          }

          const matchApproved = {
            kampgodkendt_godkendt: true,
            kampprogram_id: Number(item.id)
          }

          promises.push(Tournaments.TournamentMatchFinalApproval.create(matchApproved))
        }

        await Promise.all(promises)
          .then(() => {
            const updateTeamStatus = {
              hold_status: false
            }

            TeamsDataService.update(Number(teamData.id).toString(), updateTeamStatus)
              .then((response) => {
                console.log('Team withdrawn from tournament: ' + response.statusText)

                this.teamWithdrawWarningModal = false
                this.retrieveTeamsOverview()
              })
              .catch((err) => {
                console.log(err)
              })
          })
          .catch((err) => {
            console.log(err)
          })
      })
      .catch((err) => {
        console.log(err)
      })
  }

  public withDrawWarning (teamId: number) : void {
    this.teamWithDrawId = teamId
    this.teamWithdrawWarningModal = true
    this.teamDataModal = false
    console.log(teamId)
  }

  public async validatePlayerHistory () : Promise<void> {
    // const validatePlayerHistory = History.ValidatedPlayersHistoriesDataService.get()
    const validatePlayerHistory = History.ValidatedPlayersHistoriesDataService.getAll()
    await Promise.all([validatePlayerHistory])
      .then((response) => {
        this.playersHistories = response[0].data
        this.playersHistoriesData = this.playersHistories
      })
      .catch((error) => {
        this.error = error
      })
    this.retrievePlayersValidationHistory()
  }

  public async setSelectedPlayer (player: any) : Promise<void> {
    this.lastPlayedMatchModel = true
    this.selectedPlayersLastMatchData = player
    const matchRaekkePromiss = Tournaments.TournamentRowsDataService.get(player.matchId.raekke_id.toString())
    await Promise.all([matchRaekkePromiss])
      .then((response) => {
        this.selectedPlayersMatchRaekke = response[0].data
      })
      .catch((error) => {
        console.log('ERROR', error)
      })
    this.setLastPlayedMatch()
  }

  public async setLastPlayedMatch () : Promise<void> {
    const medlemLicensNo = (this as any).selectedPlayersLastMatchData?.playerName.match(/\d+/)
    const saesonId = (this as any).selectedPlayersLastMatchData.matchId.saeson_id

    let matchHistoryExtraParameter = ''
    matchHistoryExtraParameter += (saesonId ? `raekke_id.saeson_id=${saesonId}` : '')
    matchHistoryExtraParameter += (medlemLicensNo ? `&medlem_id.medlem_licens=${medlemLicensNo && medlemLicensNo[0]}` : '')
    const matchHistoryPromise = MatchHistoryDataService.asyncGetAll('createdAt:asc', null, `${matchHistoryExtraParameter}`)

    await Promise.all([matchHistoryPromise])
      .then((response) => {
        let historyData = response[0].data
        // historyData.sort((a: any, b: any) => (new Date(a.created_at) > new Date(b.created_at) ? -1 : 1))
        historyData = historyData.filter((match: any) => {
          if (match.kampafvikling_id.kampprogram_id !== (this as any).selectedPlayersLastMatchData.matchId.id) {
            return match
          }
        })
        let matchHistoryParam = ''
        for (const data of historyData) {
          matchHistoryParam += '&id=' + data.kampafvikling_id?.kampprogram_id.toString()
        }
        if (historyData.length > 0) {
          this.matchHistoryData = historyData
        } else {
          this.matchHistoryData = null
        }
        this.getLastplayedMatches(matchHistoryParam)
      })
      .catch((error) => {
        console.log('ERROR', error)
      })
  }

  public async getLastplayedMatches (matchID: any): Promise<void> {
    if (matchID !== '') {
      const reportedMatchDateParams = (this as any).selectedPlayersLastMatchData.matchId.kampprogram_dato
      const lastPlayedMatchesPromise = await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('kampprogram_dato:desc', null, `kampprogram_dato_lt=${reportedMatchDateParams}${matchID}`)
      await Promise.all([lastPlayedMatchesPromise])
        .then((response) => {
          const lastPlayedMatches = response[0].data
          if (lastPlayedMatches.length > 0) {
            this.lastPlayedMatch = lastPlayedMatches[0]
          } else {
            this.lastPlayedMatch = null
          }
          this.setNextPlannedMatch()
        })
        .catch((error) => {
          console.log('lastPlayedMatches_Error', error)
        })
    }
  }

  public async setNextPlannedMatch () : Promise<void> {
    if (this.lastPlayedMatch) {
      const extraParams = `raekke_id.id=${(this as any).lastPlayedMatch.raekke_id.id}&_where[_or][0][kampprogram_hjemmehold.id]=${(this as any).lastPlayedMatch.kampprogram_hjemmehold.id}&_where[_or][1][kampprogram_hjemmehold.id]=${(this as any).lastPlayedMatch.kampprogram_udehold.id}&_where[_or][2][kampprogram_udehold.id]=${(this as any).lastPlayedMatch.kampprogram_udehold.id}&_where[_or][3][kampprogram_udehold.id]=${(this as any).lastPlayedMatch.kampprogram_hjemmehold.id}&[kampprogram_dato_gte]=${(this as any).selectedPlayersLastMatchData.matchId.kampprogram_dato}`
      const nextPlaanedMatchesPromise = await Tournaments.TournamentMatchSchedulesDataService.asyncGetAll('kampprogram_dato:asc', null, `${extraParams}`)
      await Promise.all([nextPlaanedMatchesPromise])
        .then((response) => {
          const nextPlannedMatches = response[0].data
          for (let i = 0; i < nextPlannedMatches.length; i++) {
            if (nextPlannedMatches[i].kampprogram_dato === (this as any).selectedPlayersLastMatchData.matchId.kampprogram_dato) {
              const spliced = nextPlannedMatches.splice(i, 1)
            }
          }
          if (nextPlannedMatches.length > 0) {
            this.nextPlannedMatch = nextPlannedMatches[0]
          } else {
            this.nextPlannedMatch = null
          }
        })
        .catch((error) => {
          console.log('nextPlaanedMatchesError', error)
        })
    }
  }

  public addPlayerHistoryComment () : void {
    const id = (this as any).selectedPlayersLastMatchData?.id
    History.ValidatedPlayersHistoriesDataService.update(id, { comment: this.playerHistoryComment })
      .then((response) => {
        this.$Message.success({ text: 'Comment Added' })
        this.selectedPlayersLastMatchData = response.data
        this.filteredPlayersHistoriesData = response.data
        this.playerHistoryComment = ''
      })
      .catch((error) => {
        console.log('ERROR', error)
        this.$Message.danger({ text: 'Fejl: Comment' })
      })
  }

  public confirmToUpdateSatatus (event: any, player: any) : void {
    event.stopPropagation()
    this.selectedPlayersLastMatchData = player
    this.confirmationModal = true
  }

  public updateSatatus () : void {
    const id = (this as any).selectedPlayersLastMatchData?.id
    const status = ((this as any).selectedPlayersLastMatchData?.status === null || (this as any).selectedPlayersLastMatchData?.status === 'Waiting') ? 'Open' : 'Closed'
    History.ValidatedPlayersHistoriesDataService.update(id, { status: status })
      .then((response) => {
        this.filteredPlayersHistoriesData = response.data
        this.$Message.success({ text: 'Status Updated' })
        this.confirmationModal = false
        this.selectedPlayersLastMatchData = null
      })
      .catch((error) => {
        console.log('ERROR', error)
        this.$Message.danger({ text: 'Fejl: Update' })
      })
  }

  @Watch('filterPlayerValidationHistoryBasedOnStatus')
  onFilterPlayerValidationHistoryBasedOnStatusChange () : void {
    if (this.filterPlayerValidationHistoryBasedOnStatus === 'Closed') {
      this.isStatusClosed = true
      this.retrievePlayersValidationHistory()
    } else {
      this.isStatusClosed = false
      this.retrievePlayersValidationHistory()
    }
  }

  set filteredPlayersHistoriesData (data: any) {
    const indexOfUpdatedData = this.playersHistories.findIndex((item: any) => {
      return item.id === data.id
    })
    this.playersHistories[indexOfUpdatedData] = data
  }

  get filteredPlayersHistoriesData () {
    if (this.filterPlayerValidationHistoryBasedOnStatus === 'Waiting') {
      this.playersHistoriesData = this.playersHistories.filter((item: any) => {
        if (item.status === 'Waiting' || item.status === null) {
          return item
        }
      })
    } else if (this.filterPlayerValidationHistoryBasedOnStatus === 'Open') {
      this.playersHistoriesData = this.playersHistories.filter((item: any) => {
        if (item.status === 'Open') {
          return item
        }
      })
    } else if (this.filterPlayerValidationHistoryBasedOnStatus === 'Closed') {
      this.playersHistoriesData = this.playersHistories.filter((item: any) => {
        if (item.status === 'Closed') {
          return item
        }
      })
    } else {
      // Hide data if status is Closed
      this.playersHistoriesData = this.playersHistories.filter((item: any) => {
        if (item.status !== 'Closed') {
          return item
        }
      })
    }

    if (this.filterPlayerValidationHistoryValue === 'Hjem') {
      this.playersHistoriesData = this.playersHistoriesData.filter((item: any) => {
        if (item.team === 'home') {
          return item
        }
      })
    } else if (this.filterPlayerValidationHistoryValue === 'Ude') {
      this.playersHistoriesData = this.playersHistoriesData.filter((item: any) => {
        if (item.team === 'away') {
          return item
        }
      })
    } else {
      return this.playersHistoriesData
    }
    return this.playersHistoriesData
  }

  public setOrderOfPlayerHistory () {
    if (this.isSortingAscending) {
      this.currentPlayerMatchHistorySort = 'created_at:desc'
      this.isSortingAscending = false
    } else {
      this.currentPlayerMatchHistorySort = 'created_at:asc'
      this.isSortingAscending = true
    }
    this.retrievePlayersValidationHistory()
  }

  @Watch('tempTournamentMatchSchedule')
  onTempTournamentMatchScheduleChange (): void {
    this.getTeamsCaptains()
  }

  public async getTeamsCaptains (): Promise<void> {
    if (Object.keys(this.tempTournamentMatchSchedule).length > 0 && ((this as any).tempTournamentMatchSchedule.awayTeamCaptain && (this as any).tempTournamentMatchSchedule.homeTeamCaptain)) {
      const captainParams = `&id=${(this as any).tempTournamentMatchSchedule.awayTeamCaptain}&id=${(this as any).tempTournamentMatchSchedule.homeTeamCaptain}`
      const userDataPromise = UsersDataService.getAll('', null, captainParams)
      await Promise.all([userDataPromise])
        .then((res) => {
          const responseData = res[0].data
          responseData.map((data: any) => {
            if (data.id === (this as any).tempTournamentMatchSchedule.homeTeamCaptain) {
              this.teamCaptain.homeTeamCaptain = data
            } else {
              this.teamCaptain.awayTeamCaptain = data
            }
          })
        })
        .catch((err) => {
          console.log('getTeamsCaptains_Error', err)
          this.teamCaptain = { awayTeamCaptain: null, homeTeamCaptain: null }
        })
    }
  }

  async mounted () : Promise<void> {
    const loggedInStatus = localStorage.getItem('status')
    const loginType = localStorage.getItem('logintype')
    const apiToken = localStorage.getItem('apitoken')
    const userdata = localStorage.getItem('user')

    if (loggedInStatus !== undefined && loggedInStatus !== null && loggedInStatus === true.toString() && loginType !== undefined && loginType !== null && loginType === true.toString() && apiToken !== undefined && apiToken !== null && apiToken.length >= 100 && userdata !== undefined && userdata !== null && !userdata.startsWith('{"id":1,')) {
      const userString = localStorage.getItem('user')?.toString()
      const userDataObject = (userString !== undefined && userString !== null ? JSON.parse(userString) : null)

      if (userDataObject !== null && userDataObject.id !== 1 && userDataObject.id < 100 && userDataObject.role !== undefined && userDataObject.role !== null && userDataObject.role.type === 'superadmin') {
        const extraParams = this.isStatusClosed ? 'filters[status][$eq]=closed' : 'filters[status][$ne]=closed'
        History.ValidatedPlayersHistoriesDataService.getCount(extraParams)
          .then((response) => {
            this.totalHistoryPages = response.data
            this.totalNumberOfHistoryPages = Math.ceil(this.totalHistoryPages / this.historyPageSizeValue)
          })
          .catch((err) => {
            this.error = err
          })
        this.retrieveTournamentCategories()
        this.retrieveTournamentAllCategories()
        this.retrieveTournamentRows()
        this.retrieveTournamentMatchSchedule()
        this.retrieveTournamentRules()
        this.retrieveCategoriesForRules()
        this.retrieveRegionsForRule()
        // this.getSeasonOptionsData()
        this.retrieveTeamsOverview()
        this.validatePlayerHistory()
      } else {
        CommonFunctions.redirectLogin()
      }
    } else {
      CommonFunctions.redirectLogin()
    }
  }

  beforeDestroy () : void {
    clearInterval(this.matchSettlementMatchesSetsUpdateIntervalTimer)
  }
}
